var map = {
	"./archive-box-open-docs/Size=16, Style=light.svg": "b64c",
	"./archive-box-open-docs/Size=16, Style=regular.svg": "50fa",
	"./archive-box-open-docs/Size=16, Style=solid.svg": "0a29",
	"./archive-box-open-docs/Size=20, Style=light.svg": "f756",
	"./archive-box-open-docs/Size=20, Style=regular.svg": "dad5",
	"./archive-box-open-docs/Size=20, Style=solid.svg": "3125",
	"./archive-box-open-docs/Size=24, Style=regular.svg": "9215",
	"./archive-box-open-docs/Size=24, Style=solid.svg": "c7c7",
	"./archive-box-open-docs/Size=32, Style=regular.svg": "d817",
	"./archive-box-open-docs/Size=64, Style=regular.svg": "63b3",
	"./archive-box/Size=16, Style=light.svg": "1a7f",
	"./archive-box/Size=16, Style=regular.svg": "cb7c",
	"./archive-box/Size=16, Style=solid.svg": "ef0c",
	"./archive-box/Size=20, Style=light.svg": "fdac",
	"./archive-box/Size=20, Style=regular.svg": "30fb",
	"./archive-box/Size=20, Style=solid.svg": "3a02",
	"./archive-box/Size=24, Style=regular.svg": "331a",
	"./archive-box/Size=24, Style=solid.svg": "fb63",
	"./archive-box/Size=32, Style=regular.svg": "3626",
	"./archive-box/Size=64, Style=regular.svg": "1195",
	"./archive-cabinet/Size=16, Style=light.svg": "b245",
	"./archive-cabinet/Size=16, Style=regular.svg": "6671",
	"./archive-cabinet/Size=16, Style=solid.svg": "fe15",
	"./archive-cabinet/Size=20, Style=light.svg": "e60f",
	"./archive-cabinet/Size=20, Style=regular.svg": "39b6",
	"./archive-cabinet/Size=20, Style=solid.svg": "7093",
	"./archive-cabinet/Size=24, Style=regular.svg": "2492",
	"./archive-cabinet/Size=24, Style=solid.svg": "bf29",
	"./archive-cabinet/Size=32, Style=regular.svg": "b5ff",
	"./archive-cabinet/Size=64, Style=regular.svg": "bb8b",
	"./arrow-a-down-left/Size=16, Style=light.svg": "0d98",
	"./arrow-a-down-left/Size=16, Style=regular.svg": "f01f",
	"./arrow-a-down-left/Size=16, Style=solid.svg": "09e9",
	"./arrow-a-down-left/Size=20, Style=light.svg": "60f3",
	"./arrow-a-down-left/Size=20, Style=regular.svg": "8e8f",
	"./arrow-a-down-left/Size=20, Style=solid.svg": "1625",
	"./arrow-a-down-left/Size=24, Style=regular.svg": "53fc",
	"./arrow-a-down-left/Size=24, Style=solid.svg": "42bf",
	"./arrow-a-down-left/Size=32, Style=regular.svg": "0e94",
	"./arrow-a-down-left/Size=64, Style=regular.svg": "e62e",
	"./arrow-a-down-right/Size=16, Style=light.svg": "e54f",
	"./arrow-a-down-right/Size=16, Style=regular.svg": "02b3",
	"./arrow-a-down-right/Size=16, Style=solid.svg": "433b",
	"./arrow-a-down-right/Size=20, Style=light.svg": "732d",
	"./arrow-a-down-right/Size=20, Style=regular.svg": "4725",
	"./arrow-a-down-right/Size=20, Style=solid.svg": "1fce",
	"./arrow-a-down-right/Size=24, Style=regular.svg": "2b0c",
	"./arrow-a-down-right/Size=24, Style=solid.svg": "9359",
	"./arrow-a-down-right/Size=32, Style=regular.svg": "d6f8",
	"./arrow-a-down-right/Size=64, Style=regular.svg": "8b76",
	"./arrow-a-down/Size=16, Style=light.svg": "97d8",
	"./arrow-a-down/Size=16, Style=regular.svg": "fb08",
	"./arrow-a-down/Size=16, Style=solid.svg": "2388",
	"./arrow-a-down/Size=20, Style=light.svg": "d21c",
	"./arrow-a-down/Size=20, Style=regular.svg": "146b",
	"./arrow-a-down/Size=20, Style=solid.svg": "df06",
	"./arrow-a-down/Size=24, Style=regular.svg": "5770",
	"./arrow-a-down/Size=24, Style=solid.svg": "0958",
	"./arrow-a-down/Size=32, Style=regular.svg": "4fe6",
	"./arrow-a-down/Size=64, Style=regular.svg": "d331",
	"./arrow-a-left/Size=16, Style=light.svg": "b5cd",
	"./arrow-a-left/Size=16, Style=regular.svg": "66c5",
	"./arrow-a-left/Size=16, Style=solid.svg": "29a6",
	"./arrow-a-left/Size=20, Style=light.svg": "b2455",
	"./arrow-a-left/Size=20, Style=regular.svg": "7427",
	"./arrow-a-left/Size=20, Style=solid.svg": "99e2",
	"./arrow-a-left/Size=24, Style=regular.svg": "afc8",
	"./arrow-a-left/Size=24, Style=solid.svg": "b463",
	"./arrow-a-left/Size=32, Style=regular.svg": "cf12",
	"./arrow-a-left/Size=64, Style=regular.svg": "1cc0",
	"./arrow-a-right/Size=16, Style=light.svg": "2016",
	"./arrow-a-right/Size=16, Style=regular.svg": "5104",
	"./arrow-a-right/Size=16, Style=solid.svg": "2b3f",
	"./arrow-a-right/Size=20, Style=light.svg": "f27a",
	"./arrow-a-right/Size=20, Style=regular.svg": "add4",
	"./arrow-a-right/Size=20, Style=solid.svg": "e946",
	"./arrow-a-right/Size=24, Style=regular.svg": "78a9",
	"./arrow-a-right/Size=24, Style=solid.svg": "e082",
	"./arrow-a-right/Size=32, Style=regular.svg": "1219",
	"./arrow-a-right/Size=64, Style=regular.svg": "ad90",
	"./arrow-a-up-left/Size=16, Style=light.svg": "f0e0",
	"./arrow-a-up-left/Size=16, Style=regular.svg": "d90f",
	"./arrow-a-up-left/Size=16, Style=solid.svg": "722c",
	"./arrow-a-up-left/Size=20, Style=light.svg": "b57a",
	"./arrow-a-up-left/Size=20, Style=regular.svg": "cc80",
	"./arrow-a-up-left/Size=20, Style=solid.svg": "f9f9",
	"./arrow-a-up-left/Size=24, Style=regular.svg": "c941",
	"./arrow-a-up-left/Size=24, Style=solid.svg": "e71f",
	"./arrow-a-up-left/Size=32, Style=regular.svg": "5d25",
	"./arrow-a-up-left/Size=64, Style=regular.svg": "ca9d",
	"./arrow-a-up-right/Size=16, Style=light.svg": "6eb4",
	"./arrow-a-up-right/Size=16, Style=regular.svg": "1c7a",
	"./arrow-a-up-right/Size=16, Style=solid.svg": "ab3b",
	"./arrow-a-up-right/Size=20, Style=light.svg": "3429",
	"./arrow-a-up-right/Size=20, Style=regular.svg": "3597",
	"./arrow-a-up-right/Size=20, Style=solid.svg": "fa21",
	"./arrow-a-up-right/Size=24, Style=regular.svg": "1fb3",
	"./arrow-a-up-right/Size=24, Style=solid.svg": "97db",
	"./arrow-a-up-right/Size=32, Style=regular.svg": "93d4",
	"./arrow-a-up-right/Size=64, Style=regular.svg": "c922",
	"./arrow-a-up/Size=16, Style=light.svg": "82d3",
	"./arrow-a-up/Size=16, Style=regular.svg": "9f65",
	"./arrow-a-up/Size=16, Style=solid.svg": "3e50",
	"./arrow-a-up/Size=20, Style=light.svg": "55d1",
	"./arrow-a-up/Size=20, Style=regular.svg": "fc7e",
	"./arrow-a-up/Size=20, Style=solid.svg": "9be4",
	"./arrow-a-up/Size=24, Style=regular.svg": "cca0",
	"./arrow-a-up/Size=24, Style=solid.svg": "e04b",
	"./arrow-a-up/Size=32, Style=regular.svg": "8b06",
	"./arrow-a-up/Size=64, Style=regular.svg": "f231",
	"./arrow-c-down/Size=16, Style=light.svg": "85d4",
	"./arrow-c-down/Size=16, Style=regular.svg": "ba2a",
	"./arrow-c-down/Size=16, Style=solid.svg": "79a7",
	"./arrow-c-down/Size=20, Style=light.svg": "d5b0",
	"./arrow-c-down/Size=20, Style=regular.svg": "3980",
	"./arrow-c-down/Size=20, Style=solid.svg": "e5d5",
	"./arrow-c-down/Size=24, Style=regular.svg": "6a2a",
	"./arrow-c-down/Size=24, Style=solid.svg": "02de",
	"./arrow-c-down/Size=32, Style=regular.svg": "5baa",
	"./arrow-c-down/Size=64, Style=regular.svg": "66bb",
	"./arrow-c-left/Size=16, Style=light.svg": "2f629",
	"./arrow-c-left/Size=16, Style=regular.svg": "96e0",
	"./arrow-c-left/Size=16, Style=solid.svg": "6126",
	"./arrow-c-left/Size=20, Style=light.svg": "7572",
	"./arrow-c-left/Size=20, Style=regular.svg": "e616",
	"./arrow-c-left/Size=20, Style=solid.svg": "dd6f",
	"./arrow-c-left/Size=24, Style=regular.svg": "c16f",
	"./arrow-c-left/Size=24, Style=solid.svg": "dce8",
	"./arrow-c-left/Size=32, Style=regular.svg": "f55d",
	"./arrow-c-left/Size=64, Style=regular.svg": "e266",
	"./arrow-c-right/Size=16, Style=light.svg": "d8e8",
	"./arrow-c-right/Size=16, Style=regular.svg": "4d76",
	"./arrow-c-right/Size=16, Style=solid.svg": "49b6",
	"./arrow-c-right/Size=20, Style=light.svg": "478e",
	"./arrow-c-right/Size=20, Style=regular.svg": "ae3d",
	"./arrow-c-right/Size=20, Style=solid.svg": "7726",
	"./arrow-c-right/Size=24, Style=regular.svg": "657d",
	"./arrow-c-right/Size=24, Style=solid.svg": "6330",
	"./arrow-c-right/Size=32, Style=regular.svg": "0b7a",
	"./arrow-c-right/Size=64, Style=regular.svg": "ba8f",
	"./arrow-c-up/Size=16, Style=light.svg": "9b77",
	"./arrow-c-up/Size=16, Style=regular.svg": "7684",
	"./arrow-c-up/Size=16, Style=solid.svg": "d757",
	"./arrow-c-up/Size=20, Style=light.svg": "bcbb",
	"./arrow-c-up/Size=20, Style=regular.svg": "af43",
	"./arrow-c-up/Size=20, Style=solid.svg": "db4c",
	"./arrow-c-up/Size=24, Style=regular.svg": "a661",
	"./arrow-c-up/Size=24, Style=solid.svg": "f902",
	"./arrow-c-up/Size=32, Style=regular.svg": "0cdb",
	"./arrow-c-up/Size=64, Style=regular.svg": "5eeb",
	"./arrow-collapse-c-h-closed/Size=16, Style=light.svg": "d9d1",
	"./arrow-collapse-c-h-closed/Size=16, Style=regular.svg": "7ace",
	"./arrow-collapse-c-h-closed/Size=16, Style=solid.svg": "07f7",
	"./arrow-collapse-c-h-closed/Size=20, Style=light.svg": "ec83",
	"./arrow-collapse-c-h-closed/Size=20, Style=regular.svg": "b7c3",
	"./arrow-collapse-c-h-closed/Size=20, Style=solid.svg": "f2f3",
	"./arrow-collapse-c-h-closed/Size=24, Style=regular.svg": "5f60",
	"./arrow-collapse-c-h-closed/Size=24, Style=solid.svg": "176f",
	"./arrow-collapse-c-h-closed/Size=32, Style=regular.svg": "9280",
	"./arrow-collapse-c-h-closed/Size=64, Style=regular.svg": "9423",
	"./arrow-collapse-c-h-open/Size=16, Style=light.svg": "21a63",
	"./arrow-collapse-c-h-open/Size=16, Style=regular.svg": "3a64",
	"./arrow-collapse-c-h-open/Size=16, Style=solid.svg": "f3c7",
	"./arrow-collapse-c-h-open/Size=20, Style=light.svg": "1e8e",
	"./arrow-collapse-c-h-open/Size=20, Style=regular.svg": "fffe",
	"./arrow-collapse-c-h-open/Size=20, Style=solid.svg": "0f3e",
	"./arrow-collapse-c-h-open/Size=24, Style=regular.svg": "73d7",
	"./arrow-collapse-c-h-open/Size=24, Style=solid.svg": "1379",
	"./arrow-collapse-c-h-open/Size=32, Style=regular.svg": "4a3d",
	"./arrow-collapse-c-h-open/Size=64, Style=regular.svg": "13f3",
	"./arrow-collapse-c-v-closed/Size=16, Style=light.svg": "da05",
	"./arrow-collapse-c-v-closed/Size=16, Style=regular.svg": "da50",
	"./arrow-collapse-c-v-closed/Size=16, Style=solid.svg": "04e0",
	"./arrow-collapse-c-v-closed/Size=20, Style=light.svg": "096f",
	"./arrow-collapse-c-v-closed/Size=20, Style=regular.svg": "36f9",
	"./arrow-collapse-c-v-closed/Size=20, Style=solid.svg": "ebc6",
	"./arrow-collapse-c-v-closed/Size=24, Style=regular.svg": "9aa4",
	"./arrow-collapse-c-v-closed/Size=24, Style=solid.svg": "29b9",
	"./arrow-collapse-c-v-closed/Size=32, Style=regular.svg": "83c3",
	"./arrow-collapse-c-v-closed/Size=64, Style=regular.svg": "8569",
	"./arrow-collapse-c-v-open/Size=16, Style=light.svg": "ebdb",
	"./arrow-collapse-c-v-open/Size=16, Style=regular.svg": "1b0a",
	"./arrow-collapse-c-v-open/Size=16, Style=solid.svg": "e292",
	"./arrow-collapse-c-v-open/Size=20, Style=light.svg": "0435",
	"./arrow-collapse-c-v-open/Size=20, Style=regular.svg": "85de",
	"./arrow-collapse-c-v-open/Size=20, Style=solid.svg": "ec36",
	"./arrow-collapse-c-v-open/Size=24, Style=regular.svg": "d504",
	"./arrow-collapse-c-v-open/Size=24, Style=solid.svg": "bd7d",
	"./arrow-collapse-c-v-open/Size=32, Style=regular.svg": "e6b7",
	"./arrow-collapse-c-v-open/Size=64, Style=regular.svg": "eb28",
	"./arrow-collapse-triangles-h-closed/Size=16, Style=light.svg": "9204",
	"./arrow-collapse-triangles-h-closed/Size=16, Style=regular.svg": "9937",
	"./arrow-collapse-triangles-h-closed/Size=16, Style=solid.svg": "3fd6",
	"./arrow-collapse-triangles-h-closed/Size=20, Style=light.svg": "b436",
	"./arrow-collapse-triangles-h-closed/Size=20, Style=regular.svg": "0cd9",
	"./arrow-collapse-triangles-h-closed/Size=20, Style=solid.svg": "e08e",
	"./arrow-collapse-triangles-h-closed/Size=24, Style=regular.svg": "36e2",
	"./arrow-collapse-triangles-h-closed/Size=24, Style=solid.svg": "afbe",
	"./arrow-collapse-triangles-h-closed/Size=32, Style=regular.svg": "b3e0",
	"./arrow-collapse-triangles-h-closed/Size=64, Style=regular.svg": "a0e5",
	"./arrow-collapse-triangles-h-open/Size=16, Style=light.svg": "759e",
	"./arrow-collapse-triangles-h-open/Size=16, Style=regular.svg": "b6b8",
	"./arrow-collapse-triangles-h-open/Size=16, Style=solid.svg": "506f",
	"./arrow-collapse-triangles-h-open/Size=20, Style=light.svg": "c104",
	"./arrow-collapse-triangles-h-open/Size=20, Style=regular.svg": "c9cb",
	"./arrow-collapse-triangles-h-open/Size=20, Style=solid.svg": "96ba",
	"./arrow-collapse-triangles-h-open/Size=24, Style=regular.svg": "d5a5",
	"./arrow-collapse-triangles-h-open/Size=24, Style=solid.svg": "3cf0",
	"./arrow-collapse-triangles-h-open/Size=32, Style=regular.svg": "c398",
	"./arrow-collapse-triangles-h-open/Size=64, Style=regular.svg": "5213",
	"./arrow-collapse-triangles-v-closed/Size=16, Style=light.svg": "16f3",
	"./arrow-collapse-triangles-v-closed/Size=16, Style=regular.svg": "6277",
	"./arrow-collapse-triangles-v-closed/Size=16, Style=solid.svg": "685f",
	"./arrow-collapse-triangles-v-closed/Size=20, Style=light.svg": "58f4",
	"./arrow-collapse-triangles-v-closed/Size=20, Style=regular.svg": "aa9e",
	"./arrow-collapse-triangles-v-closed/Size=20, Style=solid.svg": "da74",
	"./arrow-collapse-triangles-v-closed/Size=24, Style=regular.svg": "224f",
	"./arrow-collapse-triangles-v-closed/Size=24, Style=solid.svg": "63ae",
	"./arrow-collapse-triangles-v-closed/Size=32, Style=regular.svg": "3a13",
	"./arrow-collapse-triangles-v-closed/Size=64, Style=regular.svg": "0d81",
	"./arrow-collapse-triangles-v-open/Size=16, Style=light.svg": "94dd",
	"./arrow-collapse-triangles-v-open/Size=16, Style=regular.svg": "f07c",
	"./arrow-collapse-triangles-v-open/Size=16, Style=solid.svg": "2dbe",
	"./arrow-collapse-triangles-v-open/Size=20, Style=light.svg": "4c14",
	"./arrow-collapse-triangles-v-open/Size=20, Style=regular.svg": "4031",
	"./arrow-collapse-triangles-v-open/Size=20, Style=solid.svg": "4826",
	"./arrow-collapse-triangles-v-open/Size=24, Style=regular.svg": "8a8a",
	"./arrow-collapse-triangles-v-open/Size=24, Style=solid.svg": "fab0",
	"./arrow-collapse-triangles-v-open/Size=32, Style=regular.svg": "727f",
	"./arrow-collapse-triangles-v-open/Size=64, Style=regular.svg": "7892",
	"./arrow-figure-a-circle-down/Size=16, Style=light.svg": "efed",
	"./arrow-figure-a-circle-down/Size=16, Style=regular.svg": "01ed",
	"./arrow-figure-a-circle-down/Size=16, Style=solid.svg": "6f53b",
	"./arrow-figure-a-circle-down/Size=20, Style=light.svg": "ff29",
	"./arrow-figure-a-circle-down/Size=20, Style=regular.svg": "312d",
	"./arrow-figure-a-circle-down/Size=20, Style=solid.svg": "0e22",
	"./arrow-figure-a-circle-down/Size=24, Style=regular.svg": "c54d",
	"./arrow-figure-a-circle-down/Size=24, Style=solid.svg": "ecd6",
	"./arrow-figure-a-circle-down/Size=32, Style=regular.svg": "f8a5",
	"./arrow-figure-a-circle-down/Size=64, Style=regular.svg": "e0eb",
	"./arrow-figure-a-circle-left/Size=16, Style=light.svg": "3d9f",
	"./arrow-figure-a-circle-left/Size=16, Style=regular.svg": "87df",
	"./arrow-figure-a-circle-left/Size=16, Style=solid.svg": "1746",
	"./arrow-figure-a-circle-left/Size=20, Style=light.svg": "73f7",
	"./arrow-figure-a-circle-left/Size=20, Style=regular.svg": "b33d",
	"./arrow-figure-a-circle-left/Size=20, Style=solid.svg": "21b3",
	"./arrow-figure-a-circle-left/Size=24, Style=regular.svg": "487c",
	"./arrow-figure-a-circle-left/Size=24, Style=solid.svg": "77bc",
	"./arrow-figure-a-circle-left/Size=32, Style=regular.svg": "86c8",
	"./arrow-figure-a-circle-left/Size=64, Style=regular.svg": "b06c",
	"./arrow-figure-a-circle-right/Size=16, Style=light.svg": "8504",
	"./arrow-figure-a-circle-right/Size=16, Style=regular.svg": "c460",
	"./arrow-figure-a-circle-right/Size=16, Style=solid.svg": "6cba",
	"./arrow-figure-a-circle-right/Size=20, Style=light.svg": "c643",
	"./arrow-figure-a-circle-right/Size=20, Style=regular.svg": "56e3",
	"./arrow-figure-a-circle-right/Size=20, Style=solid.svg": "5b02",
	"./arrow-figure-a-circle-right/Size=24, Style=regular.svg": "0c85",
	"./arrow-figure-a-circle-right/Size=24, Style=solid.svg": "163b",
	"./arrow-figure-a-circle-right/Size=32, Style=regular.svg": "f9a7",
	"./arrow-figure-a-circle-right/Size=64, Style=regular.svg": "037b",
	"./arrow-figure-a-circle-up/Size=16, Style=light.svg": "6b64",
	"./arrow-figure-a-circle-up/Size=16, Style=regular.svg": "02fd",
	"./arrow-figure-a-circle-up/Size=16, Style=solid.svg": "e981",
	"./arrow-figure-a-circle-up/Size=20, Style=light.svg": "89cd",
	"./arrow-figure-a-circle-up/Size=20, Style=regular.svg": "2573",
	"./arrow-figure-a-circle-up/Size=20, Style=solid.svg": "30ef",
	"./arrow-figure-a-circle-up/Size=24, Style=regular.svg": "ffb4",
	"./arrow-figure-a-circle-up/Size=24, Style=solid.svg": "f8b3",
	"./arrow-figure-a-circle-up/Size=32, Style=regular.svg": "1007",
	"./arrow-figure-a-circle-up/Size=64, Style=regular.svg": "5569",
	"./arrow-figure-a-square-down/Size=16, Style=light.svg": "d3ed",
	"./arrow-figure-a-square-down/Size=16, Style=regular.svg": "33c0",
	"./arrow-figure-a-square-down/Size=16, Style=solid.svg": "900b",
	"./arrow-figure-a-square-down/Size=20, Style=light.svg": "410a",
	"./arrow-figure-a-square-down/Size=20, Style=regular.svg": "326f",
	"./arrow-figure-a-square-down/Size=20, Style=solid.svg": "c2f5",
	"./arrow-figure-a-square-down/Size=24, Style=regular.svg": "5c92",
	"./arrow-figure-a-square-down/Size=24, Style=solid.svg": "206f",
	"./arrow-figure-a-square-down/Size=32, Style=regular.svg": "90d2",
	"./arrow-figure-a-square-down/Size=64, Style=regular.svg": "c1e2",
	"./arrow-figure-a-square-left/Size=16, Style=light.svg": "cc68",
	"./arrow-figure-a-square-left/Size=16, Style=regular.svg": "7b69",
	"./arrow-figure-a-square-left/Size=16, Style=solid.svg": "201d",
	"./arrow-figure-a-square-left/Size=20, Style=light.svg": "bc30",
	"./arrow-figure-a-square-left/Size=20, Style=regular.svg": "94c6",
	"./arrow-figure-a-square-left/Size=20, Style=solid.svg": "b830",
	"./arrow-figure-a-square-left/Size=24, Style=regular.svg": "fac0",
	"./arrow-figure-a-square-left/Size=24, Style=solid.svg": "9c24",
	"./arrow-figure-a-square-left/Size=32, Style=regular.svg": "1ef2",
	"./arrow-figure-a-square-left/Size=64, Style=regular.svg": "0649",
	"./arrow-figure-a-square-right/Size=16, Style=light.svg": "c27d",
	"./arrow-figure-a-square-right/Size=16, Style=regular.svg": "6e0f",
	"./arrow-figure-a-square-right/Size=16, Style=solid.svg": "b2c7",
	"./arrow-figure-a-square-right/Size=20, Style=light.svg": "8494",
	"./arrow-figure-a-square-right/Size=20, Style=regular.svg": "5efb",
	"./arrow-figure-a-square-right/Size=20, Style=solid.svg": "96ef",
	"./arrow-figure-a-square-right/Size=24, Style=regular.svg": "63bd",
	"./arrow-figure-a-square-right/Size=24, Style=solid.svg": "f275",
	"./arrow-figure-a-square-right/Size=32, Style=regular.svg": "a03a",
	"./arrow-figure-a-square-right/Size=64, Style=regular.svg": "d00f",
	"./arrow-figure-a-square-up/Size=16, Style=light.svg": "ffdd",
	"./arrow-figure-a-square-up/Size=16, Style=regular.svg": "4301",
	"./arrow-figure-a-square-up/Size=16, Style=solid.svg": "e3f6",
	"./arrow-figure-a-square-up/Size=20, Style=light.svg": "ef28",
	"./arrow-figure-a-square-up/Size=20, Style=regular.svg": "906b",
	"./arrow-figure-a-square-up/Size=20, Style=solid.svg": "10dd",
	"./arrow-figure-a-square-up/Size=24, Style=regular.svg": "16264",
	"./arrow-figure-a-square-up/Size=24, Style=solid.svg": "0ab0",
	"./arrow-figure-a-square-up/Size=32, Style=regular.svg": "4921",
	"./arrow-figure-a-square-up/Size=64, Style=regular.svg": "4ad7",
	"./arrow-parallel-h/Size=16, Style=light.svg": "9f78",
	"./arrow-parallel-h/Size=16, Style=regular.svg": "a616",
	"./arrow-parallel-h/Size=16, Style=solid.svg": "d827",
	"./arrow-parallel-h/Size=20, Style=light.svg": "5d4f",
	"./arrow-parallel-h/Size=20, Style=regular.svg": "6e7b",
	"./arrow-parallel-h/Size=20, Style=solid.svg": "353a",
	"./arrow-parallel-h/Size=24, Style=regular.svg": "b81d",
	"./arrow-parallel-h/Size=24, Style=solid.svg": "a7fc",
	"./arrow-parallel-h/Size=32, Style=regular.svg": "85c6",
	"./arrow-parallel-h/Size=64, Style=regular.svg": "1792",
	"./arrow-parallel-v/Size=16, Style=light.svg": "14ed",
	"./arrow-parallel-v/Size=16, Style=regular.svg": "ec4e",
	"./arrow-parallel-v/Size=16, Style=solid.svg": "59dd",
	"./arrow-parallel-v/Size=20, Style=light.svg": "0ddd",
	"./arrow-parallel-v/Size=20, Style=regular.svg": "4fa9",
	"./arrow-parallel-v/Size=20, Style=solid.svg": "d4be",
	"./arrow-parallel-v/Size=24, Style=regular.svg": "a0c8",
	"./arrow-parallel-v/Size=24, Style=solid.svg": "3857",
	"./arrow-parallel-v/Size=32, Style=regular.svg": "171a",
	"./arrow-parallel-v/Size=64, Style=regular.svg": "917b",
	"./arrow-round-sync-forward/Size=16, Style=light.svg": "7669",
	"./arrow-round-sync-forward/Size=16, Style=regular.svg": "6be3",
	"./arrow-round-sync-forward/Size=16, Style=solid.svg": "70bc",
	"./arrow-round-sync-forward/Size=20, Style=light.svg": "69f8",
	"./arrow-round-sync-forward/Size=20, Style=regular.svg": "4578",
	"./arrow-round-sync-forward/Size=20, Style=solid.svg": "bc06",
	"./arrow-round-sync-forward/Size=24, Style=regular.svg": "fc79",
	"./arrow-round-sync-forward/Size=24, Style=solid.svg": "b766",
	"./arrow-round-sync-forward/Size=32, Style=regular.svg": "2e9a",
	"./arrow-round-sync-forward/Size=64, Style=regular.svg": "738a",
	"./arrow-round-time-back/Size=16, Style=light.svg": "9e82",
	"./arrow-round-time-back/Size=16, Style=regular.svg": "6adb",
	"./arrow-round-time-back/Size=16, Style=solid.svg": "4a86",
	"./arrow-round-time-back/Size=20, Style=light.svg": "5ca6",
	"./arrow-round-time-back/Size=20, Style=regular.svg": "5d8b",
	"./arrow-round-time-back/Size=20, Style=solid.svg": "026a",
	"./arrow-round-time-back/Size=24, Style=regular.svg": "bdb5",
	"./arrow-round-time-back/Size=24, Style=solid.svg": "fcc9",
	"./arrow-round-time-back/Size=32, Style=regular.svg": "ae38",
	"./arrow-round-time-back/Size=64, Style=regular.svg": "f2d3",
	"./arrow-round-time-forward/Size=16, Style=light.svg": "1170",
	"./arrow-round-time-forward/Size=16, Style=regular.svg": "8e8e",
	"./arrow-round-time-forward/Size=16, Style=solid.svg": "1ebe",
	"./arrow-round-time-forward/Size=20, Style=light.svg": "d69d",
	"./arrow-round-time-forward/Size=20, Style=regular.svg": "9c4e",
	"./arrow-round-time-forward/Size=20, Style=solid.svg": "1616",
	"./arrow-round-time-forward/Size=24, Style=regular.svg": "5605",
	"./arrow-round-time-forward/Size=24, Style=solid.svg": "185d",
	"./arrow-round-time-forward/Size=32, Style=regular.svg": "1be7",
	"./arrow-round-time-forward/Size=64, Style=regular.svg": "dba3",
	"./arrow-shape-a-down-left/Size=16, Style=light.svg": "8561",
	"./arrow-shape-a-down-left/Size=16, Style=regular.svg": "aa90",
	"./arrow-shape-a-down-left/Size=16, Style=solid.svg": "2758",
	"./arrow-shape-a-down-left/Size=20, Style=light.svg": "1804",
	"./arrow-shape-a-down-left/Size=20, Style=regular.svg": "bf1e",
	"./arrow-shape-a-down-left/Size=20, Style=solid.svg": "308c",
	"./arrow-shape-a-down-left/Size=24, Style=regular.svg": "69ca",
	"./arrow-shape-a-down-left/Size=24, Style=solid.svg": "da00",
	"./arrow-shape-a-down-left/Size=32, Style=regular.svg": "bc2a",
	"./arrow-shape-a-down-left/Size=64, Style=regular.svg": "ff91",
	"./arrow-shape-a-down-right/Size=16, Style=light.svg": "ebff",
	"./arrow-shape-a-down-right/Size=16, Style=regular.svg": "8cd2",
	"./arrow-shape-a-down-right/Size=16, Style=solid.svg": "bb23",
	"./arrow-shape-a-down-right/Size=20, Style=light.svg": "3030",
	"./arrow-shape-a-down-right/Size=20, Style=regular.svg": "902a",
	"./arrow-shape-a-down-right/Size=20, Style=solid.svg": "d84d",
	"./arrow-shape-a-down-right/Size=24, Style=regular.svg": "2e6a",
	"./arrow-shape-a-down-right/Size=24, Style=solid.svg": "8125",
	"./arrow-shape-a-down-right/Size=32, Style=regular.svg": "5c93",
	"./arrow-shape-a-down-right/Size=64, Style=regular.svg": "d7b6",
	"./arrow-shape-a-down/Size=16, Style=light.svg": "d3ff",
	"./arrow-shape-a-down/Size=16, Style=regular.svg": "c234",
	"./arrow-shape-a-down/Size=16, Style=solid.svg": "24e5",
	"./arrow-shape-a-down/Size=20, Style=light.svg": "241e",
	"./arrow-shape-a-down/Size=20, Style=regular.svg": "7a1c",
	"./arrow-shape-a-down/Size=20, Style=solid.svg": "f02f",
	"./arrow-shape-a-down/Size=24, Style=regular.svg": "2cdb",
	"./arrow-shape-a-down/Size=24, Style=solid.svg": "96d8",
	"./arrow-shape-a-down/Size=32, Style=regular.svg": "7d6a",
	"./arrow-shape-a-down/Size=64, Style=regular.svg": "4230",
	"./arrow-shape-a-left/Size=16, Style=light.svg": "bc43",
	"./arrow-shape-a-left/Size=16, Style=regular.svg": "afbf",
	"./arrow-shape-a-left/Size=16, Style=solid.svg": "b2a4",
	"./arrow-shape-a-left/Size=20, Style=light.svg": "26f6",
	"./arrow-shape-a-left/Size=20, Style=regular.svg": "3c25",
	"./arrow-shape-a-left/Size=20, Style=solid.svg": "9604",
	"./arrow-shape-a-left/Size=24, Style=regular.svg": "6cb6",
	"./arrow-shape-a-left/Size=24, Style=solid.svg": "e20f",
	"./arrow-shape-a-left/Size=32, Style=regular.svg": "0e14",
	"./arrow-shape-a-left/Size=64, Style=regular.svg": "5218",
	"./arrow-shape-a-right/Size=16, Style=light.svg": "4501",
	"./arrow-shape-a-right/Size=16, Style=regular.svg": "e688",
	"./arrow-shape-a-right/Size=16, Style=solid.svg": "0a67",
	"./arrow-shape-a-right/Size=20, Style=light.svg": "6661",
	"./arrow-shape-a-right/Size=20, Style=regular.svg": "c8fa",
	"./arrow-shape-a-right/Size=20, Style=solid.svg": "2689",
	"./arrow-shape-a-right/Size=24, Style=regular.svg": "4115",
	"./arrow-shape-a-right/Size=24, Style=solid.svg": "8937",
	"./arrow-shape-a-right/Size=32, Style=regular.svg": "f5c4",
	"./arrow-shape-a-right/Size=64, Style=regular.svg": "c402",
	"./arrow-shape-a-up-left/Size=16, Style=light.svg": "b584",
	"./arrow-shape-a-up-left/Size=16, Style=regular.svg": "727b",
	"./arrow-shape-a-up-left/Size=16, Style=solid.svg": "c767",
	"./arrow-shape-a-up-left/Size=20, Style=light.svg": "6c2c",
	"./arrow-shape-a-up-left/Size=20, Style=regular.svg": "7a86",
	"./arrow-shape-a-up-left/Size=20, Style=solid.svg": "44e5",
	"./arrow-shape-a-up-left/Size=24, Style=regular.svg": "85a5",
	"./arrow-shape-a-up-left/Size=24, Style=solid.svg": "6794",
	"./arrow-shape-a-up-left/Size=32, Style=regular.svg": "d5d9",
	"./arrow-shape-a-up-left/Size=64, Style=regular.svg": "4d80",
	"./arrow-shape-a-up-right/Size=16, Style=light.svg": "bd6b",
	"./arrow-shape-a-up-right/Size=16, Style=regular.svg": "1fd7",
	"./arrow-shape-a-up-right/Size=16, Style=solid.svg": "35d3",
	"./arrow-shape-a-up-right/Size=20, Style=light.svg": "80c3",
	"./arrow-shape-a-up-right/Size=20, Style=regular.svg": "7c9a",
	"./arrow-shape-a-up-right/Size=20, Style=solid.svg": "a24c",
	"./arrow-shape-a-up-right/Size=24, Style=regular.svg": "63bde",
	"./arrow-shape-a-up-right/Size=24, Style=solid.svg": "73d4",
	"./arrow-shape-a-up-right/Size=32, Style=regular.svg": "a18b",
	"./arrow-shape-a-up-right/Size=64, Style=regular.svg": "193b",
	"./arrow-shape-a-up/Size=16, Style=light.svg": "0f36",
	"./arrow-shape-a-up/Size=16, Style=regular.svg": "30e8",
	"./arrow-shape-a-up/Size=16, Style=solid.svg": "b62d",
	"./arrow-shape-a-up/Size=20, Style=light.svg": "376d",
	"./arrow-shape-a-up/Size=20, Style=regular.svg": "a090",
	"./arrow-shape-a-up/Size=20, Style=solid.svg": "c9d0",
	"./arrow-shape-a-up/Size=24, Style=regular.svg": "7f60",
	"./arrow-shape-a-up/Size=24, Style=solid.svg": "0f8a",
	"./arrow-shape-a-up/Size=32, Style=regular.svg": "0caa",
	"./arrow-shape-a-up/Size=64, Style=regular.svg": "6809",
	"./arrow-shape-d-radius-down-left/Size=16, Style=light.svg": "8bea",
	"./arrow-shape-d-radius-down-left/Size=16, Style=regular.svg": "8347",
	"./arrow-shape-d-radius-down-left/Size=16, Style=solid.svg": "b0bf",
	"./arrow-shape-d-radius-down-left/Size=20, Style=light.svg": "f475",
	"./arrow-shape-d-radius-down-left/Size=20, Style=regular.svg": "8640",
	"./arrow-shape-d-radius-down-left/Size=20, Style=solid.svg": "ce7a",
	"./arrow-shape-d-radius-down-left/Size=24, Style=regular.svg": "264b",
	"./arrow-shape-d-radius-down-left/Size=24, Style=solid.svg": "8848",
	"./arrow-shape-d-radius-down-left/Size=32, Style=regular.svg": "75b6",
	"./arrow-shape-d-radius-down-left/Size=64, Style=regular.svg": "8717",
	"./arrow-shape-d-radius-down-right/Size=16, Style=light.svg": "2204",
	"./arrow-shape-d-radius-down-right/Size=16, Style=regular.svg": "ea77",
	"./arrow-shape-d-radius-down-right/Size=16, Style=solid.svg": "2ee2",
	"./arrow-shape-d-radius-down-right/Size=20, Style=light.svg": "2725",
	"./arrow-shape-d-radius-down-right/Size=20, Style=regular.svg": "6107",
	"./arrow-shape-d-radius-down-right/Size=20, Style=solid.svg": "60e1",
	"./arrow-shape-d-radius-down-right/Size=24, Style=regular.svg": "824b",
	"./arrow-shape-d-radius-down-right/Size=24, Style=solid.svg": "2930",
	"./arrow-shape-d-radius-down-right/Size=32, Style=regular.svg": "c604",
	"./arrow-shape-d-radius-down-right/Size=64, Style=regular.svg": "77b4",
	"./arrow-shape-d-radius-up-left/Size=16, Style=light.svg": "de4a",
	"./arrow-shape-d-radius-up-left/Size=16, Style=regular.svg": "353ad",
	"./arrow-shape-d-radius-up-left/Size=16, Style=solid.svg": "e600",
	"./arrow-shape-d-radius-up-left/Size=20, Style=light.svg": "6e52",
	"./arrow-shape-d-radius-up-left/Size=20, Style=regular.svg": "2244",
	"./arrow-shape-d-radius-up-left/Size=20, Style=solid.svg": "a093",
	"./arrow-shape-d-radius-up-left/Size=24, Style=regular.svg": "76a2",
	"./arrow-shape-d-radius-up-left/Size=24, Style=solid.svg": "8cce",
	"./arrow-shape-d-radius-up-left/Size=32, Style=regular.svg": "02e3",
	"./arrow-shape-d-radius-up-left/Size=64, Style=regular.svg": "0a7b",
	"./arrow-shape-d-radius-up-right/Size=16, Style=light.svg": "7058",
	"./arrow-shape-d-radius-up-right/Size=16, Style=regular.svg": "e1d5",
	"./arrow-shape-d-radius-up-right/Size=16, Style=solid.svg": "21a8",
	"./arrow-shape-d-radius-up-right/Size=20, Style=light.svg": "ed53",
	"./arrow-shape-d-radius-up-right/Size=20, Style=regular.svg": "36d4",
	"./arrow-shape-d-radius-up-right/Size=20, Style=solid.svg": "0b7a4",
	"./arrow-shape-d-radius-up-right/Size=24, Style=regular.svg": "7762",
	"./arrow-shape-d-radius-up-right/Size=24, Style=solid.svg": "9f46",
	"./arrow-shape-d-radius-up-right/Size=32, Style=regular.svg": "82cf",
	"./arrow-shape-d-radius-up-right/Size=64, Style=regular.svg": "1517",
	"./arrow-shape-triangle-a-down/Size=16, Style=light.svg": "7bf2",
	"./arrow-shape-triangle-a-down/Size=16, Style=regular.svg": "27b6",
	"./arrow-shape-triangle-a-down/Size=16, Style=solid.svg": "3157",
	"./arrow-shape-triangle-a-down/Size=20, Style=light.svg": "ac92",
	"./arrow-shape-triangle-a-down/Size=20, Style=regular.svg": "f63e",
	"./arrow-shape-triangle-a-down/Size=20, Style=solid.svg": "b8c5",
	"./arrow-shape-triangle-a-down/Size=24, Style=regular.svg": "e149",
	"./arrow-shape-triangle-a-down/Size=24, Style=solid.svg": "4528",
	"./arrow-shape-triangle-a-down/Size=32, Style=regular.svg": "6643",
	"./arrow-shape-triangle-a-down/Size=64, Style=regular.svg": "eb97",
	"./arrow-shape-triangle-a-left/Size=16, Style=light.svg": "8643",
	"./arrow-shape-triangle-a-left/Size=16, Style=regular.svg": "8a62",
	"./arrow-shape-triangle-a-left/Size=16, Style=solid.svg": "6723",
	"./arrow-shape-triangle-a-left/Size=20, Style=light.svg": "5507",
	"./arrow-shape-triangle-a-left/Size=20, Style=regular.svg": "e903",
	"./arrow-shape-triangle-a-left/Size=20, Style=solid.svg": "21d4",
	"./arrow-shape-triangle-a-left/Size=24, Style=regular.svg": "4f29",
	"./arrow-shape-triangle-a-left/Size=24, Style=solid.svg": "19d6",
	"./arrow-shape-triangle-a-left/Size=32, Style=regular.svg": "f2c9",
	"./arrow-shape-triangle-a-left/Size=64, Style=regular.svg": "eb91",
	"./arrow-shape-triangle-a-right/Size=16, Style=light.svg": "d8e4",
	"./arrow-shape-triangle-a-right/Size=16, Style=regular.svg": "0047",
	"./arrow-shape-triangle-a-right/Size=16, Style=solid.svg": "4327",
	"./arrow-shape-triangle-a-right/Size=20, Style=light.svg": "cb67",
	"./arrow-shape-triangle-a-right/Size=20, Style=regular.svg": "924a",
	"./arrow-shape-triangle-a-right/Size=20, Style=solid.svg": "c98d",
	"./arrow-shape-triangle-a-right/Size=24, Style=regular.svg": "bedb",
	"./arrow-shape-triangle-a-right/Size=24, Style=solid.svg": "c67a",
	"./arrow-shape-triangle-a-right/Size=32, Style=regular.svg": "f5c1",
	"./arrow-shape-triangle-a-right/Size=64, Style=regular.svg": "aa91",
	"./arrow-shape-triangle-a-up/Size=16, Style=light.svg": "cf85",
	"./arrow-shape-triangle-a-up/Size=16, Style=regular.svg": "098c",
	"./arrow-shape-triangle-a-up/Size=16, Style=solid.svg": "7790",
	"./arrow-shape-triangle-a-up/Size=20, Style=light.svg": "8d3d",
	"./arrow-shape-triangle-a-up/Size=20, Style=regular.svg": "9d4d",
	"./arrow-shape-triangle-a-up/Size=20, Style=solid.svg": "cbdc",
	"./arrow-shape-triangle-a-up/Size=24, Style=regular.svg": "47aa",
	"./arrow-shape-triangle-a-up/Size=24, Style=solid.svg": "c212",
	"./arrow-shape-triangle-a-up/Size=32, Style=regular.svg": "b042",
	"./arrow-shape-triangle-a-up/Size=64, Style=regular.svg": "43bc",
	"./arrow-ui-auth-login/Size=16, Style=light.svg": "bd9b",
	"./arrow-ui-auth-login/Size=16, Style=regular.svg": "088e",
	"./arrow-ui-auth-login/Size=16, Style=solid.svg": "3bb7",
	"./arrow-ui-auth-login/Size=20, Style=light.svg": "eaa1",
	"./arrow-ui-auth-login/Size=20, Style=regular.svg": "f1a8",
	"./arrow-ui-auth-login/Size=20, Style=solid.svg": "6561",
	"./arrow-ui-auth-login/Size=24, Style=regular.svg": "8bbc",
	"./arrow-ui-auth-login/Size=24, Style=solid.svg": "5d0c",
	"./arrow-ui-auth-login/Size=32, Style=regular.svg": "569c",
	"./arrow-ui-auth-login/Size=64, Style=regular.svg": "729a",
	"./arrow-ui-auth-logout/Size=16, Style=light.svg": "8a7b",
	"./arrow-ui-auth-logout/Size=16, Style=regular.svg": "233d",
	"./arrow-ui-auth-logout/Size=16, Style=solid.svg": "9cce",
	"./arrow-ui-auth-logout/Size=20, Style=light.svg": "a80c",
	"./arrow-ui-auth-logout/Size=20, Style=regular.svg": "459c",
	"./arrow-ui-auth-logout/Size=20, Style=solid.svg": "82be",
	"./arrow-ui-auth-logout/Size=24, Style=regular.svg": "8403",
	"./arrow-ui-auth-logout/Size=24, Style=solid.svg": "4a43",
	"./arrow-ui-auth-logout/Size=32, Style=regular.svg": "7e8b",
	"./arrow-ui-auth-logout/Size=64, Style=regular.svg": "0e68",
	"./arrow-ui-corner-out-up-right/Size=16, Style=light.svg": "41da",
	"./arrow-ui-corner-out-up-right/Size=16, Style=regular.svg": "7947",
	"./arrow-ui-corner-out-up-right/Size=16, Style=solid.svg": "7496",
	"./arrow-ui-corner-out-up-right/Size=20, Style=light.svg": "0f9f",
	"./arrow-ui-corner-out-up-right/Size=20, Style=regular.svg": "0028",
	"./arrow-ui-corner-out-up-right/Size=20, Style=solid.svg": "e2d7",
	"./arrow-ui-corner-out-up-right/Size=24, Style=regular.svg": "3b8a",
	"./arrow-ui-corner-out-up-right/Size=24, Style=solid.svg": "76b1",
	"./arrow-ui-corner-out-up-right/Size=32, Style=regular.svg": "f211",
	"./arrow-ui-corner-out-up-right/Size=64, Style=regular.svg": "6309",
	"./arrow-ui-share-a-export/Size=16, Style=light.svg": "926a",
	"./arrow-ui-share-a-export/Size=16, Style=regular.svg": "b39ad",
	"./arrow-ui-share-a-export/Size=16, Style=solid.svg": "3aeb",
	"./arrow-ui-share-a-export/Size=20, Style=light.svg": "54b2",
	"./arrow-ui-share-a-export/Size=20, Style=regular.svg": "9278",
	"./arrow-ui-share-a-export/Size=20, Style=solid.svg": "3e81",
	"./arrow-ui-share-a-export/Size=24, Style=regular.svg": "f808",
	"./arrow-ui-share-a-export/Size=24, Style=solid.svg": "09ff",
	"./arrow-ui-share-a-export/Size=32, Style=regular.svg": "1673",
	"./arrow-ui-share-a-export/Size=64, Style=regular.svg": "6b9a",
	"./arrow-ui-share-a-import/Size=16, Style=light.svg": "0aed",
	"./arrow-ui-share-a-import/Size=16, Style=regular.svg": "1cbc",
	"./arrow-ui-share-a-import/Size=16, Style=solid.svg": "c5d3",
	"./arrow-ui-share-a-import/Size=20, Style=light.svg": "98d2",
	"./arrow-ui-share-a-import/Size=20, Style=regular.svg": "a485",
	"./arrow-ui-share-a-import/Size=20, Style=solid.svg": "322a",
	"./arrow-ui-share-a-import/Size=24, Style=regular.svg": "edb6",
	"./arrow-ui-share-a-import/Size=24, Style=solid.svg": "117a",
	"./arrow-ui-share-a-import/Size=32, Style=regular.svg": "3370",
	"./arrow-ui-share-a-import/Size=64, Style=regular.svg": "83ad",
	"./attach-link-off/Size=16, Style=light.svg": "415e",
	"./attach-link-off/Size=16, Style=regular.svg": "3f2e",
	"./attach-link-off/Size=16, Style=solid.svg": "6acb",
	"./attach-link-off/Size=20, Style=light.svg": "8eff",
	"./attach-link-off/Size=20, Style=regular.svg": "a63a",
	"./attach-link-off/Size=20, Style=solid.svg": "26dd",
	"./attach-link-off/Size=24, Style=regular.svg": "0694",
	"./attach-link-off/Size=24, Style=solid.svg": "97be",
	"./attach-link-off/Size=32, Style=regular.svg": "58dd",
	"./attach-link-off/Size=64, Style=regular.svg": "5f09",
	"./attach-link/Size=16, Style=light.svg": "385e",
	"./attach-link/Size=16, Style=regular.svg": "2333",
	"./attach-link/Size=16, Style=solid.svg": "dbe1",
	"./attach-link/Size=20, Style=light.svg": "9554",
	"./attach-link/Size=20, Style=regular.svg": "f77e",
	"./attach-link/Size=20, Style=solid.svg": "758a",
	"./attach-link/Size=24, Style=regular.svg": "fb73",
	"./attach-link/Size=24, Style=solid.svg": "abb8",
	"./attach-link/Size=32, Style=regular.svg": "74f6",
	"./attach-link/Size=64, Style=regular.svg": "707e",
	"./attach-paperclip/Size=16, Style=light.svg": "da6f",
	"./attach-paperclip/Size=16, Style=regular.svg": "31f1",
	"./attach-paperclip/Size=16, Style=solid.svg": "fb62",
	"./attach-paperclip/Size=20, Style=light.svg": "aef1",
	"./attach-paperclip/Size=20, Style=regular.svg": "0fd3",
	"./attach-paperclip/Size=20, Style=solid.svg": "10a2",
	"./attach-paperclip/Size=24, Style=regular.svg": "ba65",
	"./attach-paperclip/Size=24, Style=solid.svg": "d17f",
	"./attach-paperclip/Size=32, Style=regular.svg": "9ab3",
	"./attach-paperclip/Size=64, Style=regular.svg": "f4b5",
	"./attach-pin/Size=16, Style=light.svg": "959c",
	"./attach-pin/Size=16, Style=regular.svg": "854d",
	"./attach-pin/Size=16, Style=solid.svg": "624d",
	"./attach-pin/Size=20, Style=light.svg": "edbf",
	"./attach-pin/Size=20, Style=regular.svg": "58f7",
	"./attach-pin/Size=20, Style=solid.svg": "3910",
	"./attach-pin/Size=24, Style=regular.svg": "fe68",
	"./attach-pin/Size=24, Style=solid.svg": "46f2",
	"./attach-pin/Size=32, Style=regular.svg": "e798",
	"./attach-pin/Size=64, Style=regular.svg": "832d",
	"./bag-briefcase/Size=16, Style=light.svg": "28b6",
	"./bag-briefcase/Size=16, Style=regular.svg": "e707",
	"./bag-briefcase/Size=16, Style=solid.svg": "f7a7",
	"./bag-briefcase/Size=20, Style=light.svg": "2ff6",
	"./bag-briefcase/Size=20, Style=regular.svg": "ead1",
	"./bag-briefcase/Size=20, Style=solid.svg": "98bf",
	"./bag-briefcase/Size=24, Style=regular.svg": "21a0",
	"./bag-briefcase/Size=24, Style=solid.svg": "05ad",
	"./bag-briefcase/Size=32, Style=regular.svg": "2ccb",
	"./bag-briefcase/Size=64, Style=regular.svg": "aa0d",
	"./block/Size=16, Style=light.svg": "31ca",
	"./block/Size=16, Style=regular.svg": "dffc",
	"./block/Size=16, Style=solid.svg": "d1b3",
	"./block/Size=20, Style=light.svg": "fef8",
	"./block/Size=20, Style=regular.svg": "6fb0",
	"./block/Size=20, Style=solid.svg": "8a88",
	"./block/Size=24, Style=regular.svg": "a781",
	"./block/Size=24, Style=solid.svg": "a5ec",
	"./block/Size=32, Style=regular.svg": "5543",
	"./block/Size=64, Style=regular.svg": "07b1",
	"./book-closed-gov/Size=16, Style=light.svg": "11c1",
	"./book-closed-gov/Size=16, Style=regular.svg": "5561",
	"./book-closed-gov/Size=16, Style=solid.svg": "5b20",
	"./book-closed-gov/Size=20, Style=light.svg": "02bb",
	"./book-closed-gov/Size=20, Style=regular.svg": "4e66",
	"./book-closed-gov/Size=20, Style=solid.svg": "dee7",
	"./book-closed-gov/Size=24, Style=regular.svg": "cf2b",
	"./book-closed-gov/Size=24, Style=solid.svg": "685a",
	"./book-closed-gov/Size=32, Style=regular.svg": "d3a7",
	"./book-closed-gov/Size=64, Style=regular.svg": "eca8",
	"./book-closed-help/Size=16, Style=light.svg": "b564",
	"./book-closed-help/Size=16, Style=regular.svg": "7d1b",
	"./book-closed-help/Size=16, Style=solid.svg": "83bf",
	"./book-closed-help/Size=20, Style=light.svg": "4a49",
	"./book-closed-help/Size=20, Style=regular.svg": "7219",
	"./book-closed-help/Size=20, Style=solid.svg": "5b10",
	"./book-closed-help/Size=24, Style=regular.svg": "54ba",
	"./book-closed-help/Size=24, Style=solid.svg": "17d7",
	"./book-closed-help/Size=32, Style=regular.svg": "69e8",
	"./book-closed-help/Size=64, Style=regular.svg": "2a53",
	"./book-closed/Size=16, Style=light.svg": "5e8c",
	"./book-closed/Size=16, Style=regular.svg": "e0c8",
	"./book-closed/Size=16, Style=solid.svg": "008b",
	"./book-closed/Size=20, Style=light.svg": "1c72",
	"./book-closed/Size=20, Style=regular.svg": "cedc",
	"./book-closed/Size=20, Style=solid.svg": "1847",
	"./book-closed/Size=24, Style=regular.svg": "47ec",
	"./book-closed/Size=24, Style=solid.svg": "1931",
	"./book-closed/Size=32, Style=regular.svg": "b4d4",
	"./book-closed/Size=64, Style=regular.svg": "34b4",
	"./book-notepad-spiral/Size=16, Style=light.svg": "9332",
	"./book-notepad-spiral/Size=16, Style=regular.svg": "2949",
	"./book-notepad-spiral/Size=16, Style=solid.svg": "56d3",
	"./book-notepad-spiral/Size=20, Style=light.svg": "9ce0",
	"./book-notepad-spiral/Size=20, Style=regular.svg": "15d0",
	"./book-notepad-spiral/Size=20, Style=solid.svg": "c6a6",
	"./book-notepad-spiral/Size=24, Style=regular.svg": "f328",
	"./book-notepad-spiral/Size=24, Style=solid.svg": "5de7",
	"./book-notepad-spiral/Size=32, Style=regular.svg": "ce16",
	"./book-notepad-spiral/Size=64, Style=regular.svg": "81c6",
	"./book-notepad/Size=16, Style=light.svg": "1d92",
	"./book-notepad/Size=16, Style=regular.svg": "1372",
	"./book-notepad/Size=16, Style=solid.svg": "dbb5",
	"./book-notepad/Size=20, Style=light.svg": "9e9b",
	"./book-notepad/Size=20, Style=regular.svg": "c564",
	"./book-notepad/Size=20, Style=solid.svg": "8b53",
	"./book-notepad/Size=24, Style=regular.svg": "cfe5",
	"./book-notepad/Size=24, Style=solid.svg": "10a3",
	"./book-notepad/Size=32, Style=regular.svg": "40eb",
	"./book-notepad/Size=64, Style=regular.svg": "c85e",
	"./book-open-text/Size=16, Style=light.svg": "74aa",
	"./book-open-text/Size=16, Style=regular.svg": "01fb",
	"./book-open-text/Size=16, Style=solid.svg": "3f0a",
	"./book-open-text/Size=20, Style=light.svg": "48e1",
	"./book-open-text/Size=20, Style=regular.svg": "1e10",
	"./book-open-text/Size=20, Style=solid.svg": "cf00",
	"./book-open-text/Size=24, Style=regular.svg": "16c6",
	"./book-open-text/Size=24, Style=solid.svg": "97be9",
	"./book-open-text/Size=32, Style=regular.svg": "207a",
	"./book-open-text/Size=64, Style=regular.svg": "9cbe",
	"./book-open/Size=16, Style=light.svg": "d4a3",
	"./book-open/Size=16, Style=regular.svg": "767d",
	"./book-open/Size=16, Style=solid.svg": "4bfc",
	"./book-open/Size=20, Style=light.svg": "6342",
	"./book-open/Size=20, Style=regular.svg": "afb8",
	"./book-open/Size=20, Style=solid.svg": "55ba",
	"./book-open/Size=24, Style=regular.svg": "c1a6",
	"./book-open/Size=24, Style=solid.svg": "8454",
	"./book-open/Size=32, Style=regular.svg": "769d",
	"./book-open/Size=64, Style=regular.svg": "1d31",
	"./bookmark/Size=16, Style=light.svg": "cd6c",
	"./bookmark/Size=16, Style=regular.svg": "cf8f",
	"./bookmark/Size=16, Style=solid.svg": "2567",
	"./bookmark/Size=20, Style=light.svg": "b392",
	"./bookmark/Size=20, Style=regular.svg": "b0e5",
	"./bookmark/Size=20, Style=solid.svg": "3687",
	"./bookmark/Size=24, Style=regular.svg": "c9b5",
	"./bookmark/Size=24, Style=solid.svg": "4a9a",
	"./bookmark/Size=32, Style=regular.svg": "a94f",
	"./bookmark/Size=64, Style=regular.svg": "3d66",
	"./books-library/Size=16, Style=light.svg": "ae0a",
	"./books-library/Size=16, Style=regular.svg": "60b9",
	"./books-library/Size=16, Style=solid.svg": "b1ef",
	"./books-library/Size=20, Style=light.svg": "e72b",
	"./books-library/Size=20, Style=regular.svg": "dfb1",
	"./books-library/Size=20, Style=solid.svg": "487a",
	"./books-library/Size=24, Style=regular.svg": "a7b9",
	"./books-library/Size=24, Style=solid.svg": "2029",
	"./books-library/Size=32, Style=regular.svg": "375a",
	"./books-library/Size=64, Style=regular.svg": "1af6",
	"./building-home/Size=16, Style=light.svg": "a6fa",
	"./building-home/Size=16, Style=regular.svg": "f113",
	"./building-home/Size=16, Style=solid.svg": "e111",
	"./building-home/Size=20, Style=light.svg": "0642",
	"./building-home/Size=20, Style=regular.svg": "135a",
	"./building-home/Size=20, Style=solid.svg": "cb75",
	"./building-home/Size=24, Style=regular.svg": "f6fe",
	"./building-home/Size=24, Style=solid.svg": "656b",
	"./building-home/Size=32, Style=regular.svg": "944f",
	"./building-home/Size=64, Style=regular.svg": "2e75",
	"./building-office/Size=16, Style=light.svg": "f234",
	"./building-office/Size=16, Style=regular.svg": "e21c",
	"./building-office/Size=16, Style=solid.svg": "35b9",
	"./building-office/Size=20, Style=light.svg": "f422",
	"./building-office/Size=20, Style=regular.svg": "225e",
	"./building-office/Size=20, Style=solid.svg": "e1a8",
	"./building-office/Size=24, Style=regular.svg": "4110",
	"./building-office/Size=24, Style=solid.svg": "802d",
	"./building-office/Size=32, Style=regular.svg": "948f",
	"./building-office/Size=64, Style=regular.svg": "864e",
	"./calculator/Size=16, Style=light.svg": "038c",
	"./calculator/Size=16, Style=regular.svg": "8c52",
	"./calculator/Size=16, Style=solid.svg": "a7f2",
	"./calculator/Size=20, Style=light.svg": "e3ca",
	"./calculator/Size=20, Style=regular.svg": "10d11",
	"./calculator/Size=20, Style=solid.svg": "d15f",
	"./calculator/Size=24, Style=regular.svg": "01f6",
	"./calculator/Size=24, Style=solid.svg": "5b25",
	"./calculator/Size=32, Style=regular.svg": "3ac4",
	"./calculator/Size=64, Style=regular.svg": "a2c9",
	"./calendar/Size=16, Style=light.svg": "8d9a",
	"./calendar/Size=16, Style=regular.svg": "2a9e",
	"./calendar/Size=16, Style=solid.svg": "0f2c",
	"./calendar/Size=20, Style=light.svg": "19ec",
	"./calendar/Size=20, Style=regular.svg": "812d",
	"./calendar/Size=20, Style=solid.svg": "5fee",
	"./calendar/Size=24, Style=regular.svg": "85be",
	"./calendar/Size=24, Style=solid.svg": "17ac",
	"./calendar/Size=32, Style=regular.svg": "ba92",
	"./calendar/Size=64, Style=regular.svg": "5d9f",
	"./cert-rosette/Size=16, Style=light.svg": "288c",
	"./cert-rosette/Size=16, Style=regular.svg": "fa46",
	"./cert-rosette/Size=16, Style=solid.svg": "ab90",
	"./cert-rosette/Size=20, Style=light.svg": "72f7f",
	"./cert-rosette/Size=20, Style=regular.svg": "c36b",
	"./cert-rosette/Size=20, Style=solid.svg": "7007",
	"./cert-rosette/Size=24, Style=regular.svg": "6418",
	"./cert-rosette/Size=24, Style=solid.svg": "b612",
	"./cert-rosette/Size=32, Style=regular.svg": "1cef",
	"./cert-rosette/Size=64, Style=regular.svg": "f478",
	"./check-a-two/Size=16, Style=light.svg": "f3f6",
	"./check-a-two/Size=16, Style=regular.svg": "8591",
	"./check-a-two/Size=16, Style=solid.svg": "a838",
	"./check-a-two/Size=20, Style=light.svg": "77bc5",
	"./check-a-two/Size=20, Style=regular.svg": "4b2c",
	"./check-a-two/Size=20, Style=solid.svg": "cc20",
	"./check-a-two/Size=24, Style=regular.svg": "a939",
	"./check-a-two/Size=24, Style=solid.svg": "0555",
	"./check-a-two/Size=32, Style=regular.svg": "1945",
	"./check-a-two/Size=64, Style=regular.svg": "2313",
	"./check-a/Size=16, Style=light.svg": "d725",
	"./check-a/Size=16, Style=regular.svg": "2d79",
	"./check-a/Size=16, Style=solid.svg": "fe20",
	"./check-a/Size=20, Style=light.svg": "4837",
	"./check-a/Size=20, Style=regular.svg": "9dc5",
	"./check-a/Size=20, Style=solid.svg": "b2ee",
	"./check-a/Size=24, Style=regular.svg": "c668",
	"./check-a/Size=24, Style=solid.svg": "cb23",
	"./check-a/Size=32, Style=regular.svg": "26c2",
	"./check-a/Size=64, Style=regular.svg": "ada1",
	"./check-circle-cut/Size=16, Style=light.svg": "cda0",
	"./check-circle-cut/Size=16, Style=regular.svg": "bc1f",
	"./check-circle-cut/Size=16, Style=solid.svg": "4a98",
	"./check-circle-cut/Size=20, Style=light.svg": "01ba",
	"./check-circle-cut/Size=20, Style=regular.svg": "4c81",
	"./check-circle-cut/Size=20, Style=solid.svg": "472c",
	"./check-circle-cut/Size=24, Style=regular.svg": "9504",
	"./check-circle-cut/Size=24, Style=solid.svg": "e03b",
	"./check-circle-cut/Size=32, Style=regular.svg": "8829",
	"./check-circle-cut/Size=64, Style=regular.svg": "6e2a",
	"./check-circle/Size=16, Style=light.svg": "df8d",
	"./check-circle/Size=16, Style=regular.svg": "044a",
	"./check-circle/Size=16, Style=solid.svg": "7195",
	"./check-circle/Size=20, Style=light.svg": "c454",
	"./check-circle/Size=20, Style=regular.svg": "0e43",
	"./check-circle/Size=20, Style=solid.svg": "ee6e",
	"./check-circle/Size=24, Style=regular.svg": "ab5a",
	"./check-circle/Size=24, Style=solid.svg": "0d84",
	"./check-circle/Size=32, Style=regular.svg": "965e",
	"./check-circle/Size=64, Style=regular.svg": "55e0",
	"./check-square-cut/Size=16, Style=light.svg": "5a3a",
	"./check-square-cut/Size=16, Style=regular.svg": "e3dc",
	"./check-square-cut/Size=16, Style=solid.svg": "9627",
	"./check-square-cut/Size=20, Style=light.svg": "de88",
	"./check-square-cut/Size=20, Style=regular.svg": "9d87",
	"./check-square-cut/Size=20, Style=solid.svg": "a8fb",
	"./check-square-cut/Size=24, Style=regular.svg": "d2e2",
	"./check-square-cut/Size=24, Style=solid.svg": "1418",
	"./check-square-cut/Size=32, Style=regular.svg": "5a57",
	"./check-square-cut/Size=64, Style=regular.svg": "efa5",
	"./check-square/Size=16, Style=light.svg": "842d",
	"./check-square/Size=16, Style=regular.svg": "1c53",
	"./check-square/Size=16, Style=solid.svg": "1bc3",
	"./check-square/Size=20, Style=light.svg": "a5d0",
	"./check-square/Size=20, Style=regular.svg": "5ca2",
	"./check-square/Size=20, Style=solid.svg": "9f27",
	"./check-square/Size=24, Style=regular.svg": "7142",
	"./check-square/Size=24, Style=solid.svg": "e010",
	"./check-square/Size=32, Style=regular.svg": "ba19",
	"./check-square/Size=64, Style=regular.svg": "fff4",
	"./comment-rect-plus/Size=16, Style=light.svg": "8461",
	"./comment-rect-plus/Size=16, Style=regular.svg": "fa7c",
	"./comment-rect-plus/Size=16, Style=solid.svg": "46f3",
	"./comment-rect-plus/Size=20, Style=light.svg": "841f",
	"./comment-rect-plus/Size=20, Style=regular.svg": "1f40",
	"./comment-rect-plus/Size=20, Style=solid.svg": "47f6",
	"./comment-rect-plus/Size=24, Style=regular.svg": "93da",
	"./comment-rect-plus/Size=24, Style=solid.svg": "db9a",
	"./comment-rect-plus/Size=32, Style=regular.svg": "a860",
	"./comment-rect-plus/Size=64, Style=regular.svg": "114b",
	"./comment-rect-text/Size=16, Style=light.svg": "4153",
	"./comment-rect-text/Size=16, Style=regular.svg": "52a7",
	"./comment-rect-text/Size=16, Style=solid.svg": "cae7",
	"./comment-rect-text/Size=20, Style=light.svg": "094d",
	"./comment-rect-text/Size=20, Style=regular.svg": "1d577",
	"./comment-rect-text/Size=20, Style=solid.svg": "cd13",
	"./comment-rect-text/Size=24, Style=regular.svg": "699a",
	"./comment-rect-text/Size=24, Style=solid.svg": "f1da",
	"./comment-rect-text/Size=32, Style=regular.svg": "c040",
	"./comment-rect-text/Size=64, Style=regular.svg": "e92c",
	"./comment-rect-two-text/Size=16, Style=light.svg": "50b0",
	"./comment-rect-two-text/Size=16, Style=regular.svg": "0a3b",
	"./comment-rect-two-text/Size=16, Style=solid.svg": "609f",
	"./comment-rect-two-text/Size=20, Style=light.svg": "e735",
	"./comment-rect-two-text/Size=20, Style=regular.svg": "798b",
	"./comment-rect-two-text/Size=20, Style=solid.svg": "244c",
	"./comment-rect-two-text/Size=24, Style=regular.svg": "1882",
	"./comment-rect-two-text/Size=24, Style=solid.svg": "c4d1",
	"./comment-rect-two-text/Size=32, Style=regular.svg": "640c",
	"./comment-rect-two-text/Size=64, Style=regular.svg": "def7",
	"./comment-rect-x/Size=16, Style=light.svg": "cc55",
	"./comment-rect-x/Size=16, Style=regular.svg": "9633",
	"./comment-rect-x/Size=16, Style=solid.svg": "1ba9",
	"./comment-rect-x/Size=20, Style=light.svg": "5333",
	"./comment-rect-x/Size=20, Style=regular.svg": "0db5",
	"./comment-rect-x/Size=20, Style=solid.svg": "a360",
	"./comment-rect-x/Size=24, Style=regular.svg": "516c",
	"./comment-rect-x/Size=24, Style=solid.svg": "50db",
	"./comment-rect-x/Size=32, Style=regular.svg": "da2e",
	"./comment-rect-x/Size=64, Style=regular.svg": "a99b",
	"./comment-rect/Size=16, Style=light.svg": "4d37",
	"./comment-rect/Size=16, Style=regular.svg": "98cc",
	"./comment-rect/Size=16, Style=solid.svg": "37bb",
	"./comment-rect/Size=20, Style=light.svg": "0088",
	"./comment-rect/Size=20, Style=regular.svg": "cef5",
	"./comment-rect/Size=20, Style=solid.svg": "d79d",
	"./comment-rect/Size=24, Style=regular.svg": "03c2",
	"./comment-rect/Size=24, Style=solid.svg": "68de",
	"./comment-rect/Size=32, Style=regular.svg": "cfb2",
	"./comment-rect/Size=64, Style=regular.svg": "e6d6",
	"./copy/Size=16, Style=light.svg": "bce0",
	"./copy/Size=16, Style=regular.svg": "c8e3",
	"./copy/Size=16, Style=solid.svg": "e84e",
	"./copy/Size=20, Style=light.svg": "688f",
	"./copy/Size=20, Style=regular.svg": "956b",
	"./copy/Size=20, Style=solid.svg": "6134",
	"./copy/Size=24, Style=regular.svg": "4943",
	"./copy/Size=24, Style=solid.svg": "26f4",
	"./copy/Size=32, Style=regular.svg": "8033",
	"./copy/Size=64, Style=regular.svg": "8b7a",
	"./counter/Size=16, Style=light.svg": "d704",
	"./counter/Size=16, Style=regular.svg": "6f3b",
	"./counter/Size=16, Style=solid.svg": "1847b",
	"./counter/Size=20, Style=light.svg": "7226",
	"./counter/Size=20, Style=regular.svg": "7dc2",
	"./counter/Size=20, Style=solid.svg": "62dd",
	"./counter/Size=24, Style=regular.svg": "107c1",
	"./counter/Size=24, Style=solid.svg": "e9be",
	"./counter/Size=32, Style=regular.svg": "e376",
	"./counter/Size=64, Style=regular.svg": "0b6b",
	"./data-chart-bars-a/Size=16, Style=light.svg": "6f93",
	"./data-chart-bars-a/Size=16, Style=regular.svg": "95d5",
	"./data-chart-bars-a/Size=16, Style=solid.svg": "e7d6",
	"./data-chart-bars-a/Size=20, Style=light.svg": "b05f",
	"./data-chart-bars-a/Size=20, Style=regular.svg": "afdc",
	"./data-chart-bars-a/Size=20, Style=solid.svg": "4f8a",
	"./data-chart-bars-a/Size=24, Style=regular.svg": "ca23",
	"./data-chart-bars-a/Size=24, Style=solid.svg": "73fb",
	"./data-chart-bars-a/Size=32, Style=regular.svg": "0d65",
	"./data-chart-bars-a/Size=64, Style=regular.svg": "cc28",
	"./data-chart-bars-x/Size=16, Style=light.svg": "ff2e",
	"./data-chart-bars-x/Size=16, Style=regular.svg": "b29e",
	"./data-chart-bars-x/Size=16, Style=solid.svg": "2e65",
	"./data-chart-bars-x/Size=20, Style=light.svg": "880d",
	"./data-chart-bars-x/Size=20, Style=regular.svg": "55d3",
	"./data-chart-bars-x/Size=20, Style=solid.svg": "4705",
	"./data-chart-bars-x/Size=24, Style=regular.svg": "3d35",
	"./data-chart-bars-x/Size=24, Style=solid.svg": "3cc0",
	"./data-chart-bars-x/Size=32, Style=regular.svg": "f643",
	"./data-chart-bars-x/Size=64, Style=regular.svg": "2420",
	"./data-chart-pie-a-one/Size=16, Style=light.svg": "e5d7",
	"./data-chart-pie-a-one/Size=16, Style=regular.svg": "371d",
	"./data-chart-pie-a-one/Size=16, Style=solid.svg": "3231",
	"./data-chart-pie-a-one/Size=20, Style=light.svg": "0db9",
	"./data-chart-pie-a-one/Size=20, Style=regular.svg": "68c1",
	"./data-chart-pie-a-one/Size=20, Style=solid.svg": "1715",
	"./data-chart-pie-a-one/Size=24, Style=regular.svg": "87cd",
	"./data-chart-pie-a-one/Size=24, Style=solid.svg": "4f6b",
	"./data-chart-pie-a-one/Size=32, Style=regular.svg": "f459",
	"./data-chart-pie-a-one/Size=64, Style=regular.svg": "48a2",
	"./data-chart-pie-a-two/Size=16, Style=light.svg": "4416",
	"./data-chart-pie-a-two/Size=16, Style=regular.svg": "d3d1",
	"./data-chart-pie-a-two/Size=16, Style=solid.svg": "9711",
	"./data-chart-pie-a-two/Size=20, Style=light.svg": "75d4",
	"./data-chart-pie-a-two/Size=20, Style=regular.svg": "a497",
	"./data-chart-pie-a-two/Size=20, Style=solid.svg": "8bf7",
	"./data-chart-pie-a-two/Size=24, Style=regular.svg": "356d",
	"./data-chart-pie-a-two/Size=24, Style=solid.svg": "7af7",
	"./data-chart-pie-a-two/Size=32, Style=regular.svg": "06bd",
	"./data-chart-pie-a-two/Size=64, Style=regular.svg": "ad9e",
	"./data-chart-trend-xy-up/Size=16, Style=light.svg": "cdb5",
	"./data-chart-trend-xy-up/Size=16, Style=regular.svg": "6419",
	"./data-chart-trend-xy-up/Size=16, Style=solid.svg": "5e9c",
	"./data-chart-trend-xy-up/Size=20, Style=light.svg": "1ef5",
	"./data-chart-trend-xy-up/Size=20, Style=regular.svg": "dddf",
	"./data-chart-trend-xy-up/Size=20, Style=solid.svg": "b56f",
	"./data-chart-trend-xy-up/Size=24, Style=regular.svg": "8b87",
	"./data-chart-trend-xy-up/Size=24, Style=solid.svg": "bb0e",
	"./data-chart-trend-xy-up/Size=32, Style=regular.svg": "017f",
	"./data-chart-trend-xy-up/Size=64, Style=regular.svg": "cacc",
	"./delivery-box-front-open/Size=16, Style=light.svg": "0567",
	"./delivery-box-front-open/Size=16, Style=regular.svg": "7a95",
	"./delivery-box-front-open/Size=16, Style=solid.svg": "dff4",
	"./delivery-box-front-open/Size=20, Style=light.svg": "5b8c",
	"./delivery-box-front-open/Size=20, Style=regular.svg": "64e6",
	"./delivery-box-front-open/Size=20, Style=solid.svg": "ff69",
	"./delivery-box-front-open/Size=24, Style=regular.svg": "bacf",
	"./delivery-box-front-open/Size=24, Style=solid.svg": "dc44",
	"./delivery-box-front-open/Size=32, Style=regular.svg": "2620",
	"./delivery-box-front-open/Size=64, Style=regular.svg": "d7f6",
	"./dev-bug/Size=16, Style=light.svg": "f31a",
	"./dev-bug/Size=16, Style=regular.svg": "c65b9",
	"./dev-bug/Size=16, Style=solid.svg": "e95b",
	"./dev-bug/Size=20, Style=light.svg": "b86a",
	"./dev-bug/Size=20, Style=regular.svg": "e731",
	"./dev-bug/Size=20, Style=solid.svg": "6e98",
	"./dev-bug/Size=24, Style=regular.svg": "f9d6",
	"./dev-bug/Size=24, Style=solid.svg": "8019",
	"./dev-bug/Size=32, Style=regular.svg": "685c",
	"./dev-bug/Size=64, Style=regular.svg": "cc5c",
	"./divide-circle/Size=16, Style=light.svg": "6967",
	"./divide-circle/Size=16, Style=regular.svg": "b209",
	"./divide-circle/Size=16, Style=solid.svg": "0ef2",
	"./divide-circle/Size=20, Style=light.svg": "d03d",
	"./divide-circle/Size=20, Style=regular.svg": "e429",
	"./divide-circle/Size=20, Style=solid.svg": "2d9f",
	"./divide-circle/Size=24, Style=regular.svg": "b264",
	"./divide-circle/Size=24, Style=solid.svg": "d387",
	"./divide-circle/Size=32, Style=regular.svg": "a725",
	"./divide-circle/Size=64, Style=regular.svg": "0210",
	"./divide/Size=16, Style=light.svg": "d3c4",
	"./divide/Size=16, Style=regular.svg": "da6a",
	"./divide/Size=16, Style=solid.svg": "a430",
	"./divide/Size=20, Style=light.svg": "fa51",
	"./divide/Size=20, Style=regular.svg": "4ba4",
	"./divide/Size=20, Style=solid.svg": "8b0c",
	"./divide/Size=24, Style=regular.svg": "fd18",
	"./divide/Size=24, Style=solid.svg": "21e7",
	"./divide/Size=32, Style=regular.svg": "2bf7",
	"./divide/Size=64, Style=regular.svg": "97ff",
	"./doc-arrow-convert/Size=16, Style=light.svg": "74da",
	"./doc-arrow-convert/Size=16, Style=regular.svg": "da51",
	"./doc-arrow-convert/Size=16, Style=solid.svg": "a237",
	"./doc-arrow-convert/Size=20, Style=light.svg": "7649",
	"./doc-arrow-convert/Size=20, Style=regular.svg": "fe9a",
	"./doc-arrow-convert/Size=20, Style=solid.svg": "f89c",
	"./doc-arrow-convert/Size=24, Style=regular.svg": "95eb",
	"./doc-arrow-convert/Size=24, Style=solid.svg": "2338",
	"./doc-arrow-convert/Size=32, Style=regular.svg": "c1e7",
	"./doc-arrow-convert/Size=64, Style=regular.svg": "6983",
	"./doc-arrow-sync/Size=16, Style=light.svg": "1bfd",
	"./doc-arrow-sync/Size=16, Style=regular.svg": "c25b",
	"./doc-arrow-sync/Size=16, Style=solid.svg": "604a",
	"./doc-arrow-sync/Size=20, Style=light.svg": "6cce",
	"./doc-arrow-sync/Size=20, Style=regular.svg": "2ab6",
	"./doc-arrow-sync/Size=20, Style=solid.svg": "b7b8",
	"./doc-arrow-sync/Size=24, Style=regular.svg": "3938",
	"./doc-arrow-sync/Size=24, Style=solid.svg": "94fa",
	"./doc-arrow-sync/Size=32, Style=regular.svg": "9c68",
	"./doc-arrow-sync/Size=64, Style=regular.svg": "f3cc",
	"./doc-check/Size=16, Style=light.svg": "98d8",
	"./doc-check/Size=16, Style=regular.svg": "9786",
	"./doc-check/Size=16, Style=solid.svg": "66c4",
	"./doc-check/Size=20, Style=light.svg": "9875",
	"./doc-check/Size=20, Style=regular.svg": "9ac4",
	"./doc-check/Size=20, Style=solid.svg": "4a28",
	"./doc-check/Size=24, Style=regular.svg": "32cb",
	"./doc-check/Size=24, Style=solid.svg": "2c68",
	"./doc-check/Size=32, Style=regular.svg": "3398",
	"./doc-check/Size=64, Style=regular.svg": "f1a7",
	"./doc-minus/Size=16, Style=light.svg": "03be",
	"./doc-minus/Size=16, Style=regular.svg": "d61d",
	"./doc-minus/Size=16, Style=solid.svg": "896e",
	"./doc-minus/Size=20, Style=light.svg": "6e42",
	"./doc-minus/Size=20, Style=regular.svg": "f875",
	"./doc-minus/Size=20, Style=solid.svg": "3387",
	"./doc-minus/Size=24, Style=regular.svg": "3c0d",
	"./doc-minus/Size=24, Style=solid.svg": "eeab",
	"./doc-minus/Size=32, Style=regular.svg": "b62f",
	"./doc-minus/Size=64, Style=regular.svg": "bd85",
	"./doc-plus/Size=16, Style=light.svg": "5e81",
	"./doc-plus/Size=16, Style=regular.svg": "79c5",
	"./doc-plus/Size=16, Style=solid.svg": "76b6",
	"./doc-plus/Size=20, Style=light.svg": "390b",
	"./doc-plus/Size=20, Style=regular.svg": "321e",
	"./doc-plus/Size=20, Style=solid.svg": "bb93",
	"./doc-plus/Size=24, Style=regular.svg": "3168",
	"./doc-plus/Size=24, Style=solid.svg": "8bb1",
	"./doc-plus/Size=32, Style=regular.svg": "5a3f",
	"./doc-plus/Size=64, Style=regular.svg": "339d",
	"./doc-text/Size=16, Style=light.svg": "9dc0",
	"./doc-text/Size=16, Style=regular.svg": "7cf6",
	"./doc-text/Size=16, Style=solid.svg": "7707",
	"./doc-text/Size=20, Style=light.svg": "5960",
	"./doc-text/Size=20, Style=regular.svg": "3fc9",
	"./doc-text/Size=20, Style=solid.svg": "fc0e",
	"./doc-text/Size=24, Style=regular.svg": "1ef1",
	"./doc-text/Size=24, Style=solid.svg": "6625",
	"./doc-text/Size=32, Style=regular.svg": "9521",
	"./doc-text/Size=64, Style=regular.svg": "36cd",
	"./doc-x/Size=16, Style=light.svg": "0a5d",
	"./doc-x/Size=16, Style=regular.svg": "b047cb",
	"./doc-x/Size=16, Style=solid.svg": "b0a0",
	"./doc-x/Size=20, Style=light.svg": "2104",
	"./doc-x/Size=20, Style=regular.svg": "c380",
	"./doc-x/Size=20, Style=solid.svg": "6562",
	"./doc-x/Size=24, Style=regular.svg": "760c",
	"./doc-x/Size=24, Style=solid.svg": "d19a",
	"./doc-x/Size=32, Style=regular.svg": "c6e4",
	"./doc-x/Size=64, Style=regular.svg": "e2cd",
	"./doc/Size=16, Style=light.svg": "e2ea",
	"./doc/Size=16, Style=regular.svg": "0668",
	"./doc/Size=16, Style=solid.svg": "2b47",
	"./doc/Size=20, Style=light.svg": "2e61",
	"./doc/Size=20, Style=regular.svg": "5da8",
	"./doc/Size=20, Style=solid.svg": "f3f7",
	"./doc/Size=24, Style=regular.svg": "4eeb",
	"./doc/Size=24, Style=solid.svg": "57da",
	"./doc/Size=32, Style=regular.svg": "cfd7",
	"./doc/Size=64, Style=regular.svg": "14f5",
	"./docs-plus/Size=16, Style=light.svg": "cc554",
	"./docs-plus/Size=16, Style=regular.svg": "bdd4",
	"./docs-plus/Size=16, Style=solid.svg": "de97",
	"./docs-plus/Size=20, Style=light.svg": "1c2f",
	"./docs-plus/Size=20, Style=regular.svg": "8e96",
	"./docs-plus/Size=20, Style=solid.svg": "545d",
	"./docs-plus/Size=24, Style=regular.svg": "70e9",
	"./docs-plus/Size=24, Style=solid.svg": "8c2a",
	"./docs-plus/Size=32, Style=regular.svg": "e675",
	"./docs-plus/Size=64, Style=regular.svg": "f985",
	"./docs-text/Size=16, Style=light.svg": "2dc0",
	"./docs-text/Size=16, Style=regular.svg": "77aa",
	"./docs-text/Size=16, Style=solid.svg": "d0a9",
	"./docs-text/Size=20, Style=light.svg": "c39a",
	"./docs-text/Size=20, Style=regular.svg": "3580",
	"./docs-text/Size=20, Style=solid.svg": "efcf",
	"./docs-text/Size=24, Style=regular.svg": "1e4b",
	"./docs-text/Size=24, Style=solid.svg": "3ae4",
	"./docs-text/Size=32, Style=regular.svg": "ff20",
	"./docs-text/Size=64, Style=regular.svg": "63d5",
	"./docs/Size=16, Style=light.svg": "535f",
	"./docs/Size=16, Style=regular.svg": "a648",
	"./docs/Size=16, Style=solid.svg": "527d",
	"./docs/Size=20, Style=light.svg": "4743",
	"./docs/Size=20, Style=regular.svg": "3a22",
	"./docs/Size=20, Style=solid.svg": "bc93",
	"./docs/Size=24, Style=regular.svg": "9526",
	"./docs/Size=24, Style=solid.svg": "e3fb",
	"./docs/Size=32, Style=regular.svg": "a8d6",
	"./docs/Size=64, Style=regular.svg": "bf55",
	"./edu-hat/Size=16, Style=light.svg": "fc52",
	"./edu-hat/Size=16, Style=regular.svg": "3da5",
	"./edu-hat/Size=16, Style=solid.svg": "9e0a",
	"./edu-hat/Size=20, Style=light.svg": "e9a7",
	"./edu-hat/Size=20, Style=regular.svg": "5998",
	"./edu-hat/Size=20, Style=solid.svg": "5037",
	"./edu-hat/Size=24, Style=regular.svg": "7a2f",
	"./edu-hat/Size=24, Style=solid.svg": "7e39",
	"./edu-hat/Size=32, Style=regular.svg": "9e47",
	"./edu-hat/Size=64, Style=regular.svg": "5644",
	"./eye-closed/Size=16, Style=light.svg": "5117",
	"./eye-closed/Size=16, Style=regular.svg": "5ee9",
	"./eye-closed/Size=16, Style=solid.svg": "f5e2",
	"./eye-closed/Size=20, Style=light.svg": "c810",
	"./eye-closed/Size=20, Style=regular.svg": "76d3",
	"./eye-closed/Size=20, Style=solid.svg": "b409",
	"./eye-closed/Size=24, Style=regular.svg": "9086",
	"./eye-closed/Size=24, Style=solid.svg": "48a5",
	"./eye-closed/Size=32, Style=regular.svg": "4cfd",
	"./eye-closed/Size=64, Style=regular.svg": "038e",
	"./eye-off/Size=16, Style=light.svg": "22c9",
	"./eye-off/Size=16, Style=regular.svg": "63bf",
	"./eye-off/Size=16, Style=solid.svg": "f742",
	"./eye-off/Size=20, Style=light.svg": "2434",
	"./eye-off/Size=20, Style=regular.svg": "d501",
	"./eye-off/Size=20, Style=solid.svg": "df3f",
	"./eye-off/Size=24, Style=regular.svg": "a6c9",
	"./eye-off/Size=24, Style=solid.svg": "36a8",
	"./eye-off/Size=32, Style=regular.svg": "4ee4",
	"./eye-off/Size=64, Style=regular.svg": "b88f",
	"./eye-open/Size=16, Style=light.svg": "f299",
	"./eye-open/Size=16, Style=regular.svg": "1a66",
	"./eye-open/Size=16, Style=solid.svg": "66437",
	"./eye-open/Size=20, Style=light.svg": "e7a7",
	"./eye-open/Size=20, Style=regular.svg": "77bf",
	"./eye-open/Size=20, Style=solid.svg": "a92f",
	"./eye-open/Size=24, Style=regular.svg": "2fe5",
	"./eye-open/Size=24, Style=solid.svg": "f7b0",
	"./eye-open/Size=32, Style=regular.svg": "fa3c",
	"./eye-open/Size=64, Style=regular.svg": "7745",
	"./face-a-happy/Size=16, Style=light.svg": "08d9",
	"./face-a-happy/Size=16, Style=regular.svg": "3950",
	"./face-a-happy/Size=16, Style=solid.svg": "2dc8",
	"./face-a-happy/Size=20, Style=light.svg": "c061",
	"./face-a-happy/Size=20, Style=regular.svg": "fc57",
	"./face-a-happy/Size=20, Style=solid.svg": "c92d",
	"./face-a-happy/Size=24, Style=regular.svg": "152f",
	"./face-a-happy/Size=24, Style=solid.svg": "8780",
	"./face-a-happy/Size=32, Style=regular.svg": "8de7",
	"./face-a-happy/Size=64, Style=regular.svg": "fe48",
	"./face-a-neutral/Size=16, Style=light.svg": "4b4c",
	"./face-a-neutral/Size=16, Style=regular.svg": "9b39",
	"./face-a-neutral/Size=16, Style=solid.svg": "1ad8",
	"./face-a-neutral/Size=20, Style=light.svg": "4d54",
	"./face-a-neutral/Size=20, Style=regular.svg": "3161",
	"./face-a-neutral/Size=20, Style=solid.svg": "268f",
	"./face-a-neutral/Size=24, Style=regular.svg": "db8a",
	"./face-a-neutral/Size=24, Style=solid.svg": "99a8",
	"./face-a-neutral/Size=32, Style=regular.svg": "d4d0",
	"./face-a-neutral/Size=64, Style=regular.svg": "5f4f",
	"./face-a-sad/Size=16, Style=light.svg": "4a8a",
	"./face-a-sad/Size=16, Style=regular.svg": "29c9",
	"./face-a-sad/Size=16, Style=solid.svg": "12b8",
	"./face-a-sad/Size=20, Style=light.svg": "f54a",
	"./face-a-sad/Size=20, Style=regular.svg": "9b37",
	"./face-a-sad/Size=20, Style=solid.svg": "8a94",
	"./face-a-sad/Size=24, Style=regular.svg": "59a3",
	"./face-a-sad/Size=24, Style=solid.svg": "cdd4",
	"./face-a-sad/Size=32, Style=regular.svg": "952b",
	"./face-a-sad/Size=64, Style=regular.svg": "abd6",
	"./flag-a/Size=16, Style=light.svg": "a7f6",
	"./flag-a/Size=16, Style=regular.svg": "5d26",
	"./flag-a/Size=16, Style=solid.svg": "8a9b",
	"./flag-a/Size=20, Style=light.svg": "d349",
	"./flag-a/Size=20, Style=regular.svg": "127f",
	"./flag-a/Size=20, Style=solid.svg": "116c",
	"./flag-a/Size=24, Style=regular.svg": "9d9d",
	"./flag-a/Size=24, Style=solid.svg": "393c",
	"./flag-a/Size=32, Style=regular.svg": "aa16",
	"./flag-a/Size=64, Style=regular.svg": "6978",
	"./flag-b/Size=16, Style=light.svg": "4f59",
	"./flag-b/Size=16, Style=regular.svg": "837f",
	"./flag-b/Size=16, Style=solid.svg": "053e",
	"./flag-b/Size=20, Style=light.svg": "a623c",
	"./flag-b/Size=20, Style=regular.svg": "7bb2",
	"./flag-b/Size=20, Style=solid.svg": "75f2",
	"./flag-b/Size=24, Style=regular.svg": "1460",
	"./flag-b/Size=24, Style=solid.svg": "10eb",
	"./flag-b/Size=32, Style=regular.svg": "c55e",
	"./flag-b/Size=64, Style=regular.svg": "0813",
	"./folder-check/Size=16, Style=light.svg": "9851",
	"./folder-check/Size=16, Style=regular.svg": "b2b5",
	"./folder-check/Size=16, Style=solid.svg": "3ea5",
	"./folder-check/Size=20, Style=light.svg": "172f",
	"./folder-check/Size=20, Style=regular.svg": "aed0",
	"./folder-check/Size=20, Style=solid.svg": "acae",
	"./folder-check/Size=24, Style=regular.svg": "b996",
	"./folder-check/Size=24, Style=solid.svg": "ee79",
	"./folder-check/Size=32, Style=regular.svg": "3028",
	"./folder-check/Size=64, Style=regular.svg": "db05",
	"./folder-minus/Size=16, Style=light.svg": "2470",
	"./folder-minus/Size=16, Style=regular.svg": "3170",
	"./folder-minus/Size=16, Style=solid.svg": "4e72",
	"./folder-minus/Size=20, Style=light.svg": "fea6",
	"./folder-minus/Size=20, Style=regular.svg": "a195",
	"./folder-minus/Size=20, Style=solid.svg": "a777",
	"./folder-minus/Size=24, Style=regular.svg": "1af4",
	"./folder-minus/Size=24, Style=solid.svg": "6c55",
	"./folder-minus/Size=32, Style=regular.svg": "5f0c",
	"./folder-minus/Size=64, Style=regular.svg": "43a9",
	"./folder-plus/Size=16, Style=light.svg": "2751",
	"./folder-plus/Size=16, Style=regular.svg": "1b77",
	"./folder-plus/Size=16, Style=solid.svg": "a5dd",
	"./folder-plus/Size=20, Style=light.svg": "e6f4",
	"./folder-plus/Size=20, Style=regular.svg": "014a",
	"./folder-plus/Size=20, Style=solid.svg": "8d36",
	"./folder-plus/Size=24, Style=regular.svg": "e402",
	"./folder-plus/Size=24, Style=solid.svg": "e3e7",
	"./folder-plus/Size=32, Style=regular.svg": "9653",
	"./folder-plus/Size=64, Style=regular.svg": "f8d0",
	"./folder-shared/Size=16, Style=light.svg": "2ed5",
	"./folder-shared/Size=16, Style=regular.svg": "fcbc",
	"./folder-shared/Size=16, Style=solid.svg": "93ed",
	"./folder-shared/Size=20, Style=light.svg": "ad1c",
	"./folder-shared/Size=20, Style=regular.svg": "8f18",
	"./folder-shared/Size=20, Style=solid.svg": "b8a4",
	"./folder-shared/Size=24, Style=regular.svg": "f2ff",
	"./folder-shared/Size=24, Style=solid.svg": "8b5a",
	"./folder-shared/Size=32, Style=regular.svg": "a30c",
	"./folder-shared/Size=64, Style=regular.svg": "6737",
	"./folder-x/Size=16, Style=light.svg": "64a0",
	"./folder-x/Size=16, Style=regular.svg": "c74e",
	"./folder-x/Size=16, Style=solid.svg": "e47c",
	"./folder-x/Size=20, Style=light.svg": "6b32",
	"./folder-x/Size=20, Style=regular.svg": "53bc",
	"./folder-x/Size=20, Style=solid.svg": "2c76",
	"./folder-x/Size=24, Style=regular.svg": "ea28",
	"./folder-x/Size=24, Style=solid.svg": "0026",
	"./folder-x/Size=32, Style=regular.svg": "ecc1",
	"./folder-x/Size=64, Style=regular.svg": "3e5d",
	"./folder/Size=16, Style=light.svg": "6667",
	"./folder/Size=16, Style=regular.svg": "975c",
	"./folder/Size=16, Style=solid.svg": "1dc9",
	"./folder/Size=20, Style=light.svg": "b422",
	"./folder/Size=20, Style=regular.svg": "9f0b",
	"./folder/Size=20, Style=solid.svg": "55d13",
	"./folder/Size=24, Style=regular.svg": "dc0f",
	"./folder/Size=24, Style=solid.svg": "a67f",
	"./folder/Size=32, Style=regular.svg": "69df",
	"./folder/Size=64, Style=regular.svg": "e37c",
	"./folders/Size=16, Style=light.svg": "d2e27",
	"./folders/Size=16, Style=regular.svg": "4f20",
	"./folders/Size=16, Style=solid.svg": "c635",
	"./folders/Size=20, Style=light.svg": "e460",
	"./folders/Size=20, Style=regular.svg": "76c0",
	"./folders/Size=20, Style=solid.svg": "e17e",
	"./folders/Size=24, Style=regular.svg": "823a",
	"./folders/Size=24, Style=solid.svg": "9aa46",
	"./folders/Size=32, Style=regular.svg": "eda9",
	"./folders/Size=64, Style=regular.svg": "52c5",
	"./food-drink-alco-bottle-wine/Size=16, Style=light.svg": "5404",
	"./food-drink-alco-bottle-wine/Size=16, Style=regular.svg": "d5f0",
	"./food-drink-alco-bottle-wine/Size=16, Style=solid.svg": "16b1",
	"./food-drink-alco-bottle-wine/Size=20, Style=light.svg": "2f7e",
	"./food-drink-alco-bottle-wine/Size=20, Style=regular.svg": "d749",
	"./food-drink-alco-bottle-wine/Size=20, Style=solid.svg": "1631",
	"./food-drink-alco-bottle-wine/Size=24, Style=regular.svg": "baf4",
	"./food-drink-alco-bottle-wine/Size=24, Style=solid.svg": "117f",
	"./food-drink-alco-bottle-wine/Size=32, Style=regular.svg": "aab9",
	"./food-drink-alco-bottle-wine/Size=64, Style=regular.svg": "7158",
	"./food-drink-alco-glass-beer/Size=16, Style=light.svg": "3dfd",
	"./food-drink-alco-glass-beer/Size=16, Style=regular.svg": "0c28",
	"./food-drink-alco-glass-beer/Size=16, Style=solid.svg": "552f",
	"./food-drink-alco-glass-beer/Size=20, Style=light.svg": "dd82",
	"./food-drink-alco-glass-beer/Size=20, Style=regular.svg": "1bef",
	"./food-drink-alco-glass-beer/Size=20, Style=solid.svg": "087f",
	"./food-drink-alco-glass-beer/Size=24, Style=regular.svg": "1a7b",
	"./food-drink-alco-glass-beer/Size=24, Style=solid.svg": "be85",
	"./food-drink-alco-glass-beer/Size=32, Style=regular.svg": "5e16",
	"./food-drink-alco-glass-beer/Size=64, Style=regular.svg": "0c3b",
	"./food-drink-alco-glass-cocktail/Size=16, Style=light.svg": "7754",
	"./food-drink-alco-glass-cocktail/Size=16, Style=regular.svg": "9f38",
	"./food-drink-alco-glass-cocktail/Size=16, Style=solid.svg": "3b8c",
	"./food-drink-alco-glass-cocktail/Size=20, Style=light.svg": "0a57",
	"./food-drink-alco-glass-cocktail/Size=20, Style=regular.svg": "d6f7",
	"./food-drink-alco-glass-cocktail/Size=20, Style=solid.svg": "d2fc",
	"./food-drink-alco-glass-cocktail/Size=24, Style=regular.svg": "d6c0",
	"./food-drink-alco-glass-cocktail/Size=24, Style=solid.svg": "86f0",
	"./food-drink-alco-glass-cocktail/Size=32, Style=regular.svg": "c5c9",
	"./food-drink-alco-glass-cocktail/Size=64, Style=regular.svg": "158b",
	"./food-drink-alco-glass-wine/Size=16, Style=light.svg": "f387",
	"./food-drink-alco-glass-wine/Size=16, Style=regular.svg": "efda",
	"./food-drink-alco-glass-wine/Size=16, Style=solid.svg": "f8a7",
	"./food-drink-alco-glass-wine/Size=20, Style=light.svg": "d711",
	"./food-drink-alco-glass-wine/Size=20, Style=regular.svg": "f25d",
	"./food-drink-alco-glass-wine/Size=20, Style=solid.svg": "913f",
	"./food-drink-alco-glass-wine/Size=24, Style=regular.svg": "9882",
	"./food-drink-alco-glass-wine/Size=24, Style=solid.svg": "a0d2",
	"./food-drink-alco-glass-wine/Size=32, Style=regular.svg": "6613",
	"./food-drink-alco-glass-wine/Size=64, Style=regular.svg": "3b4f",
	"./food-drink-cup-hot/Size=16, Style=light.svg": "7e5a",
	"./food-drink-cup-hot/Size=16, Style=regular.svg": "83d4",
	"./food-drink-cup-hot/Size=16, Style=solid.svg": "fede",
	"./food-drink-cup-hot/Size=20, Style=light.svg": "0090",
	"./food-drink-cup-hot/Size=20, Style=regular.svg": "6ce3",
	"./food-drink-cup-hot/Size=20, Style=solid.svg": "99a83",
	"./food-drink-cup-hot/Size=24, Style=regular.svg": "d365",
	"./food-drink-cup-hot/Size=24, Style=solid.svg": "3dea",
	"./food-drink-cup-hot/Size=32, Style=regular.svg": "1ef4",
	"./food-drink-cup-hot/Size=64, Style=regular.svg": "2721",
	"./gov-ko-fss/Size=16, Style=light.svg": "2ca4",
	"./gov-ko-fss/Size=16, Style=regular.svg": "72f6",
	"./gov-ko-fss/Size=16, Style=solid.svg": "4b8b",
	"./gov-ko-fss/Size=20, Style=light.svg": "acc0",
	"./gov-ko-fss/Size=20, Style=regular.svg": "8bbd",
	"./gov-ko-fss/Size=20, Style=solid.svg": "8d8f",
	"./gov-ko-fss/Size=24, Style=regular.svg": "cc34",
	"./gov-ko-fss/Size=24, Style=solid.svg": "40ea",
	"./gov-ko-fss/Size=32, Style=regular.svg": "3daf",
	"./gov-ko-fss/Size=64, Style=regular.svg": "2974",
	"./gov-law-scales/Size=16, Style=light.svg": "17c5",
	"./gov-law-scales/Size=16, Style=regular.svg": "9c6e",
	"./gov-law-scales/Size=16, Style=solid.svg": "d8be",
	"./gov-law-scales/Size=20, Style=light.svg": "8b98",
	"./gov-law-scales/Size=20, Style=regular.svg": "8a63",
	"./gov-law-scales/Size=20, Style=solid.svg": "1cf1",
	"./gov-law-scales/Size=24, Style=regular.svg": "45a4",
	"./gov-law-scales/Size=24, Style=solid.svg": "1f62",
	"./gov-law-scales/Size=32, Style=regular.svg": "bdf5",
	"./gov-law-scales/Size=64, Style=regular.svg": "9860",
	"./hand-thumb-down/Size=16, Style=light.svg": "c1a0",
	"./hand-thumb-down/Size=16, Style=regular.svg": "bca7",
	"./hand-thumb-down/Size=16, Style=solid.svg": "6606",
	"./hand-thumb-down/Size=20, Style=light.svg": "d267",
	"./hand-thumb-down/Size=20, Style=regular.svg": "cd9e",
	"./hand-thumb-down/Size=20, Style=solid.svg": "64c4",
	"./hand-thumb-down/Size=24, Style=regular.svg": "1683",
	"./hand-thumb-down/Size=24, Style=solid.svg": "840d",
	"./hand-thumb-down/Size=32, Style=regular.svg": "7a38",
	"./hand-thumb-down/Size=64, Style=regular.svg": "56ff",
	"./hand-thumb-up/Size=16, Style=light.svg": "aa6c",
	"./hand-thumb-up/Size=16, Style=regular.svg": "81fb",
	"./hand-thumb-up/Size=16, Style=solid.svg": "f361",
	"./hand-thumb-up/Size=20, Style=light.svg": "9976",
	"./hand-thumb-up/Size=20, Style=regular.svg": "3c51",
	"./hand-thumb-up/Size=20, Style=solid.svg": "e0a0",
	"./hand-thumb-up/Size=24, Style=regular.svg": "dd0e",
	"./hand-thumb-up/Size=24, Style=solid.svg": "caa8",
	"./hand-thumb-up/Size=32, Style=regular.svg": "8451",
	"./hand-thumb-up/Size=64, Style=regular.svg": "767e",
	"./heart/Size=16, Style=light.svg": "fa5d",
	"./heart/Size=16, Style=regular.svg": "ce45",
	"./heart/Size=16, Style=solid.svg": "c4e1",
	"./heart/Size=20, Style=light.svg": "b5de",
	"./heart/Size=20, Style=regular.svg": "76b8",
	"./heart/Size=20, Style=solid.svg": "3d47",
	"./heart/Size=24, Style=regular.svg": "08f4",
	"./heart/Size=24, Style=solid.svg": "0b0f",
	"./heart/Size=32, Style=regular.svg": "9f48",
	"./heart/Size=64, Style=regular.svg": "e93e",
	"./id-card/Size=16, Style=light.svg": "699b",
	"./id-card/Size=16, Style=regular.svg": "5531",
	"./id-card/Size=16, Style=solid.svg": "b833",
	"./id-card/Size=20, Style=light.svg": "60d6",
	"./id-card/Size=20, Style=regular.svg": "7f9a",
	"./id-card/Size=20, Style=solid.svg": "f927",
	"./id-card/Size=24, Style=regular.svg": "9f8c",
	"./id-card/Size=24, Style=solid.svg": "9dbe",
	"./id-card/Size=32, Style=regular.svg": "bad1",
	"./id-card/Size=64, Style=regular.svg": "f8f6",
	"./info-circle/Size=16, Style=light.svg": "de8e",
	"./info-circle/Size=16, Style=regular.svg": "12a3",
	"./info-circle/Size=16, Style=solid.svg": "5ef2",
	"./info-circle/Size=20, Style=light.svg": "e3306",
	"./info-circle/Size=20, Style=regular.svg": "feaf",
	"./info-circle/Size=20, Style=solid.svg": "c554",
	"./info-circle/Size=24, Style=regular.svg": "b838",
	"./info-circle/Size=24, Style=solid.svg": "e6b70",
	"./info-circle/Size=32, Style=regular.svg": "8963",
	"./info-circle/Size=64, Style=regular.svg": "544c",
	"./info-square/Size=16, Style=light.svg": "f082",
	"./info-square/Size=16, Style=regular.svg": "ec39",
	"./info-square/Size=16, Style=solid.svg": "8f3b",
	"./info-square/Size=20, Style=light.svg": "776a",
	"./info-square/Size=20, Style=regular.svg": "d8bc",
	"./info-square/Size=20, Style=solid.svg": "6ab3",
	"./info-square/Size=24, Style=regular.svg": "be41",
	"./info-square/Size=24, Style=solid.svg": "b81a",
	"./info-square/Size=32, Style=regular.svg": "9e83",
	"./info-square/Size=64, Style=regular.svg": "91f6",
	"./jewel-crown/Size=16, Style=light.svg": "552b",
	"./jewel-crown/Size=16, Style=regular.svg": "69bf",
	"./jewel-crown/Size=16, Style=solid.svg": "cafc",
	"./jewel-crown/Size=20, Style=light.svg": "be8c",
	"./jewel-crown/Size=20, Style=regular.svg": "074b",
	"./jewel-crown/Size=20, Style=solid.svg": "e955",
	"./jewel-crown/Size=24, Style=regular.svg": "ee25",
	"./jewel-crown/Size=24, Style=solid.svg": "faa1",
	"./jewel-crown/Size=32, Style=regular.svg": "e648",
	"./jewel-crown/Size=64, Style=regular.svg": "8d87",
	"./kontur-mercury/Size=16, Style=light.svg": "b9b3",
	"./kontur-mercury/Size=16, Style=regular.svg": "7dfd",
	"./kontur-mercury/Size=16, Style=solid.svg": "67ab",
	"./kontur-mercury/Size=20, Style=light.svg": "d32e",
	"./kontur-mercury/Size=20, Style=regular.svg": "ec3e",
	"./kontur-mercury/Size=20, Style=solid.svg": "3cd0",
	"./kontur-mercury/Size=24, Style=regular.svg": "32ac",
	"./kontur-mercury/Size=24, Style=solid.svg": "7dd7",
	"./kontur-mercury/Size=32, Style=regular.svg": "add6",
	"./kontur-mercury/Size=64, Style=regular.svg": "9873",
	"./lightbulb-on/Size=16, Style=light.svg": "0ad2",
	"./lightbulb-on/Size=16, Style=regular.svg": "a15d",
	"./lightbulb-on/Size=16, Style=solid.svg": "70a3",
	"./lightbulb-on/Size=20, Style=light.svg": "37bb6",
	"./lightbulb-on/Size=20, Style=regular.svg": "bb97",
	"./lightbulb-on/Size=20, Style=solid.svg": "d5f7",
	"./lightbulb-on/Size=24, Style=regular.svg": "7a72",
	"./lightbulb-on/Size=24, Style=solid.svg": "6e6b",
	"./lightbulb-on/Size=32, Style=regular.svg": "af49",
	"./lightbulb-on/Size=64, Style=regular.svg": "b8ac",
	"./lightbulb/Size=16, Style=light.svg": "9a9a",
	"./lightbulb/Size=16, Style=regular.svg": "b0c08",
	"./lightbulb/Size=16, Style=solid.svg": "f657",
	"./lightbulb/Size=20, Style=light.svg": "5777",
	"./lightbulb/Size=20, Style=regular.svg": "afba",
	"./lightbulb/Size=20, Style=solid.svg": "4d0b",
	"./lightbulb/Size=24, Style=regular.svg": "396f",
	"./lightbulb/Size=24, Style=solid.svg": "2668",
	"./lightbulb/Size=32, Style=regular.svg": "3ac1",
	"./lightbulb/Size=64, Style=regular.svg": "101c",
	"./location-globe/Size=16, Style=light.svg": "234b",
	"./location-globe/Size=16, Style=regular.svg": "aea6",
	"./location-globe/Size=16, Style=solid.svg": "29e6",
	"./location-globe/Size=20, Style=light.svg": "9f3a",
	"./location-globe/Size=20, Style=regular.svg": "8536",
	"./location-globe/Size=20, Style=solid.svg": "1304",
	"./location-globe/Size=24, Style=regular.svg": "cf17",
	"./location-globe/Size=24, Style=solid.svg": "d62a",
	"./location-globe/Size=32, Style=regular.svg": "9525",
	"./location-globe/Size=64, Style=regular.svg": "6834",
	"./location-pin/Size=16, Style=light.svg": "b402",
	"./location-pin/Size=16, Style=regular.svg": "8715",
	"./location-pin/Size=16, Style=solid.svg": "14cc",
	"./location-pin/Size=20, Style=light.svg": "740b",
	"./location-pin/Size=20, Style=regular.svg": "2c80",
	"./location-pin/Size=20, Style=solid.svg": "ba48",
	"./location-pin/Size=24, Style=regular.svg": "9515",
	"./location-pin/Size=24, Style=solid.svg": "4784",
	"./location-pin/Size=32, Style=regular.svg": "261c",
	"./location-pin/Size=64, Style=regular.svg": "1698",
	"./logo-facebook/Size=16, Style=light.svg": "4f46",
	"./logo-facebook/Size=16, Style=regular.svg": "c3c8",
	"./logo-facebook/Size=16, Style=solid.svg": "2bf7c",
	"./logo-facebook/Size=20, Style=light.svg": "287c",
	"./logo-facebook/Size=20, Style=regular.svg": "9512",
	"./logo-facebook/Size=20, Style=solid.svg": "180c",
	"./logo-facebook/Size=24, Style=regular.svg": "9687",
	"./logo-facebook/Size=24, Style=solid.svg": "0ddc",
	"./logo-facebook/Size=32, Style=regular.svg": "cda3",
	"./logo-facebook/Size=64, Style=regular.svg": "63f0",
	"./logo-instagram/Size=16, Style=light.svg": "365f",
	"./logo-instagram/Size=16, Style=regular.svg": "006d",
	"./logo-instagram/Size=16, Style=solid.svg": "11ae",
	"./logo-instagram/Size=20, Style=light.svg": "4707",
	"./logo-instagram/Size=20, Style=regular.svg": "e82c",
	"./logo-instagram/Size=20, Style=solid.svg": "4d09",
	"./logo-instagram/Size=24, Style=regular.svg": "9181",
	"./logo-instagram/Size=24, Style=solid.svg": "824b4",
	"./logo-instagram/Size=32, Style=regular.svg": "26a3",
	"./logo-instagram/Size=64, Style=regular.svg": "37a6",
	"./logo-ok/Size=16, Style=light.svg": "26cc",
	"./logo-ok/Size=16, Style=regular.svg": "63a2",
	"./logo-ok/Size=16, Style=solid.svg": "1d34",
	"./logo-ok/Size=20, Style=light.svg": "ce65",
	"./logo-ok/Size=20, Style=regular.svg": "e37a",
	"./logo-ok/Size=20, Style=solid.svg": "dd7c",
	"./logo-ok/Size=24, Style=regular.svg": "c87f",
	"./logo-ok/Size=24, Style=solid.svg": "b230",
	"./logo-ok/Size=32, Style=regular.svg": "b89d",
	"./logo-ok/Size=64, Style=regular.svg": "1cd7",
	"./logo-telegram/Size=16, Style=light.svg": "6eec",
	"./logo-telegram/Size=16, Style=regular.svg": "3751",
	"./logo-telegram/Size=16, Style=solid.svg": "41e0",
	"./logo-telegram/Size=20, Style=light.svg": "f9fb",
	"./logo-telegram/Size=20, Style=regular.svg": "8cd7",
	"./logo-telegram/Size=20, Style=solid.svg": "0023",
	"./logo-telegram/Size=24, Style=regular.svg": "d579",
	"./logo-telegram/Size=24, Style=solid.svg": "3a54",
	"./logo-telegram/Size=32, Style=regular.svg": "fc00",
	"./logo-telegram/Size=64, Style=regular.svg": "0dae",
	"./logo-twitter/Size=16, Style=light.svg": "65c6",
	"./logo-twitter/Size=16, Style=regular.svg": "e503",
	"./logo-twitter/Size=16, Style=solid.svg": "41f0",
	"./logo-twitter/Size=20, Style=light.svg": "3777",
	"./logo-twitter/Size=20, Style=regular.svg": "c531",
	"./logo-twitter/Size=20, Style=solid.svg": "7d75",
	"./logo-twitter/Size=24, Style=regular.svg": "8ef3",
	"./logo-twitter/Size=24, Style=solid.svg": "cbe1",
	"./logo-twitter/Size=32, Style=regular.svg": "2e1f",
	"./logo-twitter/Size=64, Style=regular.svg": "c3ff",
	"./logo-viber/Size=16, Style=light.svg": "05b3",
	"./logo-viber/Size=16, Style=regular.svg": "6363",
	"./logo-viber/Size=16, Style=solid.svg": "86f4",
	"./logo-viber/Size=20, Style=light.svg": "87a0",
	"./logo-viber/Size=20, Style=regular.svg": "8307",
	"./logo-viber/Size=20, Style=solid.svg": "d466",
	"./logo-viber/Size=24, Style=regular.svg": "265a",
	"./logo-viber/Size=24, Style=solid.svg": "a76d",
	"./logo-viber/Size=32, Style=regular.svg": "93fc",
	"./logo-viber/Size=64, Style=regular.svg": "9fb0",
	"./logo-vk/Size=16, Style=light.svg": "b8df",
	"./logo-vk/Size=16, Style=regular.svg": "1b65",
	"./logo-vk/Size=16, Style=solid.svg": "3ca2",
	"./logo-vk/Size=20, Style=light.svg": "0b8e",
	"./logo-vk/Size=20, Style=regular.svg": "7ecc",
	"./logo-vk/Size=20, Style=solid.svg": "f281",
	"./logo-vk/Size=24, Style=regular.svg": "92df",
	"./logo-vk/Size=24, Style=solid.svg": "bed0",
	"./logo-vk/Size=32, Style=regular.svg": "196a",
	"./logo-vk/Size=64, Style=regular.svg": "55e2",
	"./logo-whatsapp/Size=16, Style=light.svg": "75ff",
	"./logo-whatsapp/Size=16, Style=regular.svg": "cfdf",
	"./logo-whatsapp/Size=16, Style=solid.svg": "dad6",
	"./logo-whatsapp/Size=20, Style=light.svg": "a81c",
	"./logo-whatsapp/Size=20, Style=regular.svg": "806a",
	"./logo-whatsapp/Size=20, Style=solid.svg": "6f32",
	"./logo-whatsapp/Size=24, Style=regular.svg": "3ab1",
	"./logo-whatsapp/Size=24, Style=solid.svg": "9565",
	"./logo-whatsapp/Size=32, Style=regular.svg": "1dc1",
	"./logo-whatsapp/Size=64, Style=regular.svg": "a1fd",
	"./logo-yandex-zen/Size=16, Style=light.svg": "3fb6",
	"./logo-yandex-zen/Size=16, Style=regular.svg": "4653",
	"./logo-yandex-zen/Size=16, Style=solid.svg": "ae9c",
	"./logo-yandex-zen/Size=20, Style=light.svg": "0054",
	"./logo-yandex-zen/Size=20, Style=regular.svg": "e2b8",
	"./logo-yandex-zen/Size=20, Style=solid.svg": "1ccf",
	"./logo-yandex-zen/Size=24, Style=regular.svg": "e95a2",
	"./logo-yandex-zen/Size=24, Style=solid.svg": "2322",
	"./logo-yandex-zen/Size=32, Style=regular.svg": "a15f",
	"./logo-yandex-zen/Size=64, Style=regular.svg": "46ad",
	"./logo-youtube/Size=16, Style=light.svg": "81e4",
	"./logo-youtube/Size=16, Style=regular.svg": "10a32",
	"./logo-youtube/Size=16, Style=solid.svg": "6307",
	"./logo-youtube/Size=20, Style=light.svg": "0b2f",
	"./logo-youtube/Size=20, Style=regular.svg": "00c2d",
	"./logo-youtube/Size=20, Style=solid.svg": "4d4f",
	"./logo-youtube/Size=24, Style=regular.svg": "2b16",
	"./logo-youtube/Size=24, Style=solid.svg": "1670",
	"./logo-youtube/Size=32, Style=regular.svg": "3040",
	"./logo-youtube/Size=64, Style=regular.svg": "b345",
	"./mail-arrow-in/Size=16, Style=light.svg": "ab45",
	"./mail-arrow-in/Size=16, Style=regular.svg": "5aa3",
	"./mail-arrow-in/Size=16, Style=solid.svg": "6a42",
	"./mail-arrow-in/Size=20, Style=light.svg": "bbfa",
	"./mail-arrow-in/Size=20, Style=regular.svg": "31e5",
	"./mail-arrow-in/Size=20, Style=solid.svg": "1610",
	"./mail-arrow-in/Size=24, Style=regular.svg": "9c5b",
	"./mail-arrow-in/Size=24, Style=solid.svg": "51ee",
	"./mail-arrow-in/Size=32, Style=regular.svg": "1c06",
	"./mail-arrow-in/Size=64, Style=regular.svg": "9d7f",
	"./mail-arrow-out/Size=16, Style=light.svg": "a368",
	"./mail-arrow-out/Size=16, Style=regular.svg": "c499",
	"./mail-arrow-out/Size=16, Style=solid.svg": "401f",
	"./mail-arrow-out/Size=20, Style=light.svg": "1b4e",
	"./mail-arrow-out/Size=20, Style=regular.svg": "4e6b",
	"./mail-arrow-out/Size=20, Style=solid.svg": "af8e",
	"./mail-arrow-out/Size=24, Style=regular.svg": "d248",
	"./mail-arrow-out/Size=24, Style=solid.svg": "f7b8",
	"./mail-arrow-out/Size=32, Style=regular.svg": "6b80",
	"./mail-arrow-out/Size=64, Style=regular.svg": "5d6b",
	"./mail/Size=16, Style=light.svg": "9de6",
	"./mail/Size=16, Style=regular.svg": "1a19",
	"./mail/Size=16, Style=solid.svg": "0559",
	"./mail/Size=20, Style=light.svg": "0b7a2",
	"./mail/Size=20, Style=regular.svg": "6fe6",
	"./mail/Size=20, Style=solid.svg": "9177",
	"./mail/Size=24, Style=regular.svg": "4bb7",
	"./mail/Size=24, Style=solid.svg": "5a0e",
	"./mail/Size=32, Style=regular.svg": "b7d3",
	"./mail/Size=64, Style=regular.svg": "dc3d",
	"./market-receipt/Size=16, Style=light.svg": "7351",
	"./market-receipt/Size=16, Style=regular.svg": "773a",
	"./market-receipt/Size=16, Style=solid.svg": "4c08",
	"./market-receipt/Size=20, Style=light.svg": "8888",
	"./market-receipt/Size=20, Style=regular.svg": "c015",
	"./market-receipt/Size=20, Style=solid.svg": "8cbd",
	"./market-receipt/Size=24, Style=regular.svg": "bb6c",
	"./market-receipt/Size=24, Style=solid.svg": "06a6",
	"./market-receipt/Size=32, Style=regular.svg": "fa2c",
	"./market-receipt/Size=64, Style=regular.svg": "9a26",
	"./market-register-classic/Size=16, Style=light.svg": "c8fc",
	"./market-register-classic/Size=16, Style=regular.svg": "9c2b",
	"./market-register-classic/Size=16, Style=solid.svg": "11dc",
	"./market-register-classic/Size=20, Style=light.svg": "66b7",
	"./market-register-classic/Size=20, Style=regular.svg": "c7c9",
	"./market-register-classic/Size=20, Style=solid.svg": "2288",
	"./market-register-classic/Size=24, Style=regular.svg": "31fd",
	"./market-register-classic/Size=24, Style=solid.svg": "6e88",
	"./market-register-classic/Size=32, Style=regular.svg": "bf75",
	"./market-register-classic/Size=64, Style=regular.svg": "db77",
	"./market-shopping-basket/Size=16, Style=light.svg": "a5e7",
	"./market-shopping-basket/Size=16, Style=regular.svg": "8646",
	"./market-shopping-basket/Size=16, Style=solid.svg": "122d",
	"./market-shopping-basket/Size=20, Style=light.svg": "fafe",
	"./market-shopping-basket/Size=20, Style=regular.svg": "5f26",
	"./market-shopping-basket/Size=20, Style=solid.svg": "9b8f",
	"./market-shopping-basket/Size=24, Style=regular.svg": "7311",
	"./market-shopping-basket/Size=24, Style=solid.svg": "5c91",
	"./market-shopping-basket/Size=32, Style=regular.svg": "61ce",
	"./market-shopping-basket/Size=64, Style=regular.svg": "c627",
	"./market-shopping-cart/Size=16, Style=light.svg": "0a79",
	"./market-shopping-cart/Size=16, Style=regular.svg": "98f4",
	"./market-shopping-cart/Size=16, Style=solid.svg": "9b3d",
	"./market-shopping-cart/Size=20, Style=light.svg": "1c66",
	"./market-shopping-cart/Size=20, Style=regular.svg": "ec2f",
	"./market-shopping-cart/Size=20, Style=solid.svg": "0b45",
	"./market-shopping-cart/Size=24, Style=regular.svg": "780f",
	"./market-shopping-cart/Size=24, Style=solid.svg": "c94e",
	"./market-shopping-cart/Size=32, Style=regular.svg": "58e1",
	"./market-shopping-cart/Size=64, Style=regular.svg": "7da0",
	"./math-delta/Size=16, Style=light.svg": "0da7",
	"./math-delta/Size=16, Style=regular.svg": "db94",
	"./math-delta/Size=16, Style=solid.svg": "a1cc",
	"./math-delta/Size=20, Style=light.svg": "d39d",
	"./math-delta/Size=20, Style=regular.svg": "2f9f",
	"./math-delta/Size=20, Style=solid.svg": "bf7c",
	"./math-delta/Size=24, Style=regular.svg": "db82",
	"./math-delta/Size=24, Style=solid.svg": "e481",
	"./math-delta/Size=32, Style=regular.svg": "0c97",
	"./math-delta/Size=64, Style=regular.svg": "a9e6",
	"./math-function-off/Size=16, Style=light.svg": "b405",
	"./math-function-off/Size=16, Style=regular.svg": "58ab",
	"./math-function-off/Size=16, Style=solid.svg": "1699",
	"./math-function-off/Size=20, Style=light.svg": "3aa8",
	"./math-function-off/Size=20, Style=regular.svg": "d095",
	"./math-function-off/Size=20, Style=solid.svg": "39a3",
	"./math-function-off/Size=24, Style=regular.svg": "9807",
	"./math-function-off/Size=24, Style=solid.svg": "7a8e",
	"./math-function-off/Size=32, Style=regular.svg": "6745",
	"./math-function-off/Size=64, Style=regular.svg": "f840",
	"./math-function/Size=16, Style=light.svg": "e1ea",
	"./math-function/Size=16, Style=regular.svg": "882c",
	"./math-function/Size=16, Style=solid.svg": "db69",
	"./math-function/Size=20, Style=light.svg": "98fb",
	"./math-function/Size=20, Style=regular.svg": "98ae",
	"./math-function/Size=20, Style=solid.svg": "e1fd",
	"./math-function/Size=24, Style=regular.svg": "49436",
	"./math-function/Size=24, Style=solid.svg": "19a1",
	"./math-function/Size=32, Style=regular.svg": "cb7a",
	"./math-function/Size=64, Style=regular.svg": "841f1",
	"./math-infinity/Size=16, Style=light.svg": "e9bb",
	"./math-infinity/Size=16, Style=regular.svg": "2475",
	"./math-infinity/Size=16, Style=solid.svg": "5172",
	"./math-infinity/Size=20, Style=light.svg": "c30d",
	"./math-infinity/Size=20, Style=regular.svg": "2c53",
	"./math-infinity/Size=20, Style=solid.svg": "4de7",
	"./math-infinity/Size=24, Style=regular.svg": "5e8f",
	"./math-infinity/Size=24, Style=solid.svg": "108f",
	"./math-infinity/Size=32, Style=regular.svg": "9071",
	"./math-infinity/Size=64, Style=regular.svg": "9344",
	"./math-sum/Size=16, Style=light.svg": "0e77",
	"./math-sum/Size=16, Style=regular.svg": "8315",
	"./math-sum/Size=16, Style=solid.svg": "d4c30",
	"./math-sum/Size=20, Style=light.svg": "da8b",
	"./math-sum/Size=20, Style=regular.svg": "687a",
	"./math-sum/Size=20, Style=solid.svg": "2a67",
	"./math-sum/Size=24, Style=regular.svg": "0e83",
	"./math-sum/Size=24, Style=solid.svg": "23b8",
	"./math-sum/Size=32, Style=regular.svg": "14ed4",
	"./math-sum/Size=64, Style=regular.svg": "10a7",
	"./med-briefcase/Size=16, Style=light.svg": "205b",
	"./med-briefcase/Size=16, Style=regular.svg": "c008",
	"./med-briefcase/Size=16, Style=solid.svg": "b529",
	"./med-briefcase/Size=20, Style=light.svg": "8164",
	"./med-briefcase/Size=20, Style=regular.svg": "637e",
	"./med-briefcase/Size=20, Style=solid.svg": "69ec",
	"./med-briefcase/Size=24, Style=regular.svg": "ec28",
	"./med-briefcase/Size=24, Style=solid.svg": "4637",
	"./med-briefcase/Size=32, Style=regular.svg": "87f1",
	"./med-briefcase/Size=64, Style=regular.svg": "f942",
	"./media-audio-headphones/Size=16, Style=light.svg": "476a",
	"./media-audio-headphones/Size=16, Style=regular.svg": "52b8",
	"./media-audio-headphones/Size=16, Style=solid.svg": "6943",
	"./media-audio-headphones/Size=20, Style=light.svg": "1e5a",
	"./media-audio-headphones/Size=20, Style=regular.svg": "a1a2",
	"./media-audio-headphones/Size=20, Style=solid.svg": "f97a",
	"./media-audio-headphones/Size=24, Style=regular.svg": "df41",
	"./media-audio-headphones/Size=24, Style=solid.svg": "a234",
	"./media-audio-headphones/Size=32, Style=regular.svg": "b290",
	"./media-audio-headphones/Size=64, Style=regular.svg": "cc0a",
	"./media-audio-headset/Size=16, Style=light.svg": "4df8",
	"./media-audio-headset/Size=16, Style=regular.svg": "7b49",
	"./media-audio-headset/Size=16, Style=solid.svg": "47543",
	"./media-audio-headset/Size=20, Style=light.svg": "c0f9",
	"./media-audio-headset/Size=20, Style=regular.svg": "e83c",
	"./media-audio-headset/Size=20, Style=solid.svg": "4c24",
	"./media-audio-headset/Size=24, Style=regular.svg": "7e63",
	"./media-audio-headset/Size=24, Style=solid.svg": "be74",
	"./media-audio-headset/Size=32, Style=regular.svg": "a352",
	"./media-audio-headset/Size=64, Style=regular.svg": "2bf0",
	"./media-picture/Size=16, Style=light.svg": "6c17",
	"./media-picture/Size=16, Style=regular.svg": "f9bf",
	"./media-picture/Size=16, Style=solid.svg": "f2cc",
	"./media-picture/Size=20, Style=light.svg": "54bf",
	"./media-picture/Size=20, Style=regular.svg": "58de",
	"./media-picture/Size=20, Style=solid.svg": "36be",
	"./media-picture/Size=24, Style=regular.svg": "6ca4",
	"./media-picture/Size=24, Style=solid.svg": "9684",
	"./media-picture/Size=32, Style=regular.svg": "7297",
	"./media-picture/Size=64, Style=regular.svg": "98f1",
	"./media-ui-a-eject/Size=16, Style=light.svg": "c4d1d",
	"./media-ui-a-eject/Size=16, Style=regular.svg": "585f",
	"./media-ui-a-eject/Size=16, Style=solid.svg": "b3c6",
	"./media-ui-a-eject/Size=20, Style=light.svg": "4f1a",
	"./media-ui-a-eject/Size=20, Style=regular.svg": "23ba",
	"./media-ui-a-eject/Size=20, Style=solid.svg": "2cde",
	"./media-ui-a-eject/Size=24, Style=regular.svg": "7b1d",
	"./media-ui-a-eject/Size=24, Style=solid.svg": "a175",
	"./media-ui-a-eject/Size=32, Style=regular.svg": "0da8",
	"./media-ui-a-eject/Size=64, Style=regular.svg": "3977",
	"./media-ui-a-pause-shape/Size=16, Style=light.svg": "4b7f",
	"./media-ui-a-pause-shape/Size=16, Style=regular.svg": "05b39",
	"./media-ui-a-pause-shape/Size=16, Style=solid.svg": "50c3",
	"./media-ui-a-pause-shape/Size=20, Style=light.svg": "09e1",
	"./media-ui-a-pause-shape/Size=20, Style=regular.svg": "39f6",
	"./media-ui-a-pause-shape/Size=20, Style=solid.svg": "9587",
	"./media-ui-a-pause-shape/Size=24, Style=regular.svg": "15b7",
	"./media-ui-a-pause-shape/Size=24, Style=solid.svg": "469a",
	"./media-ui-a-pause-shape/Size=32, Style=regular.svg": "aae5",
	"./media-ui-a-pause-shape/Size=64, Style=regular.svg": "0fd8",
	"./media-ui-a-pause/Size=16, Style=light.svg": "93a3",
	"./media-ui-a-pause/Size=16, Style=regular.svg": "6221",
	"./media-ui-a-pause/Size=16, Style=solid.svg": "01df",
	"./media-ui-a-pause/Size=20, Style=light.svg": "3506",
	"./media-ui-a-pause/Size=20, Style=regular.svg": "cb0d",
	"./media-ui-a-pause/Size=20, Style=solid.svg": "40b5",
	"./media-ui-a-pause/Size=24, Style=regular.svg": "9fb3",
	"./media-ui-a-pause/Size=24, Style=solid.svg": "a8ad",
	"./media-ui-a-pause/Size=32, Style=regular.svg": "1f1f",
	"./media-ui-a-pause/Size=64, Style=regular.svg": "5538",
	"./media-ui-a-play-forward/Size=16, Style=light.svg": "8e7b",
	"./media-ui-a-play-forward/Size=16, Style=regular.svg": "cd3a",
	"./media-ui-a-play-forward/Size=16, Style=solid.svg": "691b",
	"./media-ui-a-play-forward/Size=20, Style=light.svg": "4031c",
	"./media-ui-a-play-forward/Size=20, Style=regular.svg": "7439",
	"./media-ui-a-play-forward/Size=20, Style=solid.svg": "2067",
	"./media-ui-a-play-forward/Size=24, Style=regular.svg": "3741",
	"./media-ui-a-play-forward/Size=24, Style=solid.svg": "6438",
	"./media-ui-a-play-forward/Size=32, Style=regular.svg": "62be",
	"./media-ui-a-play-forward/Size=64, Style=regular.svg": "c30b",
	"./media-ui-a-play-pause/Size=16, Style=light.svg": "327e",
	"./media-ui-a-play-pause/Size=16, Style=regular.svg": "4e1d",
	"./media-ui-a-play-pause/Size=16, Style=solid.svg": "1b9a",
	"./media-ui-a-play-pause/Size=20, Style=light.svg": "c7bc",
	"./media-ui-a-play-pause/Size=20, Style=regular.svg": "27bd",
	"./media-ui-a-play-pause/Size=20, Style=solid.svg": "b160",
	"./media-ui-a-play-pause/Size=24, Style=regular.svg": "7cb7",
	"./media-ui-a-play-pause/Size=24, Style=solid.svg": "5d27",
	"./media-ui-a-play-pause/Size=32, Style=regular.svg": "a90a",
	"./media-ui-a-play-pause/Size=64, Style=regular.svg": "7c8d",
	"./media-ui-a-play/Size=16, Style=light.svg": "ec3f",
	"./media-ui-a-play/Size=16, Style=regular.svg": "c7b9",
	"./media-ui-a-play/Size=16, Style=solid.svg": "2f88",
	"./media-ui-a-play/Size=20, Style=light.svg": "58dc",
	"./media-ui-a-play/Size=20, Style=regular.svg": "4d8c",
	"./media-ui-a-play/Size=20, Style=solid.svg": "d6cb",
	"./media-ui-a-play/Size=24, Style=regular.svg": "37d6",
	"./media-ui-a-play/Size=24, Style=solid.svg": "730b",
	"./media-ui-a-play/Size=32, Style=regular.svg": "0ce3",
	"./media-ui-a-play/Size=64, Style=regular.svg": "55a1",
	"./media-ui-a-record/Size=16, Style=light.svg": "3f0b",
	"./media-ui-a-record/Size=16, Style=regular.svg": "68a5",
	"./media-ui-a-record/Size=16, Style=solid.svg": "3050",
	"./media-ui-a-record/Size=20, Style=light.svg": "27f3",
	"./media-ui-a-record/Size=20, Style=regular.svg": "6564",
	"./media-ui-a-record/Size=20, Style=solid.svg": "ff93",
	"./media-ui-a-record/Size=24, Style=regular.svg": "b045",
	"./media-ui-a-record/Size=24, Style=solid.svg": "f055",
	"./media-ui-a-record/Size=32, Style=regular.svg": "f936",
	"./media-ui-a-record/Size=64, Style=regular.svg": "b39e",
	"./media-ui-a-rewind-back/Size=16, Style=light.svg": "5259",
	"./media-ui-a-rewind-back/Size=16, Style=regular.svg": "1bb0",
	"./media-ui-a-rewind-back/Size=16, Style=solid.svg": "7fda",
	"./media-ui-a-rewind-back/Size=20, Style=light.svg": "5587",
	"./media-ui-a-rewind-back/Size=20, Style=regular.svg": "f12d",
	"./media-ui-a-rewind-back/Size=20, Style=solid.svg": "3469",
	"./media-ui-a-rewind-back/Size=24, Style=regular.svg": "19f2",
	"./media-ui-a-rewind-back/Size=24, Style=solid.svg": "2ac0",
	"./media-ui-a-rewind-back/Size=32, Style=regular.svg": "0023c",
	"./media-ui-a-rewind-back/Size=64, Style=regular.svg": "265c",
	"./media-ui-a-rewind-forward/Size=16, Style=light.svg": "4f68",
	"./media-ui-a-rewind-forward/Size=16, Style=regular.svg": "8b27",
	"./media-ui-a-rewind-forward/Size=16, Style=solid.svg": "00b9",
	"./media-ui-a-rewind-forward/Size=20, Style=light.svg": "d375",
	"./media-ui-a-rewind-forward/Size=20, Style=regular.svg": "9908",
	"./media-ui-a-rewind-forward/Size=20, Style=solid.svg": "47252",
	"./media-ui-a-rewind-forward/Size=24, Style=regular.svg": "01ea",
	"./media-ui-a-rewind-forward/Size=24, Style=solid.svg": "6481",
	"./media-ui-a-rewind-forward/Size=32, Style=regular.svg": "3469e",
	"./media-ui-a-rewind-forward/Size=64, Style=regular.svg": "a919",
	"./media-ui-a-skip-back/Size=16, Style=light.svg": "5721",
	"./media-ui-a-skip-back/Size=16, Style=regular.svg": "9e22",
	"./media-ui-a-skip-back/Size=16, Style=solid.svg": "2499",
	"./media-ui-a-skip-back/Size=20, Style=light.svg": "8cb4",
	"./media-ui-a-skip-back/Size=20, Style=regular.svg": "807d",
	"./media-ui-a-skip-back/Size=20, Style=solid.svg": "f270",
	"./media-ui-a-skip-back/Size=24, Style=regular.svg": "9638",
	"./media-ui-a-skip-back/Size=24, Style=solid.svg": "38f1",
	"./media-ui-a-skip-back/Size=32, Style=regular.svg": "b068",
	"./media-ui-a-skip-back/Size=64, Style=regular.svg": "0140",
	"./media-ui-a-skip-forward/Size=16, Style=light.svg": "2f66",
	"./media-ui-a-skip-forward/Size=16, Style=regular.svg": "7f80",
	"./media-ui-a-skip-forward/Size=16, Style=solid.svg": "a0e4",
	"./media-ui-a-skip-forward/Size=20, Style=light.svg": "da0e",
	"./media-ui-a-skip-forward/Size=20, Style=regular.svg": "45da",
	"./media-ui-a-skip-forward/Size=20, Style=solid.svg": "bde5",
	"./media-ui-a-skip-forward/Size=24, Style=regular.svg": "9328",
	"./media-ui-a-skip-forward/Size=24, Style=solid.svg": "521b",
	"./media-ui-a-skip-forward/Size=32, Style=regular.svg": "6d33",
	"./media-ui-a-skip-forward/Size=64, Style=regular.svg": "f381",
	"./media-ui-a-skip-two-back/Size=16, Style=light.svg": "21cf",
	"./media-ui-a-skip-two-back/Size=16, Style=regular.svg": "df22",
	"./media-ui-a-skip-two-back/Size=16, Style=solid.svg": "355b",
	"./media-ui-a-skip-two-back/Size=20, Style=light.svg": "d734",
	"./media-ui-a-skip-two-back/Size=20, Style=regular.svg": "6340",
	"./media-ui-a-skip-two-back/Size=20, Style=solid.svg": "4fae",
	"./media-ui-a-skip-two-back/Size=24, Style=regular.svg": "9bd9",
	"./media-ui-a-skip-two-back/Size=24, Style=solid.svg": "1aed",
	"./media-ui-a-skip-two-back/Size=32, Style=regular.svg": "b9f7",
	"./media-ui-a-skip-two-back/Size=64, Style=regular.svg": "b542",
	"./media-ui-a-skip-two-forward/Size=16, Style=light.svg": "26be",
	"./media-ui-a-skip-two-forward/Size=16, Style=regular.svg": "3a71",
	"./media-ui-a-skip-two-forward/Size=16, Style=solid.svg": "7141",
	"./media-ui-a-skip-two-forward/Size=20, Style=light.svg": "f0a2",
	"./media-ui-a-skip-two-forward/Size=20, Style=regular.svg": "1b50",
	"./media-ui-a-skip-two-forward/Size=20, Style=solid.svg": "95a3",
	"./media-ui-a-skip-two-forward/Size=24, Style=regular.svg": "a3ce",
	"./media-ui-a-skip-two-forward/Size=24, Style=solid.svg": "b854",
	"./media-ui-a-skip-two-forward/Size=32, Style=regular.svg": "fa83",
	"./media-ui-a-skip-two-forward/Size=64, Style=regular.svg": "497b",
	"./media-ui-a-stop/Size=16, Style=light.svg": "4e20",
	"./media-ui-a-stop/Size=16, Style=regular.svg": "5a0b",
	"./media-ui-a-stop/Size=16, Style=solid.svg": "b933",
	"./media-ui-a-stop/Size=20, Style=light.svg": "7b75",
	"./media-ui-a-stop/Size=20, Style=regular.svg": "060d",
	"./media-ui-a-stop/Size=20, Style=solid.svg": "a98b",
	"./media-ui-a-stop/Size=24, Style=regular.svg": "3bf3",
	"./media-ui-a-stop/Size=24, Style=solid.svg": "5afb",
	"./media-ui-a-stop/Size=32, Style=regular.svg": "8afb",
	"./media-ui-a-stop/Size=64, Style=regular.svg": "79c2",
	"./media-ui-circle-pause/Size=16, Style=light.svg": "3495",
	"./media-ui-circle-pause/Size=16, Style=regular.svg": "f962",
	"./media-ui-circle-pause/Size=16, Style=solid.svg": "4d7a",
	"./media-ui-circle-pause/Size=20, Style=light.svg": "4303",
	"./media-ui-circle-pause/Size=20, Style=regular.svg": "3e65",
	"./media-ui-circle-pause/Size=20, Style=solid.svg": "f72d",
	"./media-ui-circle-pause/Size=24, Style=regular.svg": "49df",
	"./media-ui-circle-pause/Size=24, Style=solid.svg": "8c4a",
	"./media-ui-circle-pause/Size=32, Style=regular.svg": "dc24",
	"./media-ui-circle-pause/Size=64, Style=regular.svg": "bba4",
	"./media-ui-circle-play/Size=16, Style=light.svg": "5f5d",
	"./media-ui-circle-play/Size=16, Style=regular.svg": "3dc5",
	"./media-ui-circle-play/Size=16, Style=solid.svg": "7d04",
	"./media-ui-circle-play/Size=20, Style=light.svg": "20cc1",
	"./media-ui-circle-play/Size=20, Style=regular.svg": "b4f2",
	"./media-ui-circle-play/Size=20, Style=solid.svg": "2900",
	"./media-ui-circle-play/Size=24, Style=regular.svg": "6ddc",
	"./media-ui-circle-play/Size=24, Style=solid.svg": "6f5c",
	"./media-ui-circle-play/Size=32, Style=regular.svg": "3de5",
	"./media-ui-circle-play/Size=64, Style=regular.svg": "de1c",
	"./media-ui-rect-play/Size=16, Style=light.svg": "07db",
	"./media-ui-rect-play/Size=16, Style=regular.svg": "c1ad",
	"./media-ui-rect-play/Size=16, Style=solid.svg": "6f5e",
	"./media-ui-rect-play/Size=20, Style=light.svg": "c214",
	"./media-ui-rect-play/Size=20, Style=regular.svg": "60e4",
	"./media-ui-rect-play/Size=20, Style=solid.svg": "d12e",
	"./media-ui-rect-play/Size=24, Style=regular.svg": "1510",
	"./media-ui-rect-play/Size=24, Style=solid.svg": "8e03",
	"./media-ui-rect-play/Size=32, Style=regular.svg": "144c",
	"./media-ui-rect-play/Size=64, Style=regular.svg": "26c5",
	"./megaphone/Size=16, Style=light.svg": "d756",
	"./megaphone/Size=16, Style=regular.svg": "4845",
	"./megaphone/Size=16, Style=solid.svg": "aa8d",
	"./megaphone/Size=20, Style=light.svg": "96d7",
	"./megaphone/Size=20, Style=regular.svg": "0a09",
	"./megaphone/Size=20, Style=solid.svg": "366f",
	"./megaphone/Size=24, Style=regular.svg": "5932",
	"./megaphone/Size=24, Style=solid.svg": "7cf5",
	"./megaphone/Size=32, Style=regular.svg": "e127",
	"./megaphone/Size=64, Style=regular.svg": "09d9",
	"./minus-circle/Size=16, Style=light.svg": "ba93",
	"./minus-circle/Size=16, Style=regular.svg": "d6d0",
	"./minus-circle/Size=16, Style=solid.svg": "ec0b",
	"./minus-circle/Size=20, Style=light.svg": "3eb8",
	"./minus-circle/Size=20, Style=regular.svg": "71f7",
	"./minus-circle/Size=20, Style=solid.svg": "6267",
	"./minus-circle/Size=24, Style=regular.svg": "f673",
	"./minus-circle/Size=24, Style=solid.svg": "d07c",
	"./minus-circle/Size=32, Style=regular.svg": "cb2e",
	"./minus-circle/Size=64, Style=regular.svg": "ba11",
	"./minus-square/Size=16, Style=light.svg": "b8e4",
	"./minus-square/Size=16, Style=regular.svg": "2af7",
	"./minus-square/Size=16, Style=solid.svg": "d237",
	"./minus-square/Size=20, Style=light.svg": "0956",
	"./minus-square/Size=20, Style=regular.svg": "e3d6",
	"./minus-square/Size=20, Style=solid.svg": "01f0",
	"./minus-square/Size=24, Style=regular.svg": "1efb",
	"./minus-square/Size=24, Style=solid.svg": "a2a4",
	"./minus-square/Size=32, Style=regular.svg": "ead2",
	"./minus-square/Size=64, Style=regular.svg": "daeb",
	"./minus/Size=16, Style=light.svg": "0fee",
	"./minus/Size=16, Style=regular.svg": "5741",
	"./minus/Size=16, Style=solid.svg": "145f",
	"./minus/Size=20, Style=light.svg": "9abf",
	"./minus/Size=20, Style=regular.svg": "2085",
	"./minus/Size=20, Style=solid.svg": "5cf3",
	"./minus/Size=24, Style=regular.svg": "b7e8",
	"./minus/Size=24, Style=solid.svg": "94aa",
	"./minus/Size=32, Style=regular.svg": "2cc5",
	"./minus/Size=64, Style=regular.svg": "742c",
	"./money-currency-ruble-circle/Size=16, Style=light.svg": "b0fc",
	"./money-currency-ruble-circle/Size=16, Style=regular.svg": "86f41",
	"./money-currency-ruble-circle/Size=16, Style=solid.svg": "cd3a6",
	"./money-currency-ruble-circle/Size=20, Style=light.svg": "89e0",
	"./money-currency-ruble-circle/Size=20, Style=regular.svg": "626f",
	"./money-currency-ruble-circle/Size=20, Style=solid.svg": "110c",
	"./money-currency-ruble-circle/Size=24, Style=regular.svg": "fd6a",
	"./money-currency-ruble-circle/Size=24, Style=solid.svg": "d384",
	"./money-currency-ruble-circle/Size=32, Style=regular.svg": "1687",
	"./money-currency-ruble-circle/Size=64, Style=regular.svg": "d456",
	"./money-currency-ruble-rect/Size=16, Style=light.svg": "b42c",
	"./money-currency-ruble-rect/Size=16, Style=regular.svg": "7ba9",
	"./money-currency-ruble-rect/Size=16, Style=solid.svg": "36dc",
	"./money-currency-ruble-rect/Size=20, Style=light.svg": "b00e",
	"./money-currency-ruble-rect/Size=20, Style=regular.svg": "6e84",
	"./money-currency-ruble-rect/Size=20, Style=solid.svg": "8b17",
	"./money-currency-ruble-rect/Size=24, Style=regular.svg": "f6a2",
	"./money-currency-ruble-rect/Size=24, Style=solid.svg": "0441",
	"./money-currency-ruble-rect/Size=32, Style=regular.svg": "ca39",
	"./money-currency-ruble-rect/Size=64, Style=regular.svg": "47ef",
	"./money-currency-ruble/Size=16, Style=light.svg": "4f7d",
	"./money-currency-ruble/Size=16, Style=regular.svg": "6d49",
	"./money-currency-ruble/Size=16, Style=solid.svg": "e031",
	"./money-currency-ruble/Size=20, Style=light.svg": "498b",
	"./money-currency-ruble/Size=20, Style=regular.svg": "d93f",
	"./money-currency-ruble/Size=20, Style=solid.svg": "c020",
	"./money-currency-ruble/Size=24, Style=regular.svg": "74ce",
	"./money-currency-ruble/Size=24, Style=solid.svg": "af83",
	"./money-currency-ruble/Size=32, Style=regular.svg": "08ab",
	"./money-currency-ruble/Size=64, Style=regular.svg": "ecff",
	"./money-type-card/Size=16, Style=light.svg": "f7ce",
	"./money-type-card/Size=16, Style=regular.svg": "9587c",
	"./money-type-card/Size=16, Style=solid.svg": "f37a",
	"./money-type-card/Size=20, Style=light.svg": "073f",
	"./money-type-card/Size=20, Style=regular.svg": "27aa",
	"./money-type-card/Size=20, Style=solid.svg": "30fd",
	"./money-type-card/Size=24, Style=regular.svg": "740bb",
	"./money-type-card/Size=24, Style=solid.svg": "b388",
	"./money-type-card/Size=32, Style=regular.svg": "c4da",
	"./money-type-card/Size=64, Style=regular.svg": "bf6d",
	"./money-type-coins/Size=16, Style=light.svg": "2887",
	"./money-type-coins/Size=16, Style=regular.svg": "0472",
	"./money-type-coins/Size=16, Style=solid.svg": "de00",
	"./money-type-coins/Size=20, Style=light.svg": "3bfe",
	"./money-type-coins/Size=20, Style=regular.svg": "fc4b",
	"./money-type-coins/Size=20, Style=solid.svg": "bbfe",
	"./money-type-coins/Size=24, Style=regular.svg": "3fcc0",
	"./money-type-coins/Size=24, Style=solid.svg": "4020",
	"./money-type-coins/Size=32, Style=regular.svg": "3615",
	"./money-type-coins/Size=64, Style=regular.svg": "aaf8",
	"./money-wallet-a-open/Size=16, Style=light.svg": "23dc0",
	"./money-wallet-a-open/Size=16, Style=regular.svg": "6933",
	"./money-wallet-a-open/Size=16, Style=solid.svg": "2456",
	"./money-wallet-a-open/Size=20, Style=light.svg": "309c",
	"./money-wallet-a-open/Size=20, Style=regular.svg": "4ef8",
	"./money-wallet-a-open/Size=20, Style=solid.svg": "bdcf",
	"./money-wallet-a-open/Size=24, Style=regular.svg": "e4ff",
	"./money-wallet-a-open/Size=24, Style=solid.svg": "5e1c",
	"./money-wallet-a-open/Size=32, Style=regular.svg": "a104",
	"./money-wallet-a-open/Size=64, Style=regular.svg": "0104",
	"./money-wallet-a/Size=16, Style=light.svg": "813a",
	"./money-wallet-a/Size=16, Style=regular.svg": "325b",
	"./money-wallet-a/Size=16, Style=solid.svg": "ccc1",
	"./money-wallet-a/Size=20, Style=light.svg": "9a86",
	"./money-wallet-a/Size=20, Style=regular.svg": "d193",
	"./money-wallet-a/Size=20, Style=solid.svg": "9b13",
	"./money-wallet-a/Size=24, Style=regular.svg": "bdfc",
	"./money-wallet-a/Size=24, Style=solid.svg": "9cdb",
	"./money-wallet-a/Size=32, Style=regular.svg": "7ee3",
	"./money-wallet-a/Size=64, Style=regular.svg": "d41d",
	"./net-cloud-arrow-download/Size=16, Style=light.svg": "8d06",
	"./net-cloud-arrow-download/Size=16, Style=regular.svg": "477a",
	"./net-cloud-arrow-download/Size=16, Style=solid.svg": "62a6",
	"./net-cloud-arrow-download/Size=20, Style=light.svg": "9b59",
	"./net-cloud-arrow-download/Size=20, Style=regular.svg": "dddb",
	"./net-cloud-arrow-download/Size=20, Style=solid.svg": "20852",
	"./net-cloud-arrow-download/Size=24, Style=regular.svg": "fa63",
	"./net-cloud-arrow-download/Size=24, Style=solid.svg": "1169",
	"./net-cloud-arrow-download/Size=32, Style=regular.svg": "0223",
	"./net-cloud-arrow-download/Size=64, Style=regular.svg": "3aa7",
	"./net-cloud-arrow-upload/Size=16, Style=light.svg": "f41a",
	"./net-cloud-arrow-upload/Size=16, Style=regular.svg": "06df",
	"./net-cloud-arrow-upload/Size=16, Style=solid.svg": "197d",
	"./net-cloud-arrow-upload/Size=20, Style=light.svg": "8b85",
	"./net-cloud-arrow-upload/Size=20, Style=regular.svg": "56c8",
	"./net-cloud-arrow-upload/Size=20, Style=solid.svg": "2ce1",
	"./net-cloud-arrow-upload/Size=24, Style=regular.svg": "868e",
	"./net-cloud-arrow-upload/Size=24, Style=solid.svg": "d469",
	"./net-cloud-arrow-upload/Size=32, Style=regular.svg": "82f1",
	"./net-cloud-arrow-upload/Size=64, Style=regular.svg": "cec0",
	"./net-cloud-check/Size=16, Style=light.svg": "8400",
	"./net-cloud-check/Size=16, Style=regular.svg": "29cc",
	"./net-cloud-check/Size=16, Style=solid.svg": "26c9",
	"./net-cloud-check/Size=20, Style=light.svg": "8c13",
	"./net-cloud-check/Size=20, Style=regular.svg": "c63b",
	"./net-cloud-check/Size=20, Style=solid.svg": "f0f6",
	"./net-cloud-check/Size=24, Style=regular.svg": "8471",
	"./net-cloud-check/Size=24, Style=solid.svg": "35d5",
	"./net-cloud-check/Size=32, Style=regular.svg": "c77a",
	"./net-cloud-check/Size=64, Style=regular.svg": "cc44",
	"./net-cloud-wire/Size=16, Style=light.svg": "c699",
	"./net-cloud-wire/Size=16, Style=regular.svg": "2190",
	"./net-cloud-wire/Size=16, Style=solid.svg": "94c6e",
	"./net-cloud-wire/Size=20, Style=light.svg": "433e",
	"./net-cloud-wire/Size=20, Style=regular.svg": "9def",
	"./net-cloud-wire/Size=20, Style=solid.svg": "f6b6",
	"./net-cloud-wire/Size=24, Style=regular.svg": "7216",
	"./net-cloud-wire/Size=24, Style=solid.svg": "5555",
	"./net-cloud-wire/Size=32, Style=regular.svg": "3fb4",
	"./net-cloud-wire/Size=64, Style=regular.svg": "57fc",
	"./net-cloud/Size=16, Style=light.svg": "33da",
	"./net-cloud/Size=16, Style=regular.svg": "c7be",
	"./net-cloud/Size=16, Style=solid.svg": "45fe",
	"./net-cloud/Size=20, Style=light.svg": "eab5",
	"./net-cloud/Size=20, Style=regular.svg": "92ad",
	"./net-cloud/Size=20, Style=solid.svg": "030d",
	"./net-cloud/Size=24, Style=regular.svg": "7e8e",
	"./net-cloud/Size=24, Style=solid.svg": "296b",
	"./net-cloud/Size=32, Style=regular.svg": "d120",
	"./net-cloud/Size=64, Style=regular.svg": "8cc7",
	"./net-download/Size=16, Style=light.svg": "ca1f",
	"./net-download/Size=16, Style=regular.svg": "641e",
	"./net-download/Size=16, Style=solid.svg": "0cde",
	"./net-download/Size=20, Style=light.svg": "7b0f",
	"./net-download/Size=20, Style=regular.svg": "cd97",
	"./net-download/Size=20, Style=solid.svg": "bab1",
	"./net-download/Size=24, Style=regular.svg": "716e",
	"./net-download/Size=24, Style=solid.svg": "0a2d",
	"./net-download/Size=32, Style=regular.svg": "6544",
	"./net-download/Size=64, Style=regular.svg": "4bd3",
	"./net-upload/Size=16, Style=light.svg": "680e",
	"./net-upload/Size=16, Style=regular.svg": "46fb",
	"./net-upload/Size=16, Style=solid.svg": "9260",
	"./net-upload/Size=20, Style=light.svg": "372d",
	"./net-upload/Size=20, Style=regular.svg": "b408",
	"./net-upload/Size=20, Style=solid.svg": "98c8",
	"./net-upload/Size=24, Style=regular.svg": "24f8",
	"./net-upload/Size=24, Style=solid.svg": "3825",
	"./net-upload/Size=32, Style=regular.svg": "f113f",
	"./net-upload/Size=64, Style=regular.svg": "358e",
	"./news-feed/Size=16, Style=light.svg": "8ef1",
	"./news-feed/Size=16, Style=regular.svg": "832e",
	"./news-feed/Size=16, Style=solid.svg": "e0e88",
	"./news-feed/Size=20, Style=light.svg": "e699",
	"./news-feed/Size=20, Style=regular.svg": "f88b",
	"./news-feed/Size=20, Style=solid.svg": "61e0",
	"./news-feed/Size=24, Style=regular.svg": "60d0",
	"./news-feed/Size=24, Style=solid.svg": "98fa",
	"./news-feed/Size=32, Style=regular.svg": "ac85",
	"./news-feed/Size=64, Style=regular.svg": "36df",
	"./notification-bell-alarm/Size=16, Style=light.svg": "a1f8",
	"./notification-bell-alarm/Size=16, Style=regular.svg": "9858",
	"./notification-bell-alarm/Size=16, Style=solid.svg": "aa83",
	"./notification-bell-alarm/Size=20, Style=light.svg": "209a",
	"./notification-bell-alarm/Size=20, Style=regular.svg": "eec9",
	"./notification-bell-alarm/Size=20, Style=solid.svg": "29f8",
	"./notification-bell-alarm/Size=24, Style=regular.svg": "a350",
	"./notification-bell-alarm/Size=24, Style=solid.svg": "49db",
	"./notification-bell-alarm/Size=32, Style=regular.svg": "1f77",
	"./notification-bell-alarm/Size=64, Style=regular.svg": "22b4",
	"./notification-bell-off/Size=16, Style=light.svg": "c944",
	"./notification-bell-off/Size=16, Style=regular.svg": "f9a4",
	"./notification-bell-off/Size=16, Style=solid.svg": "0f6d",
	"./notification-bell-off/Size=20, Style=light.svg": "6081",
	"./notification-bell-off/Size=20, Style=regular.svg": "3ebe",
	"./notification-bell-off/Size=20, Style=solid.svg": "0add",
	"./notification-bell-off/Size=24, Style=regular.svg": "d500",
	"./notification-bell-off/Size=24, Style=solid.svg": "96db",
	"./notification-bell-off/Size=32, Style=regular.svg": "76db",
	"./notification-bell-off/Size=64, Style=regular.svg": "f7db",
	"./notification-bell/Size=16, Style=light.svg": "7469",
	"./notification-bell/Size=16, Style=regular.svg": "16a6",
	"./notification-bell/Size=16, Style=solid.svg": "4c88",
	"./notification-bell/Size=20, Style=light.svg": "74cc",
	"./notification-bell/Size=20, Style=regular.svg": "3ffb",
	"./notification-bell/Size=20, Style=solid.svg": "e3e1",
	"./notification-bell/Size=24, Style=regular.svg": "4994",
	"./notification-bell/Size=24, Style=solid.svg": "4810",
	"./notification-bell/Size=32, Style=regular.svg": "3381",
	"./notification-bell/Size=64, Style=regular.svg": "3490",
	"./people-circle-one/Size=16, Style=light.svg": "2467",
	"./people-circle-one/Size=16, Style=regular.svg": "9897",
	"./people-circle-one/Size=16, Style=solid.svg": "3200",
	"./people-circle-one/Size=20, Style=light.svg": "3bac",
	"./people-circle-one/Size=20, Style=regular.svg": "6514",
	"./people-circle-one/Size=20, Style=solid.svg": "db34",
	"./people-circle-one/Size=24, Style=regular.svg": "6588",
	"./people-circle-one/Size=24, Style=solid.svg": "1fa0",
	"./people-circle-one/Size=32, Style=regular.svg": "945d",
	"./people-circle-one/Size=64, Style=regular.svg": "3c28",
	"./people-one-badge/Size=16, Style=light.svg": "51a0",
	"./people-one-badge/Size=16, Style=regular.svg": "8a69",
	"./people-one-badge/Size=16, Style=solid.svg": "dcc7",
	"./people-one-badge/Size=20, Style=light.svg": "ff202",
	"./people-one-badge/Size=20, Style=regular.svg": "1465",
	"./people-one-badge/Size=20, Style=solid.svg": "93a4",
	"./people-one-badge/Size=24, Style=regular.svg": "74b2",
	"./people-one-badge/Size=24, Style=solid.svg": "a3ca",
	"./people-one-badge/Size=32, Style=regular.svg": "2819",
	"./people-one-badge/Size=64, Style=regular.svg": "ccf6",
	"./people-one-check/Size=16, Style=light.svg": "dee6",
	"./people-one-check/Size=16, Style=regular.svg": "5eda",
	"./people-one-check/Size=16, Style=solid.svg": "f070",
	"./people-one-check/Size=20, Style=light.svg": "aee3",
	"./people-one-check/Size=20, Style=regular.svg": "c8c4",
	"./people-one-check/Size=20, Style=solid.svg": "b7c6",
	"./people-one-check/Size=24, Style=regular.svg": "8c7e",
	"./people-one-check/Size=24, Style=solid.svg": "0f0b",
	"./people-one-check/Size=32, Style=regular.svg": "fb27",
	"./people-one-check/Size=64, Style=regular.svg": "a6b9",
	"./people-one-edit/Size=16, Style=light.svg": "3712",
	"./people-one-edit/Size=16, Style=regular.svg": "41d4",
	"./people-one-edit/Size=16, Style=solid.svg": "4f24",
	"./people-one-edit/Size=20, Style=light.svg": "4823",
	"./people-one-edit/Size=20, Style=regular.svg": "ed65",
	"./people-one-edit/Size=20, Style=solid.svg": "6073",
	"./people-one-edit/Size=24, Style=regular.svg": "f6e3",
	"./people-one-edit/Size=24, Style=solid.svg": "0225",
	"./people-one-edit/Size=32, Style=regular.svg": "8335",
	"./people-one-edit/Size=64, Style=regular.svg": "c7a0",
	"./people-one-gear/Size=16, Style=light.svg": "8944",
	"./people-one-gear/Size=16, Style=regular.svg": "9384",
	"./people-one-gear/Size=16, Style=solid.svg": "d4e8",
	"./people-one-gear/Size=20, Style=light.svg": "91de",
	"./people-one-gear/Size=20, Style=regular.svg": "7e66",
	"./people-one-gear/Size=20, Style=solid.svg": "8dfb",
	"./people-one-gear/Size=24, Style=regular.svg": "7497",
	"./people-one-gear/Size=24, Style=solid.svg": "7a9a",
	"./people-one-gear/Size=32, Style=regular.svg": "c03e",
	"./people-one-gear/Size=64, Style=regular.svg": "d996",
	"./people-one-lock/Size=16, Style=light.svg": "2bee",
	"./people-one-lock/Size=16, Style=regular.svg": "e143",
	"./people-one-lock/Size=16, Style=solid.svg": "d628",
	"./people-one-lock/Size=20, Style=light.svg": "6961",
	"./people-one-lock/Size=20, Style=regular.svg": "855c",
	"./people-one-lock/Size=20, Style=solid.svg": "6df5",
	"./people-one-lock/Size=24, Style=regular.svg": "a939a",
	"./people-one-lock/Size=24, Style=solid.svg": "3659",
	"./people-one-lock/Size=32, Style=regular.svg": "80ed",
	"./people-one-lock/Size=64, Style=regular.svg": "6ec4",
	"./people-one-minus/Size=16, Style=light.svg": "9725",
	"./people-one-minus/Size=16, Style=regular.svg": "1976",
	"./people-one-minus/Size=16, Style=solid.svg": "9bd2",
	"./people-one-minus/Size=20, Style=light.svg": "eb8f",
	"./people-one-minus/Size=20, Style=regular.svg": "155a",
	"./people-one-minus/Size=20, Style=solid.svg": "2e9d",
	"./people-one-minus/Size=24, Style=regular.svg": "753a",
	"./people-one-minus/Size=24, Style=solid.svg": "dd8e",
	"./people-one-minus/Size=32, Style=regular.svg": "93ba",
	"./people-one-minus/Size=64, Style=regular.svg": "2ed7",
	"./people-one-plus/Size=16, Style=light.svg": "de0d",
	"./people-one-plus/Size=16, Style=regular.svg": "1325",
	"./people-one-plus/Size=16, Style=solid.svg": "6c9a",
	"./people-one-plus/Size=20, Style=light.svg": "c90b",
	"./people-one-plus/Size=20, Style=regular.svg": "bfe9",
	"./people-one-plus/Size=20, Style=solid.svg": "5786",
	"./people-one-plus/Size=24, Style=regular.svg": "d8d9",
	"./people-one-plus/Size=24, Style=solid.svg": "04e7",
	"./people-one-plus/Size=32, Style=regular.svg": "7526",
	"./people-one-plus/Size=64, Style=regular.svg": "c6fc",
	"./people-one-x/Size=16, Style=light.svg": "e695",
	"./people-one-x/Size=16, Style=regular.svg": "53b4",
	"./people-one-x/Size=16, Style=solid.svg": "8597",
	"./people-one-x/Size=20, Style=light.svg": "17c0",
	"./people-one-x/Size=20, Style=regular.svg": "e75e",
	"./people-one-x/Size=20, Style=solid.svg": "2cc8",
	"./people-one-x/Size=24, Style=regular.svg": "4a83",
	"./people-one-x/Size=24, Style=solid.svg": "e958",
	"./people-one-x/Size=32, Style=regular.svg": "35b4",
	"./people-one-x/Size=64, Style=regular.svg": "2ce8",
	"./people-one/Size=16, Style=light.svg": "a8e5",
	"./people-one/Size=16, Style=regular.svg": "2eec",
	"./people-one/Size=16, Style=solid.svg": "c836",
	"./people-one/Size=20, Style=light.svg": "3b25",
	"./people-one/Size=20, Style=regular.svg": "e61d",
	"./people-one/Size=20, Style=solid.svg": "4ac4",
	"./people-one/Size=24, Style=regular.svg": "4ab2",
	"./people-one/Size=24, Style=solid.svg": "29f0",
	"./people-one/Size=32, Style=regular.svg": "2d48",
	"./people-one/Size=64, Style=regular.svg": "c62d",
	"./people-three/Size=16, Style=light.svg": "d58e",
	"./people-three/Size=16, Style=regular.svg": "675d",
	"./people-three/Size=16, Style=solid.svg": "1193",
	"./people-three/Size=20, Style=light.svg": "9fce",
	"./people-three/Size=20, Style=regular.svg": "2296",
	"./people-three/Size=20, Style=solid.svg": "597a",
	"./people-three/Size=24, Style=regular.svg": "166b",
	"./people-three/Size=24, Style=solid.svg": "9cdc",
	"./people-three/Size=32, Style=regular.svg": "0200",
	"./people-three/Size=64, Style=regular.svg": "94f2",
	"./people-two/Size=16, Style=light.svg": "07a0",
	"./people-two/Size=16, Style=regular.svg": "3d02",
	"./people-two/Size=16, Style=solid.svg": "ca2a",
	"./people-two/Size=20, Style=light.svg": "2335",
	"./people-two/Size=20, Style=regular.svg": "c180",
	"./people-two/Size=20, Style=solid.svg": "a094",
	"./people-two/Size=24, Style=regular.svg": "ebac",
	"./people-two/Size=24, Style=solid.svg": "d74b",
	"./people-two/Size=32, Style=regular.svg": "f42d",
	"./people-two/Size=64, Style=regular.svg": "801a",
	"./plus-circle/Size=16, Style=light.svg": "b412",
	"./plus-circle/Size=16, Style=regular.svg": "b9a9",
	"./plus-circle/Size=16, Style=solid.svg": "1c7c",
	"./plus-circle/Size=20, Style=light.svg": "9909",
	"./plus-circle/Size=20, Style=regular.svg": "099f",
	"./plus-circle/Size=20, Style=solid.svg": "a411",
	"./plus-circle/Size=24, Style=regular.svg": "8493",
	"./plus-circle/Size=24, Style=solid.svg": "6444",
	"./plus-circle/Size=32, Style=regular.svg": "c185",
	"./plus-circle/Size=64, Style=regular.svg": "d957",
	"./plus-square/Size=16, Style=light.svg": "9a4a",
	"./plus-square/Size=16, Style=regular.svg": "d979",
	"./plus-square/Size=16, Style=solid.svg": "3788",
	"./plus-square/Size=20, Style=light.svg": "88a1",
	"./plus-square/Size=20, Style=regular.svg": "ff4f",
	"./plus-square/Size=20, Style=solid.svg": "dc17",
	"./plus-square/Size=24, Style=regular.svg": "02fa",
	"./plus-square/Size=24, Style=solid.svg": "9de62",
	"./plus-square/Size=32, Style=regular.svg": "8e7f",
	"./plus-square/Size=64, Style=regular.svg": "4e51",
	"./plus/Size=16, Style=light.svg": "7435",
	"./plus/Size=16, Style=regular.svg": "6c9c",
	"./plus/Size=16, Style=solid.svg": "d349d",
	"./plus/Size=20, Style=light.svg": "37e9",
	"./plus/Size=20, Style=regular.svg": "826c",
	"./plus/Size=20, Style=solid.svg": "78e5",
	"./plus/Size=24, Style=regular.svg": "aa13",
	"./plus/Size=24, Style=solid.svg": "94cf",
	"./plus/Size=32, Style=regular.svg": "efc7",
	"./plus/Size=64, Style=regular.svg": "4b86",
	"./question-circle/Size=16, Style=light.svg": "b6c5",
	"./question-circle/Size=16, Style=regular.svg": "5790",
	"./question-circle/Size=16, Style=solid.svg": "1c6c",
	"./question-circle/Size=20, Style=light.svg": "20c7",
	"./question-circle/Size=20, Style=regular.svg": "8070",
	"./question-circle/Size=20, Style=solid.svg": "9bbc",
	"./question-circle/Size=24, Style=regular.svg": "c44c",
	"./question-circle/Size=24, Style=solid.svg": "eb1b",
	"./question-circle/Size=32, Style=regular.svg": "0c18",
	"./question-circle/Size=64, Style=regular.svg": "e09f",
	"./question-square/Size=16, Style=light.svg": "f0a7",
	"./question-square/Size=16, Style=regular.svg": "11f4",
	"./question-square/Size=16, Style=solid.svg": "88f8",
	"./question-square/Size=20, Style=light.svg": "d66e",
	"./question-square/Size=20, Style=regular.svg": "9a54",
	"./question-square/Size=20, Style=solid.svg": "3f50",
	"./question-square/Size=24, Style=regular.svg": "0ae2",
	"./question-square/Size=24, Style=solid.svg": "368d",
	"./question-square/Size=32, Style=regular.svg": "1d3d",
	"./question-square/Size=64, Style=regular.svg": "25f00",
	"./search-loupe-minus/Size=16, Style=light.svg": "c137",
	"./search-loupe-minus/Size=16, Style=regular.svg": "19f0",
	"./search-loupe-minus/Size=16, Style=solid.svg": "75a5",
	"./search-loupe-minus/Size=20, Style=light.svg": "534b",
	"./search-loupe-minus/Size=20, Style=regular.svg": "3eb9",
	"./search-loupe-minus/Size=20, Style=solid.svg": "0e1b",
	"./search-loupe-minus/Size=24, Style=regular.svg": "8f9f",
	"./search-loupe-minus/Size=24, Style=solid.svg": "d760",
	"./search-loupe-minus/Size=32, Style=regular.svg": "a01a",
	"./search-loupe-minus/Size=64, Style=regular.svg": "43033",
	"./search-loupe-plus/Size=16, Style=light.svg": "1fd4",
	"./search-loupe-plus/Size=16, Style=regular.svg": "2e8a",
	"./search-loupe-plus/Size=16, Style=solid.svg": "e020",
	"./search-loupe-plus/Size=20, Style=light.svg": "945c",
	"./search-loupe-plus/Size=20, Style=regular.svg": "86d2",
	"./search-loupe-plus/Size=20, Style=solid.svg": "4c0d",
	"./search-loupe-plus/Size=24, Style=regular.svg": "c63e",
	"./search-loupe-plus/Size=24, Style=solid.svg": "e63c",
	"./search-loupe-plus/Size=32, Style=regular.svg": "692f",
	"./search-loupe-plus/Size=64, Style=regular.svg": "4858",
	"./search-loupe/Size=16, Style=light.svg": "10b5",
	"./search-loupe/Size=16, Style=regular.svg": "9c03",
	"./search-loupe/Size=16, Style=solid.svg": "e4a8",
	"./search-loupe/Size=20, Style=light.svg": "bf2d",
	"./search-loupe/Size=20, Style=regular.svg": "1989",
	"./search-loupe/Size=20, Style=solid.svg": "e942",
	"./search-loupe/Size=24, Style=regular.svg": "a5cd",
	"./search-loupe/Size=24, Style=solid.svg": "37b3",
	"./search-loupe/Size=32, Style=regular.svg": "9eb0",
	"./search-loupe/Size=64, Style=regular.svg": "fabc",
	"./security-key-a/Size=16, Style=light.svg": "860c",
	"./security-key-a/Size=16, Style=regular.svg": "b9c0",
	"./security-key-a/Size=16, Style=solid.svg": "3e8c",
	"./security-key-a/Size=20, Style=light.svg": "c5ee",
	"./security-key-a/Size=20, Style=regular.svg": "53fcf",
	"./security-key-a/Size=20, Style=solid.svg": "5848",
	"./security-key-a/Size=24, Style=regular.svg": "6f12",
	"./security-key-a/Size=24, Style=solid.svg": "85c3",
	"./security-key-a/Size=32, Style=regular.svg": "9aae",
	"./security-key-a/Size=64, Style=regular.svg": "28cd",
	"./security-key-b/Size=16, Style=light.svg": "2141",
	"./security-key-b/Size=16, Style=regular.svg": "ab05",
	"./security-key-b/Size=16, Style=solid.svg": "68b7",
	"./security-key-b/Size=20, Style=light.svg": "a0a9",
	"./security-key-b/Size=20, Style=regular.svg": "f0de",
	"./security-key-b/Size=20, Style=solid.svg": "87e1",
	"./security-key-b/Size=24, Style=regular.svg": "939e",
	"./security-key-b/Size=24, Style=solid.svg": "8bc6",
	"./security-key-b/Size=32, Style=regular.svg": "b782",
	"./security-key-b/Size=64, Style=regular.svg": "765b",
	"./security-lock-closed/Size=16, Style=light.svg": "d9af",
	"./security-lock-closed/Size=16, Style=regular.svg": "b8ab",
	"./security-lock-closed/Size=16, Style=solid.svg": "28d4",
	"./security-lock-closed/Size=20, Style=light.svg": "e637",
	"./security-lock-closed/Size=20, Style=regular.svg": "6dd4",
	"./security-lock-closed/Size=20, Style=solid.svg": "8e8e9",
	"./security-lock-closed/Size=24, Style=regular.svg": "4a34",
	"./security-lock-closed/Size=24, Style=solid.svg": "b482",
	"./security-lock-closed/Size=32, Style=regular.svg": "9af3",
	"./security-lock-closed/Size=64, Style=regular.svg": "b485",
	"./security-lock-open/Size=16, Style=light.svg": "8ca7",
	"./security-lock-open/Size=16, Style=regular.svg": "9cc5",
	"./security-lock-open/Size=16, Style=solid.svg": "ac27",
	"./security-lock-open/Size=20, Style=light.svg": "2182",
	"./security-lock-open/Size=20, Style=regular.svg": "7f53",
	"./security-lock-open/Size=20, Style=solid.svg": "25de",
	"./security-lock-open/Size=24, Style=regular.svg": "333a",
	"./security-lock-open/Size=24, Style=solid.svg": "5c0c",
	"./security-lock-open/Size=32, Style=regular.svg": "8a4c",
	"./security-lock-open/Size=64, Style=regular.svg": "810f",
	"./security-shield-check/Size=16, Style=light.svg": "4026",
	"./security-shield-check/Size=16, Style=regular.svg": "17c03",
	"./security-shield-check/Size=16, Style=solid.svg": "80e1",
	"./security-shield-check/Size=20, Style=light.svg": "88bf",
	"./security-shield-check/Size=20, Style=regular.svg": "682b",
	"./security-shield-check/Size=20, Style=solid.svg": "8003",
	"./security-shield-check/Size=24, Style=regular.svg": "691a",
	"./security-shield-check/Size=24, Style=solid.svg": "8b8d",
	"./security-shield-check/Size=32, Style=regular.svg": "2ad0",
	"./security-shield-check/Size=64, Style=regular.svg": "4315",
	"./security-shield/Size=16, Style=light.svg": "775d",
	"./security-shield/Size=16, Style=regular.svg": "57e3",
	"./security-shield/Size=16, Style=solid.svg": "9445",
	"./security-shield/Size=20, Style=light.svg": "abb89",
	"./security-shield/Size=20, Style=regular.svg": "cf24",
	"./security-shield/Size=20, Style=solid.svg": "d34e",
	"./security-shield/Size=24, Style=regular.svg": "ed9c",
	"./security-shield/Size=24, Style=solid.svg": "68e1",
	"./security-shield/Size=32, Style=regular.svg": "8291",
	"./security-shield/Size=64, Style=regular.svg": "73ab",
	"./send-paperplane-diag/Size=16, Style=light.svg": "7ba4",
	"./send-paperplane-diag/Size=16, Style=regular.svg": "1a26",
	"./send-paperplane-diag/Size=16, Style=solid.svg": "f62a",
	"./send-paperplane-diag/Size=20, Style=light.svg": "5090",
	"./send-paperplane-diag/Size=20, Style=regular.svg": "1ea4",
	"./send-paperplane-diag/Size=20, Style=solid.svg": "76e0",
	"./send-paperplane-diag/Size=24, Style=regular.svg": "7f72",
	"./send-paperplane-diag/Size=24, Style=solid.svg": "5aca",
	"./send-paperplane-diag/Size=32, Style=regular.svg": "ccfb",
	"./send-paperplane-diag/Size=64, Style=regular.svg": "307f",
	"./send-paperplane/Size=16, Style=light.svg": "adcc",
	"./send-paperplane/Size=16, Style=regular.svg": "dfba",
	"./send-paperplane/Size=16, Style=solid.svg": "90fa",
	"./send-paperplane/Size=20, Style=light.svg": "55870",
	"./send-paperplane/Size=20, Style=regular.svg": "87ab",
	"./send-paperplane/Size=20, Style=solid.svg": "01a9",
	"./send-paperplane/Size=24, Style=regular.svg": "0aa3",
	"./send-paperplane/Size=24, Style=solid.svg": "9663",
	"./send-paperplane/Size=32, Style=regular.svg": "4024",
	"./send-paperplane/Size=64, Style=regular.svg": "4938",
	"./settings-gear/Size=16, Style=light.svg": "91d4",
	"./settings-gear/Size=16, Style=regular.svg": "7be6",
	"./settings-gear/Size=16, Style=solid.svg": "ebb2",
	"./settings-gear/Size=20, Style=light.svg": "d73e",
	"./settings-gear/Size=20, Style=regular.svg": "3b95",
	"./settings-gear/Size=20, Style=solid.svg": "764f",
	"./settings-gear/Size=24, Style=regular.svg": "5404d",
	"./settings-gear/Size=24, Style=solid.svg": "6f42",
	"./settings-gear/Size=32, Style=regular.svg": "dc87",
	"./settings-gear/Size=64, Style=regular.svg": "867f",
	"./settings-sliders-h-three/Size=16, Style=light.svg": "b6e4",
	"./settings-sliders-h-three/Size=16, Style=regular.svg": "f94b",
	"./settings-sliders-h-three/Size=16, Style=solid.svg": "1982",
	"./settings-sliders-h-three/Size=20, Style=light.svg": "3003",
	"./settings-sliders-h-three/Size=20, Style=regular.svg": "9edf",
	"./settings-sliders-h-three/Size=20, Style=solid.svg": "79478",
	"./settings-sliders-h-three/Size=24, Style=regular.svg": "73c7",
	"./settings-sliders-h-three/Size=24, Style=solid.svg": "7a4a",
	"./settings-sliders-h-three/Size=32, Style=regular.svg": "534a",
	"./settings-sliders-h-three/Size=64, Style=regular.svg": "db3b",
	"./shape-circle/Size=16, Style=light.svg": "5811",
	"./shape-circle/Size=16, Style=regular.svg": "4f55",
	"./shape-circle/Size=16, Style=solid.svg": "e471",
	"./shape-circle/Size=20, Style=light.svg": "651d",
	"./shape-circle/Size=20, Style=regular.svg": "cf6c",
	"./shape-circle/Size=20, Style=solid.svg": "1064",
	"./shape-circle/Size=24, Style=regular.svg": "f5a8",
	"./shape-circle/Size=24, Style=solid.svg": "9fe8",
	"./shape-circle/Size=32, Style=regular.svg": "aac2",
	"./shape-circle/Size=64, Style=regular.svg": "5fd1",
	"./shape-rect-h/Size=16, Style=light.svg": "331a6",
	"./shape-rect-h/Size=16, Style=regular.svg": "8d0a",
	"./shape-rect-h/Size=16, Style=solid.svg": "52d7",
	"./shape-rect-h/Size=20, Style=light.svg": "b77d",
	"./shape-rect-h/Size=20, Style=regular.svg": "658a",
	"./shape-rect-h/Size=20, Style=solid.svg": "34f6",
	"./shape-rect-h/Size=24, Style=regular.svg": "1b64",
	"./shape-rect-h/Size=24, Style=solid.svg": "a183",
	"./shape-rect-h/Size=32, Style=regular.svg": "38fb",
	"./shape-rect-h/Size=64, Style=regular.svg": "a433",
	"./shape-rect-v/Size=16, Style=light.svg": "7da5",
	"./shape-rect-v/Size=16, Style=regular.svg": "c2ab",
	"./shape-rect-v/Size=16, Style=solid.svg": "ec81",
	"./shape-rect-v/Size=20, Style=light.svg": "0a53",
	"./shape-rect-v/Size=20, Style=regular.svg": "17e4",
	"./shape-rect-v/Size=20, Style=solid.svg": "18cb",
	"./shape-rect-v/Size=24, Style=regular.svg": "f653",
	"./shape-rect-v/Size=24, Style=solid.svg": "514c",
	"./shape-rect-v/Size=32, Style=regular.svg": "643c",
	"./shape-rect-v/Size=64, Style=regular.svg": "4102",
	"./shape-square/Size=16, Style=light.svg": "0cba",
	"./shape-square/Size=16, Style=regular.svg": "3dcc",
	"./shape-square/Size=16, Style=solid.svg": "07a40",
	"./shape-square/Size=20, Style=light.svg": "5a3ae",
	"./shape-square/Size=20, Style=regular.svg": "fe75",
	"./shape-square/Size=20, Style=solid.svg": "ecd5",
	"./shape-square/Size=24, Style=regular.svg": "d98c",
	"./shape-square/Size=24, Style=solid.svg": "2ec6",
	"./shape-square/Size=32, Style=regular.svg": "4a42",
	"./shape-square/Size=64, Style=regular.svg": "f8c2",
	"./shape-triangle-up/Size=16, Style=light.svg": "ede6",
	"./shape-triangle-up/Size=16, Style=regular.svg": "1207",
	"./shape-triangle-up/Size=16, Style=solid.svg": "1d13",
	"./shape-triangle-up/Size=20, Style=light.svg": "6d75",
	"./shape-triangle-up/Size=20, Style=regular.svg": "70b1",
	"./shape-triangle-up/Size=20, Style=solid.svg": "ffff",
	"./shape-triangle-up/Size=24, Style=regular.svg": "b7f7",
	"./shape-triangle-up/Size=24, Style=solid.svg": "750a",
	"./shape-triangle-up/Size=32, Style=regular.svg": "4912",
	"./shape-triangle-up/Size=64, Style=regular.svg": "9311",
	"./share-network/Size=16, Style=light.svg": "f736",
	"./share-network/Size=16, Style=regular.svg": "013b",
	"./share-network/Size=16, Style=solid.svg": "c741",
	"./share-network/Size=20, Style=light.svg": "bbd3",
	"./share-network/Size=20, Style=regular.svg": "bcb1",
	"./share-network/Size=20, Style=solid.svg": "fa11",
	"./share-network/Size=24, Style=regular.svg": "3855",
	"./share-network/Size=24, Style=solid.svg": "67af",
	"./share-network/Size=32, Style=regular.svg": "6005",
	"./share-network/Size=64, Style=regular.svg": "9caf",
	"./stack-h-down/Size=16, Style=light.svg": "12bb",
	"./stack-h-down/Size=16, Style=regular.svg": "4ed2",
	"./stack-h-down/Size=16, Style=solid.svg": "8c60",
	"./stack-h-down/Size=20, Style=light.svg": "dbdf",
	"./stack-h-down/Size=20, Style=regular.svg": "b0c1",
	"./stack-h-down/Size=20, Style=solid.svg": "f7d2",
	"./stack-h-down/Size=24, Style=regular.svg": "5d81",
	"./stack-h-down/Size=24, Style=solid.svg": "3613",
	"./stack-h-down/Size=32, Style=regular.svg": "1f0d",
	"./stack-h-down/Size=64, Style=regular.svg": "9a13",
	"./star-half/Size=16, Style=light.svg": "505f",
	"./star-half/Size=16, Style=regular.svg": "b0e9",
	"./star-half/Size=16, Style=solid.svg": "bc09",
	"./star-half/Size=20, Style=light.svg": "1026",
	"./star-half/Size=20, Style=regular.svg": "4b26",
	"./star-half/Size=20, Style=solid.svg": "5eb3",
	"./star-half/Size=24, Style=regular.svg": "6f6a",
	"./star-half/Size=24, Style=solid.svg": "09f5",
	"./star-half/Size=32, Style=regular.svg": "1c2b",
	"./star-half/Size=64, Style=regular.svg": "144c8",
	"./star/Size=16, Style=light.svg": "807c",
	"./star/Size=16, Style=regular.svg": "5d34",
	"./star/Size=16, Style=solid.svg": "d2ad",
	"./star/Size=20, Style=light.svg": "1add",
	"./star/Size=20, Style=regular.svg": "ae00",
	"./star/Size=20, Style=solid.svg": "311e",
	"./star/Size=24, Style=regular.svg": "9be2",
	"./star/Size=24, Style=solid.svg": "c5bd",
	"./star/Size=32, Style=regular.svg": "f1da5",
	"./star/Size=64, Style=regular.svg": "147f",
	"./tag/Size=16, Style=light.svg": "4bc3",
	"./tag/Size=16, Style=regular.svg": "b0ef",
	"./tag/Size=16, Style=solid.svg": "c54c",
	"./tag/Size=20, Style=light.svg": "bcf5",
	"./tag/Size=20, Style=regular.svg": "8624",
	"./tag/Size=20, Style=solid.svg": "757d",
	"./tag/Size=24, Style=regular.svg": "e04e",
	"./tag/Size=24, Style=solid.svg": "5b69",
	"./tag/Size=32, Style=regular.svg": "339f",
	"./tag/Size=64, Style=regular.svg": "8c7e7",
	"./tech-cam-photo/Size=16, Style=light.svg": "9327",
	"./tech-cam-photo/Size=16, Style=regular.svg": "5525",
	"./tech-cam-photo/Size=16, Style=solid.svg": "2305",
	"./tech-cam-photo/Size=20, Style=light.svg": "6ce1",
	"./tech-cam-photo/Size=20, Style=regular.svg": "0c87",
	"./tech-cam-photo/Size=20, Style=solid.svg": "cb3e",
	"./tech-cam-photo/Size=24, Style=regular.svg": "4b67",
	"./tech-cam-photo/Size=24, Style=solid.svg": "8a61",
	"./tech-cam-photo/Size=32, Style=regular.svg": "9384a",
	"./tech-cam-photo/Size=64, Style=regular.svg": "3250",
	"./tech-pc-laptop/Size=16, Style=light.svg": "af7e",
	"./tech-pc-laptop/Size=16, Style=regular.svg": "47ce",
	"./tech-pc-laptop/Size=16, Style=solid.svg": "4624",
	"./tech-pc-laptop/Size=20, Style=light.svg": "53a5",
	"./tech-pc-laptop/Size=20, Style=regular.svg": "ffb3a",
	"./tech-pc-laptop/Size=20, Style=solid.svg": "1653",
	"./tech-pc-laptop/Size=24, Style=regular.svg": "028e",
	"./tech-pc-laptop/Size=24, Style=solid.svg": "2079",
	"./tech-pc-laptop/Size=32, Style=regular.svg": "4ef7",
	"./tech-pc-laptop/Size=64, Style=regular.svg": "09da",
	"./tech-phone-classic/Size=16, Style=light.svg": "d9ff",
	"./tech-phone-classic/Size=16, Style=regular.svg": "947f",
	"./tech-phone-classic/Size=16, Style=solid.svg": "d014",
	"./tech-phone-classic/Size=20, Style=light.svg": "67a1",
	"./tech-phone-classic/Size=20, Style=regular.svg": "ccd8",
	"./tech-phone-classic/Size=20, Style=solid.svg": "1c2e",
	"./tech-phone-classic/Size=24, Style=regular.svg": "0a45",
	"./tech-phone-classic/Size=24, Style=solid.svg": "2f0b",
	"./tech-phone-classic/Size=32, Style=regular.svg": "fc0d",
	"./tech-phone-classic/Size=64, Style=regular.svg": "69be",
	"./tech-phone-smart/Size=16, Style=light.svg": "7bb8",
	"./tech-phone-smart/Size=16, Style=regular.svg": "8193",
	"./tech-phone-smart/Size=16, Style=solid.svg": "e457",
	"./tech-phone-smart/Size=20, Style=light.svg": "e14f",
	"./tech-phone-smart/Size=20, Style=regular.svg": "a7b8",
	"./tech-phone-smart/Size=20, Style=solid.svg": "57d8",
	"./tech-phone-smart/Size=24, Style=regular.svg": "3015",
	"./tech-phone-smart/Size=24, Style=solid.svg": "6cba9",
	"./tech-phone-smart/Size=32, Style=regular.svg": "c797",
	"./tech-phone-smart/Size=64, Style=regular.svg": "6972",
	"./tech-printer/Size=16, Style=light.svg": "d078",
	"./tech-printer/Size=16, Style=regular.svg": "b276",
	"./tech-printer/Size=16, Style=solid.svg": "529d",
	"./tech-printer/Size=20, Style=light.svg": "1303",
	"./tech-printer/Size=20, Style=regular.svg": "2652",
	"./tech-printer/Size=20, Style=solid.svg": "9886",
	"./tech-printer/Size=24, Style=regular.svg": "5bc1",
	"./tech-printer/Size=24, Style=solid.svg": "909b",
	"./tech-printer/Size=32, Style=regular.svg": "b4d2",
	"./tech-printer/Size=64, Style=regular.svg": "553d",
	"./tech-screen-generic/Size=16, Style=light.svg": "2eb1",
	"./tech-screen-generic/Size=16, Style=regular.svg": "2b78",
	"./tech-screen-generic/Size=16, Style=solid.svg": "8406",
	"./tech-screen-generic/Size=20, Style=light.svg": "dc09",
	"./tech-screen-generic/Size=20, Style=regular.svg": "92e6",
	"./tech-screen-generic/Size=20, Style=solid.svg": "2b68",
	"./tech-screen-generic/Size=24, Style=regular.svg": "d26b",
	"./tech-screen-generic/Size=24, Style=solid.svg": "77549",
	"./tech-screen-generic/Size=32, Style=regular.svg": "fe7a",
	"./tech-screen-generic/Size=64, Style=regular.svg": "7c8a",
	"./tech-server/Size=16, Style=light.svg": "c5c7",
	"./tech-server/Size=16, Style=regular.svg": "628c",
	"./tech-server/Size=16, Style=solid.svg": "b873",
	"./tech-server/Size=20, Style=light.svg": "ab4e",
	"./tech-server/Size=20, Style=regular.svg": "91fa",
	"./tech-server/Size=20, Style=solid.svg": "c067",
	"./tech-server/Size=24, Style=regular.svg": "1690",
	"./tech-server/Size=24, Style=solid.svg": "9374",
	"./tech-server/Size=32, Style=regular.svg": "14a5",
	"./tech-server/Size=64, Style=regular.svg": "da0d",
	"./tech-storage-usb/Size=16, Style=light.svg": "ae02",
	"./tech-storage-usb/Size=16, Style=regular.svg": "9bbb",
	"./tech-storage-usb/Size=16, Style=solid.svg": "afab",
	"./tech-storage-usb/Size=20, Style=light.svg": "d694",
	"./tech-storage-usb/Size=20, Style=regular.svg": "cea3",
	"./tech-storage-usb/Size=20, Style=solid.svg": "c0674",
	"./tech-storage-usb/Size=24, Style=regular.svg": "8cd1",
	"./tech-storage-usb/Size=24, Style=solid.svg": "6088",
	"./tech-storage-usb/Size=32, Style=regular.svg": "6b27",
	"./tech-storage-usb/Size=64, Style=regular.svg": "de48",
	"./text-action-check/Size=16, Style=light.svg": "b1a5",
	"./text-action-check/Size=16, Style=regular.svg": "1620",
	"./text-action-check/Size=16, Style=solid.svg": "e69d",
	"./text-action-check/Size=20, Style=light.svg": "32dc",
	"./text-action-check/Size=20, Style=regular.svg": "b46f",
	"./text-action-check/Size=20, Style=solid.svg": "8850",
	"./text-action-check/Size=24, Style=regular.svg": "846b",
	"./text-action-check/Size=24, Style=solid.svg": "096c",
	"./text-action-check/Size=32, Style=regular.svg": "384e",
	"./text-action-check/Size=64, Style=regular.svg": "4e12",
	"./text-action-plus/Size=16, Style=light.svg": "3c76",
	"./text-action-plus/Size=16, Style=regular.svg": "2eecd",
	"./text-action-plus/Size=16, Style=solid.svg": "14a6",
	"./text-action-plus/Size=20, Style=light.svg": "ab1e",
	"./text-action-plus/Size=20, Style=regular.svg": "bffb",
	"./text-action-plus/Size=20, Style=solid.svg": "a923",
	"./text-action-plus/Size=24, Style=regular.svg": "efb9",
	"./text-action-plus/Size=24, Style=solid.svg": "bed6",
	"./text-action-plus/Size=32, Style=regular.svg": "d73d",
	"./text-action-plus/Size=64, Style=regular.svg": "affb",
	"./text-align-center-justify/Size=16, Style=light.svg": "b7e9",
	"./text-align-center-justify/Size=16, Style=regular.svg": "fbc5",
	"./text-align-center-justify/Size=16, Style=solid.svg": "ce8e",
	"./text-align-center-justify/Size=20, Style=light.svg": "76ab",
	"./text-align-center-justify/Size=20, Style=regular.svg": "1ba6",
	"./text-align-center-justify/Size=20, Style=solid.svg": "16169",
	"./text-align-center-justify/Size=24, Style=regular.svg": "78c8",
	"./text-align-center-justify/Size=24, Style=solid.svg": "005f",
	"./text-align-center-justify/Size=32, Style=regular.svg": "4802",
	"./text-align-center-justify/Size=64, Style=regular.svg": "5c52",
	"./text-align-center/Size=16, Style=light.svg": "0d82",
	"./text-align-center/Size=16, Style=regular.svg": "961d",
	"./text-align-center/Size=16, Style=solid.svg": "4658",
	"./text-align-center/Size=20, Style=light.svg": "fceb",
	"./text-align-center/Size=20, Style=regular.svg": "32a1",
	"./text-align-center/Size=20, Style=solid.svg": "2a0a",
	"./text-align-center/Size=24, Style=regular.svg": "64f4",
	"./text-align-center/Size=24, Style=solid.svg": "c182",
	"./text-align-center/Size=32, Style=regular.svg": "8962",
	"./text-align-center/Size=64, Style=regular.svg": "228f",
	"./text-align-left-justify/Size=16, Style=light.svg": "0ba1",
	"./text-align-left-justify/Size=16, Style=regular.svg": "d6c3",
	"./text-align-left-justify/Size=16, Style=solid.svg": "a678",
	"./text-align-left-justify/Size=20, Style=light.svg": "1e0f",
	"./text-align-left-justify/Size=20, Style=regular.svg": "2409",
	"./text-align-left-justify/Size=20, Style=solid.svg": "0b60",
	"./text-align-left-justify/Size=24, Style=regular.svg": "4b7e",
	"./text-align-left-justify/Size=24, Style=solid.svg": "ed3a",
	"./text-align-left-justify/Size=32, Style=regular.svg": "2206",
	"./text-align-left-justify/Size=64, Style=regular.svg": "f4ce",
	"./text-align-left/Size=16, Style=light.svg": "bbda",
	"./text-align-left/Size=16, Style=regular.svg": "6d21",
	"./text-align-left/Size=16, Style=solid.svg": "7b1c",
	"./text-align-left/Size=20, Style=light.svg": "1a83",
	"./text-align-left/Size=20, Style=regular.svg": "29c9b",
	"./text-align-left/Size=20, Style=solid.svg": "d236",
	"./text-align-left/Size=24, Style=regular.svg": "2e82",
	"./text-align-left/Size=24, Style=solid.svg": "490a",
	"./text-align-left/Size=32, Style=regular.svg": "44cb",
	"./text-align-left/Size=64, Style=regular.svg": "be7f",
	"./text-align-right-justify/Size=16, Style=light.svg": "bd47",
	"./text-align-right-justify/Size=16, Style=regular.svg": "3562",
	"./text-align-right-justify/Size=16, Style=solid.svg": "e413",
	"./text-align-right-justify/Size=20, Style=light.svg": "b22e",
	"./text-align-right-justify/Size=20, Style=regular.svg": "c2d1",
	"./text-align-right-justify/Size=20, Style=solid.svg": "b52e",
	"./text-align-right-justify/Size=24, Style=regular.svg": "2df7",
	"./text-align-right-justify/Size=24, Style=solid.svg": "a487",
	"./text-align-right-justify/Size=32, Style=regular.svg": "fb0c",
	"./text-align-right-justify/Size=64, Style=regular.svg": "4f2b",
	"./text-align-right/Size=16, Style=light.svg": "9195",
	"./text-align-right/Size=16, Style=regular.svg": "8e25",
	"./text-align-right/Size=16, Style=solid.svg": "18e1",
	"./text-align-right/Size=20, Style=light.svg": "3847",
	"./text-align-right/Size=20, Style=regular.svg": "e643",
	"./text-align-right/Size=20, Style=solid.svg": "9700",
	"./text-align-right/Size=24, Style=regular.svg": "bfd3",
	"./text-align-right/Size=24, Style=solid.svg": "aeb1",
	"./text-align-right/Size=32, Style=regular.svg": "54af",
	"./text-align-right/Size=64, Style=regular.svg": "de09",
	"./text-bullet-checklist/Size=16, Style=light.svg": "c181",
	"./text-bullet-checklist/Size=16, Style=regular.svg": "597f",
	"./text-bullet-checklist/Size=16, Style=solid.svg": "55d0",
	"./text-bullet-checklist/Size=20, Style=light.svg": "b7ed",
	"./text-bullet-checklist/Size=20, Style=regular.svg": "39d5",
	"./text-bullet-checklist/Size=20, Style=solid.svg": "23ed",
	"./text-bullet-checklist/Size=24, Style=regular.svg": "2a69",
	"./text-bullet-checklist/Size=24, Style=solid.svg": "00b2",
	"./text-bullet-checklist/Size=32, Style=regular.svg": "f8b4",
	"./text-bullet-checklist/Size=64, Style=regular.svg": "b631",
	"./text-bullet-group/Size=16, Style=light.svg": "8da0",
	"./text-bullet-group/Size=16, Style=regular.svg": "10f0",
	"./text-bullet-group/Size=16, Style=solid.svg": "f270a",
	"./text-bullet-group/Size=20, Style=light.svg": "ca4e",
	"./text-bullet-group/Size=20, Style=regular.svg": "ab46",
	"./text-bullet-group/Size=20, Style=solid.svg": "f1d6",
	"./text-bullet-group/Size=24, Style=regular.svg": "0596",
	"./text-bullet-group/Size=24, Style=solid.svg": "02e1",
	"./text-bullet-group/Size=32, Style=regular.svg": "7dec",
	"./text-bullet-group/Size=64, Style=regular.svg": "145b",
	"./text-bullet-numbers/Size=16, Style=light.svg": "ca5b",
	"./text-bullet-numbers/Size=16, Style=regular.svg": "5902",
	"./text-bullet-numbers/Size=16, Style=solid.svg": "80af",
	"./text-bullet-numbers/Size=20, Style=light.svg": "0ce9",
	"./text-bullet-numbers/Size=20, Style=regular.svg": "b207",
	"./text-bullet-numbers/Size=20, Style=solid.svg": "ab44",
	"./text-bullet-numbers/Size=24, Style=regular.svg": "3656",
	"./text-bullet-numbers/Size=24, Style=solid.svg": "d03d9",
	"./text-bullet-numbers/Size=32, Style=regular.svg": "79b1",
	"./text-bullet-numbers/Size=64, Style=regular.svg": "25fe",
	"./text-bullet/Size=16, Style=light.svg": "63a3",
	"./text-bullet/Size=16, Style=regular.svg": "0819",
	"./text-bullet/Size=16, Style=solid.svg": "d4b3",
	"./text-bullet/Size=20, Style=light.svg": "8baa",
	"./text-bullet/Size=20, Style=regular.svg": "b3c4",
	"./text-bullet/Size=20, Style=solid.svg": "28c6",
	"./text-bullet/Size=24, Style=regular.svg": "ccf65",
	"./text-bullet/Size=24, Style=solid.svg": "a2f0",
	"./text-bullet/Size=32, Style=regular.svg": "d5c8",
	"./text-bullet/Size=64, Style=regular.svg": "5c8f",
	"./time-clock-fast/Size=16, Style=light.svg": "5137",
	"./time-clock-fast/Size=16, Style=regular.svg": "8a4cc",
	"./time-clock-fast/Size=16, Style=solid.svg": "74ed",
	"./time-clock-fast/Size=20, Style=light.svg": "7fa6",
	"./time-clock-fast/Size=20, Style=regular.svg": "138c",
	"./time-clock-fast/Size=20, Style=solid.svg": "19ea",
	"./time-clock-fast/Size=24, Style=regular.svg": "544b",
	"./time-clock-fast/Size=24, Style=solid.svg": "aad3",
	"./time-clock-fast/Size=32, Style=regular.svg": "f691",
	"./time-clock-fast/Size=64, Style=regular.svg": "f837",
	"./time-clock-move-back/Size=16, Style=light.svg": "d150",
	"./time-clock-move-back/Size=16, Style=regular.svg": "c3c0",
	"./time-clock-move-back/Size=16, Style=solid.svg": "f806",
	"./time-clock-move-back/Size=20, Style=light.svg": "a3b1",
	"./time-clock-move-back/Size=20, Style=regular.svg": "ab04",
	"./time-clock-move-back/Size=20, Style=solid.svg": "5c6d",
	"./time-clock-move-back/Size=24, Style=regular.svg": "643b",
	"./time-clock-move-back/Size=24, Style=solid.svg": "2144",
	"./time-clock-move-back/Size=32, Style=regular.svg": "08b0",
	"./time-clock-move-back/Size=64, Style=regular.svg": "428fa",
	"./time-clock-move-forward/Size=16, Style=light.svg": "4d21",
	"./time-clock-move-forward/Size=16, Style=regular.svg": "48ff",
	"./time-clock-move-forward/Size=16, Style=solid.svg": "ad82",
	"./time-clock-move-forward/Size=20, Style=light.svg": "d086",
	"./time-clock-move-forward/Size=20, Style=regular.svg": "6718",
	"./time-clock-move-forward/Size=20, Style=solid.svg": "4fe6d",
	"./time-clock-move-forward/Size=24, Style=regular.svg": "d30a",
	"./time-clock-move-forward/Size=24, Style=solid.svg": "3018",
	"./time-clock-move-forward/Size=32, Style=regular.svg": "900d",
	"./time-clock-move-forward/Size=64, Style=regular.svg": "22e7",
	"./time-clock/Size=16, Style=light.svg": "609b",
	"./time-clock/Size=16, Style=regular.svg": "b542a",
	"./time-clock/Size=16, Style=solid.svg": "9f76",
	"./time-clock/Size=20, Style=light.svg": "3f69",
	"./time-clock/Size=20, Style=regular.svg": "ebe1",
	"./time-clock/Size=20, Style=solid.svg": "120d",
	"./time-clock/Size=24, Style=regular.svg": "7a62",
	"./time-clock/Size=24, Style=solid.svg": "2723",
	"./time-clock/Size=32, Style=regular.svg": "bf4e",
	"./time-clock/Size=64, Style=regular.svg": "188d",
	"./time-hourglass/Size=16, Style=light.svg": "0950",
	"./time-hourglass/Size=16, Style=regular.svg": "03cb",
	"./time-hourglass/Size=16, Style=solid.svg": "1ace",
	"./time-hourglass/Size=20, Style=light.svg": "566f",
	"./time-hourglass/Size=20, Style=regular.svg": "a1d9",
	"./time-hourglass/Size=20, Style=solid.svg": "b820",
	"./time-hourglass/Size=24, Style=regular.svg": "0078",
	"./time-hourglass/Size=24, Style=solid.svg": "1ad0",
	"./time-hourglass/Size=32, Style=regular.svg": "63a8",
	"./time-hourglass/Size=64, Style=regular.svg": "6b7d",
	"./tool-hard-hammers/Size=16, Style=light.svg": "9e00",
	"./tool-hard-hammers/Size=16, Style=regular.svg": "9f8a",
	"./tool-hard-hammers/Size=16, Style=solid.svg": "4281",
	"./tool-hard-hammers/Size=20, Style=light.svg": "6424",
	"./tool-hard-hammers/Size=20, Style=regular.svg": "1b1b",
	"./tool-hard-hammers/Size=20, Style=solid.svg": "6d44",
	"./tool-hard-hammers/Size=24, Style=regular.svg": "175a",
	"./tool-hard-hammers/Size=24, Style=solid.svg": "558a",
	"./tool-hard-hammers/Size=32, Style=regular.svg": "963c",
	"./tool-hard-hammers/Size=64, Style=regular.svg": "7c1a",
	"./tool-magic-wand/Size=16, Style=light.svg": "c742",
	"./tool-magic-wand/Size=16, Style=regular.svg": "187d",
	"./tool-magic-wand/Size=16, Style=solid.svg": "b437",
	"./tool-magic-wand/Size=20, Style=light.svg": "76c06",
	"./tool-magic-wand/Size=20, Style=regular.svg": "fd82",
	"./tool-magic-wand/Size=20, Style=solid.svg": "cc6e",
	"./tool-magic-wand/Size=24, Style=regular.svg": "3014",
	"./tool-magic-wand/Size=24, Style=solid.svg": "f085",
	"./tool-magic-wand/Size=32, Style=regular.svg": "4aef",
	"./tool-magic-wand/Size=64, Style=regular.svg": "f254",
	"./tool-pencil-line/Size=16, Style=light.svg": "51374",
	"./tool-pencil-line/Size=16, Style=regular.svg": "1e37",
	"./tool-pencil-line/Size=16, Style=solid.svg": "bc0a",
	"./tool-pencil-line/Size=20, Style=light.svg": "7b87",
	"./tool-pencil-line/Size=20, Style=regular.svg": "9904",
	"./tool-pencil-line/Size=20, Style=solid.svg": "e50e",
	"./tool-pencil-line/Size=24, Style=regular.svg": "3056",
	"./tool-pencil-line/Size=24, Style=solid.svg": "019d",
	"./tool-pencil-line/Size=32, Style=regular.svg": "faf1",
	"./tool-pencil-line/Size=64, Style=regular.svg": "3a2c",
	"./tool-pencil-square/Size=16, Style=light.svg": "a118",
	"./tool-pencil-square/Size=16, Style=regular.svg": "e2b5",
	"./tool-pencil-square/Size=16, Style=solid.svg": "c94e7",
	"./tool-pencil-square/Size=20, Style=light.svg": "de06",
	"./tool-pencil-square/Size=20, Style=regular.svg": "5fc0",
	"./tool-pencil-square/Size=20, Style=solid.svg": "7fa8",
	"./tool-pencil-square/Size=24, Style=regular.svg": "c6ce",
	"./tool-pencil-square/Size=24, Style=solid.svg": "22ae",
	"./tool-pencil-square/Size=32, Style=regular.svg": "e385",
	"./tool-pencil-square/Size=64, Style=regular.svg": "5c91f",
	"./tool-pencil/Size=16, Style=light.svg": "27ae",
	"./tool-pencil/Size=16, Style=regular.svg": "78f9",
	"./tool-pencil/Size=16, Style=solid.svg": "7907",
	"./tool-pencil/Size=20, Style=light.svg": "c457",
	"./tool-pencil/Size=20, Style=regular.svg": "6521",
	"./tool-pencil/Size=20, Style=solid.svg": "e8f3",
	"./tool-pencil/Size=24, Style=regular.svg": "fb3b",
	"./tool-pencil/Size=24, Style=solid.svg": "2b4d",
	"./tool-pencil/Size=32, Style=regular.svg": "f650",
	"./tool-pencil/Size=64, Style=regular.svg": "c57f",
	"./transport-auto-car-front/Size=16, Style=light.svg": "ecc8",
	"./transport-auto-car-front/Size=16, Style=regular.svg": "f3e8",
	"./transport-auto-car-front/Size=16, Style=solid.svg": "4380",
	"./transport-auto-car-front/Size=20, Style=light.svg": "f6a4",
	"./transport-auto-car-front/Size=20, Style=regular.svg": "dcb6",
	"./transport-auto-car-front/Size=20, Style=solid.svg": "d0f7",
	"./transport-auto-car-front/Size=24, Style=regular.svg": "e0ba",
	"./transport-auto-car-front/Size=24, Style=solid.svg": "ea34",
	"./transport-auto-car-front/Size=32, Style=regular.svg": "b085",
	"./transport-auto-car-front/Size=64, Style=regular.svg": "470f",
	"./trash-can/Size=16, Style=light.svg": "fe7f",
	"./trash-can/Size=16, Style=regular.svg": "17f9",
	"./trash-can/Size=16, Style=solid.svg": "b912",
	"./trash-can/Size=20, Style=light.svg": "e2e1",
	"./trash-can/Size=20, Style=regular.svg": "3696",
	"./trash-can/Size=20, Style=solid.svg": "a83c",
	"./trash-can/Size=24, Style=regular.svg": "5782",
	"./trash-can/Size=24, Style=solid.svg": "5c1f",
	"./trash-can/Size=32, Style=regular.svg": "1f11",
	"./trash-can/Size=64, Style=regular.svg": "3586",
	"./ui-filter-funnel/Size=16, Style=light.svg": "c5c0",
	"./ui-filter-funnel/Size=16, Style=regular.svg": "d0f2",
	"./ui-filter-funnel/Size=16, Style=solid.svg": "34a8",
	"./ui-filter-funnel/Size=20, Style=light.svg": "a9a7",
	"./ui-filter-funnel/Size=20, Style=regular.svg": "307fb",
	"./ui-filter-funnel/Size=20, Style=solid.svg": "f595",
	"./ui-filter-funnel/Size=24, Style=regular.svg": "117d",
	"./ui-filter-funnel/Size=24, Style=solid.svg": "6153",
	"./ui-filter-funnel/Size=32, Style=regular.svg": "733e",
	"./ui-filter-funnel/Size=64, Style=regular.svg": "d847",
	"./ui-filter-list/Size=16, Style=light.svg": "beee",
	"./ui-filter-list/Size=16, Style=regular.svg": "0daa",
	"./ui-filter-list/Size=16, Style=solid.svg": "c97a",
	"./ui-filter-list/Size=20, Style=light.svg": "aff2",
	"./ui-filter-list/Size=20, Style=regular.svg": "d52f",
	"./ui-filter-list/Size=20, Style=solid.svg": "1b2e",
	"./ui-filter-list/Size=24, Style=regular.svg": "260e",
	"./ui-filter-list/Size=24, Style=solid.svg": "4042",
	"./ui-filter-list/Size=32, Style=regular.svg": "d244",
	"./ui-filter-list/Size=64, Style=regular.svg": "8f6b",
	"./ui-filter-sort-a-default/Size=16, Style=light.svg": "1fa1",
	"./ui-filter-sort-a-default/Size=16, Style=regular.svg": "58c2",
	"./ui-filter-sort-a-default/Size=16, Style=solid.svg": "f491",
	"./ui-filter-sort-a-default/Size=20, Style=light.svg": "efcc",
	"./ui-filter-sort-a-default/Size=20, Style=regular.svg": "515e",
	"./ui-filter-sort-a-default/Size=20, Style=solid.svg": "d529",
	"./ui-filter-sort-a-default/Size=24, Style=regular.svg": "6ede",
	"./ui-filter-sort-a-default/Size=24, Style=solid.svg": "8a96",
	"./ui-filter-sort-a-default/Size=32, Style=regular.svg": "db12",
	"./ui-filter-sort-a-default/Size=64, Style=regular.svg": "83ae",
	"./ui-filter-sort-a-high-to-low/Size=16, Style=light.svg": "6fad",
	"./ui-filter-sort-a-high-to-low/Size=16, Style=regular.svg": "08f9",
	"./ui-filter-sort-a-high-to-low/Size=16, Style=solid.svg": "0807",
	"./ui-filter-sort-a-high-to-low/Size=20, Style=light.svg": "ca34",
	"./ui-filter-sort-a-high-to-low/Size=20, Style=regular.svg": "0c5e",
	"./ui-filter-sort-a-high-to-low/Size=20, Style=solid.svg": "7b09",
	"./ui-filter-sort-a-high-to-low/Size=24, Style=regular.svg": "bac1",
	"./ui-filter-sort-a-high-to-low/Size=24, Style=solid.svg": "39a2",
	"./ui-filter-sort-a-high-to-low/Size=32, Style=regular.svg": "9a92",
	"./ui-filter-sort-a-high-to-low/Size=64, Style=regular.svg": "b535",
	"./ui-filter-sort-a-low-to-high/Size=16, Style=light.svg": "89c0",
	"./ui-filter-sort-a-low-to-high/Size=16, Style=regular.svg": "254c",
	"./ui-filter-sort-a-low-to-high/Size=16, Style=solid.svg": "7404",
	"./ui-filter-sort-a-low-to-high/Size=20, Style=light.svg": "27ae1",
	"./ui-filter-sort-a-low-to-high/Size=20, Style=regular.svg": "39e4",
	"./ui-filter-sort-a-low-to-high/Size=20, Style=solid.svg": "0c9c",
	"./ui-filter-sort-a-low-to-high/Size=24, Style=regular.svg": "84cb",
	"./ui-filter-sort-a-low-to-high/Size=24, Style=solid.svg": "c73a",
	"./ui-filter-sort-a-low-to-high/Size=32, Style=regular.svg": "5c9b",
	"./ui-filter-sort-a-low-to-high/Size=64, Style=regular.svg": "0f67",
	"./ui-load-spinner/Size=16, Style=light.svg": "6267b",
	"./ui-load-spinner/Size=16, Style=regular.svg": "2340",
	"./ui-load-spinner/Size=16, Style=solid.svg": "b419",
	"./ui-load-spinner/Size=20, Style=light.svg": "a005",
	"./ui-load-spinner/Size=20, Style=regular.svg": "00ad",
	"./ui-load-spinner/Size=20, Style=solid.svg": "dcee",
	"./ui-load-spinner/Size=24, Style=regular.svg": "7d76",
	"./ui-load-spinner/Size=24, Style=solid.svg": "890e",
	"./ui-load-spinner/Size=32, Style=regular.svg": "b7fb",
	"./ui-load-spinner/Size=64, Style=regular.svg": "8b60",
	"./ui-menu-bars-three-h/Size=16, Style=light.svg": "5365",
	"./ui-menu-bars-three-h/Size=16, Style=regular.svg": "3b5c",
	"./ui-menu-bars-three-h/Size=16, Style=solid.svg": "902b",
	"./ui-menu-bars-three-h/Size=20, Style=light.svg": "624f",
	"./ui-menu-bars-three-h/Size=20, Style=regular.svg": "bad9",
	"./ui-menu-bars-three-h/Size=20, Style=solid.svg": "d3b0",
	"./ui-menu-bars-three-h/Size=24, Style=regular.svg": "282c",
	"./ui-menu-bars-three-h/Size=24, Style=solid.svg": "8f01",
	"./ui-menu-bars-three-h/Size=32, Style=regular.svg": "e72a",
	"./ui-menu-bars-three-h/Size=64, Style=regular.svg": "422c",
	"./ui-menu-dots-eight-v/Size=16, Style=light.svg": "3665",
	"./ui-menu-dots-eight-v/Size=16, Style=regular.svg": "e4bb",
	"./ui-menu-dots-eight-v/Size=16, Style=solid.svg": "9fea",
	"./ui-menu-dots-eight-v/Size=20, Style=light.svg": "e52c",
	"./ui-menu-dots-eight-v/Size=20, Style=regular.svg": "a81c3",
	"./ui-menu-dots-eight-v/Size=20, Style=solid.svg": "45ab",
	"./ui-menu-dots-eight-v/Size=24, Style=regular.svg": "bc97",
	"./ui-menu-dots-eight-v/Size=24, Style=solid.svg": "2185",
	"./ui-menu-dots-eight-v/Size=32, Style=regular.svg": "b617",
	"./ui-menu-dots-eight-v/Size=64, Style=regular.svg": "ee14",
	"./ui-menu-dots-three-h-circle/Size=16, Style=light.svg": "b6e2",
	"./ui-menu-dots-three-h-circle/Size=16, Style=regular.svg": "8a28",
	"./ui-menu-dots-three-h-circle/Size=16, Style=solid.svg": "96fa",
	"./ui-menu-dots-three-h-circle/Size=20, Style=light.svg": "9f04",
	"./ui-menu-dots-three-h-circle/Size=20, Style=regular.svg": "4a20",
	"./ui-menu-dots-three-h-circle/Size=20, Style=solid.svg": "2c8c",
	"./ui-menu-dots-three-h-circle/Size=24, Style=regular.svg": "e382",
	"./ui-menu-dots-three-h-circle/Size=24, Style=solid.svg": "a621",
	"./ui-menu-dots-three-h-circle/Size=32, Style=regular.svg": "b081",
	"./ui-menu-dots-three-h-circle/Size=64, Style=regular.svg": "7cc5",
	"./ui-menu-dots-three-h/Size=16, Style=light.svg": "93dc",
	"./ui-menu-dots-three-h/Size=16, Style=regular.svg": "9c1e",
	"./ui-menu-dots-three-h/Size=16, Style=solid.svg": "ee69",
	"./ui-menu-dots-three-h/Size=20, Style=light.svg": "0c43",
	"./ui-menu-dots-three-h/Size=20, Style=regular.svg": "df18",
	"./ui-menu-dots-three-h/Size=20, Style=solid.svg": "209d",
	"./ui-menu-dots-three-h/Size=24, Style=regular.svg": "0e4c",
	"./ui-menu-dots-three-h/Size=24, Style=solid.svg": "19ec7",
	"./ui-menu-dots-three-h/Size=32, Style=regular.svg": "ec7f",
	"./ui-menu-dots-three-h/Size=64, Style=regular.svg": "6b02",
	"./ui-menu-dots-three-v/Size=16, Style=light.svg": "9cad",
	"./ui-menu-dots-three-v/Size=16, Style=regular.svg": "3020",
	"./ui-menu-dots-three-v/Size=16, Style=solid.svg": "6d16",
	"./ui-menu-dots-three-v/Size=20, Style=light.svg": "9b3a",
	"./ui-menu-dots-three-v/Size=20, Style=regular.svg": "1039",
	"./ui-menu-dots-three-v/Size=20, Style=solid.svg": "b5e6",
	"./ui-menu-dots-three-v/Size=24, Style=regular.svg": "42a5",
	"./ui-menu-dots-three-v/Size=24, Style=solid.svg": "8616",
	"./ui-menu-dots-three-v/Size=32, Style=regular.svg": "c78f",
	"./ui-menu-dots-three-v/Size=64, Style=regular.svg": "12f2",
	"./ui-window-new-down-right/Size=16, Style=light.svg": "ce8f",
	"./ui-window-new-down-right/Size=16, Style=regular.svg": "7d7c",
	"./ui-window-new-down-right/Size=16, Style=solid.svg": "7f27",
	"./ui-window-new-down-right/Size=20, Style=light.svg": "18e4",
	"./ui-window-new-down-right/Size=20, Style=regular.svg": "9e834",
	"./ui-window-new-down-right/Size=20, Style=solid.svg": "53b6",
	"./ui-window-new-down-right/Size=24, Style=regular.svg": "76e2",
	"./ui-window-new-down-right/Size=24, Style=solid.svg": "6b8e",
	"./ui-window-new-down-right/Size=32, Style=regular.svg": "28d5",
	"./ui-window-new-down-right/Size=64, Style=regular.svg": "ab93",
	"./ui-window-new-up-right/Size=16, Style=light.svg": "5c41",
	"./ui-window-new-up-right/Size=16, Style=regular.svg": "75da",
	"./ui-window-new-up-right/Size=16, Style=solid.svg": "9b06",
	"./ui-window-new-up-right/Size=20, Style=light.svg": "297a",
	"./ui-window-new-up-right/Size=20, Style=regular.svg": "e35d",
	"./ui-window-new-up-right/Size=20, Style=solid.svg": "6b7dc",
	"./ui-window-new-up-right/Size=24, Style=regular.svg": "fe52",
	"./ui-window-new-up-right/Size=24, Style=solid.svg": "4fac",
	"./ui-window-new-up-right/Size=32, Style=regular.svg": "716c",
	"./ui-window-new-up-right/Size=64, Style=regular.svg": "e5e3",
	"./warning-circle/Size=16, Style=light.svg": "db53",
	"./warning-circle/Size=16, Style=regular.svg": "0df5",
	"./warning-circle/Size=16, Style=solid.svg": "0685",
	"./warning-circle/Size=20, Style=light.svg": "1ca2",
	"./warning-circle/Size=20, Style=regular.svg": "f18b",
	"./warning-circle/Size=20, Style=solid.svg": "1589",
	"./warning-circle/Size=24, Style=regular.svg": "8249",
	"./warning-circle/Size=24, Style=solid.svg": "4606",
	"./warning-circle/Size=32, Style=regular.svg": "4804",
	"./warning-circle/Size=64, Style=regular.svg": "f7c2",
	"./warning-triangle/Size=16, Style=light.svg": "d7cd",
	"./warning-triangle/Size=16, Style=regular.svg": "b003",
	"./warning-triangle/Size=16, Style=solid.svg": "d31f",
	"./warning-triangle/Size=20, Style=light.svg": "5214",
	"./warning-triangle/Size=20, Style=regular.svg": "d0a4",
	"./warning-triangle/Size=20, Style=solid.svg": "a201",
	"./warning-triangle/Size=24, Style=regular.svg": "c1b1",
	"./warning-triangle/Size=24, Style=solid.svg": "cdd4b",
	"./warning-triangle/Size=32, Style=regular.svg": "eacf",
	"./warning-triangle/Size=64, Style=regular.svg": "0b97",
	"./x-circle/Size=16, Style=light.svg": "c4f3",
	"./x-circle/Size=16, Style=regular.svg": "4e09",
	"./x-circle/Size=16, Style=solid.svg": "a70c",
	"./x-circle/Size=20, Style=light.svg": "64244",
	"./x-circle/Size=20, Style=regular.svg": "43d3",
	"./x-circle/Size=20, Style=solid.svg": "d277",
	"./x-circle/Size=24, Style=regular.svg": "ee2e",
	"./x-circle/Size=24, Style=solid.svg": "550d",
	"./x-circle/Size=32, Style=regular.svg": "fe90",
	"./x-circle/Size=64, Style=regular.svg": "94506",
	"./x-square/Size=16, Style=light.svg": "b31a",
	"./x-square/Size=16, Style=regular.svg": "e058",
	"./x-square/Size=16, Style=solid.svg": "c91e",
	"./x-square/Size=20, Style=light.svg": "91dd",
	"./x-square/Size=20, Style=regular.svg": "a904",
	"./x-square/Size=20, Style=solid.svg": "e3bf",
	"./x-square/Size=24, Style=regular.svg": "6246",
	"./x-square/Size=24, Style=solid.svg": "c5df",
	"./x-square/Size=32, Style=regular.svg": "3ddd",
	"./x-square/Size=64, Style=regular.svg": "4499",
	"./x/Size=16, Style=light.svg": "61de",
	"./x/Size=16, Style=regular.svg": "253b",
	"./x/Size=16, Style=solid.svg": "9d90",
	"./x/Size=20, Style=light.svg": "bd1f",
	"./x/Size=20, Style=regular.svg": "2261",
	"./x/Size=20, Style=solid.svg": "5b58",
	"./x/Size=24, Style=regular.svg": "00d3",
	"./x/Size=24, Style=solid.svg": "3f46",
	"./x/Size=32, Style=regular.svg": "a8b7",
	"./x/Size=64, Style=regular.svg": "bd79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d239";